/**
 * GENERATED FILE — Polish stem lexicon. DO NOT EDIT BY HAND.
 *
 * Emitted by data-pipeline/run-polish.ts from UniMorph pol
 * (https://github.com/unimorph/pol). Data licence: CC BY-SA — see
 * LICENSE-DATA.md.
 *
 * Each line is a lemma and the choices its paradigm makes, one letter per
 * choice:
 *
 *   c  declension class (m masculine, f -a feminine, n neuter, k
 *      consonant-final feminine) when the ending does not give it away
 *   s  the oblique stem, when the rules cannot derive it
 *   g  genitive singular ending      d  dative singular ending
 *   l  locative singular ending      n  nominative plural ending
 *   p  genitive plural ending
 *   A  animate: the accusative singular copies the genitive
 *   P  personal: the accusative plural copies the genitive too
 *   *case.number=form  a cell nothing shorter explains
 */
import type { RuClass, RuStemFlags } from "./declension.js";

const STEM_DATA = `аангич|A
аароновец|A
абаас|A
абаданец|A
абаданка|A
абазин|A
абазинка|A
абакумыч|A
абалон|A
абарга|p,A
аббас|A
аббат|A
аббатиса|A
аббатство|cm,sаббатств,nа,p
абгалдырь|cm
абдерит|A
абдуктант|A
абевегедейка|p
абилка|p
абиссинец|A
абитуриент|A
аболиционист|A
аболиционистка|A
абонент|A
абориген|A
аборигенка|A
абракадабра|p
абрек|A
абсолютист|A
абстенционист|A
абстинент|A
абстракционист|A
абсурдист|A
абсцисса|p
абхаз|A
авантюрист|A
авантюристка|A
аварец|A
аварка|A
авгур|A
авиагруппа|p
авиадвигатель|cm
авиазвено|cm,sавиазвень,nя,S,*genitive.sg=авиазвена,*dative.sg=авиазвену,*instrumental.sg=авиазвеном,*prepositional.sg=авиазвене
авиакорпус|nа
авиатор|A
авиаэскадрилья|*genitive.pl=авиаэскадрилий
авось|cm
авоська|*genitive.pl=авосек
австрал|A
австралиец|A
австралийка|A,*genitive.pl=австралиек,*accusative.pl=австралиек
австриец|A
австрийка|A,*genitive.pl=австриек,*accusative.pl=австриек
автовладелец|A
автогонки|*genitive.sg=автогонок,*dative.sg=автогонкам,*instrumental.sg=автогонками,*prepositional.sg=автогонках
автодидакт|A
автокольцо|cm,sавтокольц,nа,*genitive.pl=автоколец,*instrumental.sg=автокольцом
автократ|A
автолюбитель|cm,A
автоматчик|A
автомобилист|A
автомобиль|cm
автор|A
авторские|cm,*genitive.sg=авторских,*dative.sg=авторским,*instrumental.sg=авторскими,*prepositional.sg=авторских
авторство|cm,sавторств,nа,p
автохтон|A
агарянин|sагарян,nе,p,A,*genitive.sg=агарянина,*dative.sg=агарянину,*accusative.sg=агарянина,*instrumental.sg=агарянином,*prepositional.sg=агарянине
агванец|A
агванка|A
агванский|*genitive.sg=агванского,*dative.sg=агванскому,*instrumental.sg=агванским,*prepositional.sg=агванском
аггел|A
агент|A
агентство|cm,sагентств,nа,p
агитатор|A
агнец|A
агностик|A
аграрий|A
агрессор|A
агробиолог|A
агроном|A
агротехник|A
агрохимик|A
агул|A
агулы|A,*genitive.sg=агулов,*dative.sg=агулам,*accusative.sg=агулов,*instrumental.sg=агулами,*prepositional.sg=агулах
адвентист|A
адвентистка|A
адвокат|A
адепт|A
администратор|A
адмирал|A
адмиралтейство|cm,sадмиралтейств,nа,p
адрес|nа
адресант|A
адресат|A
адъютант|A
ажан|A
азер|A
азербайджанец|A
азербайджанка|A
азиат|A
азиатка|A
азик|A
азы|*genitive.sg=азов,*dative.sg=азам,*instrumental.sg=азами,*prepositional.sg=азах
аид|A
аид|A
аист|A
аистёнок|sаистят,nа,p,A,*genitive.sg=аистёнка,*dative.sg=аистёнку,*accusative.sg=аистёнка,*instrumental.sg=аистёнком,*prepositional.sg=аистёнке
ай-ай|A
айва|p
айсорский|*genitive.sg=айсорского,*dative.sg=айсорскому,*instrumental.sg=айсорским,*prepositional.sg=айсорском
академик|A
аканский|*genitive.sg=аканского,*dative.sg=аканскому,*instrumental.sg=аканским,*prepositional.sg=аканском
аканье|cm,sакань,nя,S,*genitive.pl=аканий
аккордеонист|A
аккордеонистка|A
акробат|A
акробатка|A
аксолотль|cm,A
актёр|A
активист|A
актуарий|A
акушер|A
акушер-гинеколог|sакушерам-гинеколог,A,*nominative.pl=акушеры-гинекологи,*genitive.sg=акушера-гинеколога,*genitive.pl=акушеров-гинекологов,*dative.sg=акушеру-гинекологу,*accusative.sg=акушера-гинеколога,*accusative.pl=акушеров-гинекологов,*instrumental.sg=акушером-гинекологом,*instrumental.pl=акушерами-гинекологами,*prepositional.sg=акушере-гинекологе,*prepositional.pl=акушерах-гинекологах
акушерка|A
акцептант|A
акционер|A
аламанн|A
алан|A
алармист|A
алармистка|A
албан|A
албанец|A
албанка|A
албанский|*nominative.sg=албанского,*genitive.sg=албанскому,*instrumental.sg=албанским,*prepositional.sg=албанском
алгебра|p
алгонкин|A
алебарда|p
алеманн|A
алеут|A
алеутка|A
алжирец|A
алжирка|A
алия|dе,iёй
алкаш|A,*instrumental.sg=алкашом
алкашня|iёй,pей
алкоголик|A
алкоголь|cm
алконавт|A
аллах|A
аллея|pй
аллигатор|A
алтарь|cm,iём
алфавит|*genitive.sg=алфавит,*genitive.pl=алфавиты,*dative.sg=алфавита,*dative.pl=алфавитов
алхимик|A
алыча|pей,*instrumental.sg=алычой
альбатрос|A
альбинос|A
альбиноска|A
альпинист|A
альтруист|A
альтруистка|A
альфа|p
альфа-лучи|*genitive.sg=альфа-лучей,*dative.sg=альфа-лучам,*instrumental.sg=альфа-лучами,*prepositional.sg=альфа-лучах
альфа-самец|A,*genitive.pl=альфа-самцов,*accusative.pl=альфа-самцов,*instrumental.sg=альфа-самцом
аманат|A
амбиграмма|p
амбра|p
амёба|A
аменорея|pй
американец|A
ампер|p
ампер-виток|sампер-витк
амстердамец|A
амуры|*genitive.sg=амуров,*dative.sg=амурам,*instrumental.sg=амурами,*prepositional.sg=амурах
амфипростиль|cm
амхарский|*genitive.sg=амхарского,*dative.sg=амхарскому,*instrumental.sg=амхарским,*prepositional.sg=амхарском
анаграмма|p
анаконда|p,A
аналемма|p
аналитик|A
анатом|A
анахорет|A
ангел|A
ангел-хранитель|cm,sангелам-хранител,A,*nominative.pl=ангелы-хранители,*genitive.sg=ангела-хранителя,*genitive.pl=ангелов-хранителей,*dative.sg=ангелу-хранителю,*accusative.sg=ангела-хранителя,*accusative.pl=ангелов-хранителей,*instrumental.sg=ангелом-хранителем,*instrumental.pl=ангелами-хранителями,*prepositional.sg=ангеле-хранителе,*prepositional.pl=ангелах-хранителях
англ|A
англичанин|A,*nominative.pl=англичане,*genitive.pl=англичан,*dative.pl=англичанам,*instrumental.pl=англичанами,*prepositional.pl=англичанах
англо-норманка|A
англо-норманн|A
англосакс|A
англофил|A
англофоб|A
анголец|A
анголка|A
андроид|A
аневризма|p
анестезиолог|A
аниец|A
аниматор|A
анналы|*genitive.sg=анналов,*dative.sg=анналам,*instrumental.sg=анналами,*prepositional.sg=анналах
аноним|A
анофелес|A
ансамбль|cm
антагонист|A
антенна|p
антивещество|cm,sантивеществ,nа,p
антигерой|A
антиквар|A
антилопа|A
антилопа-гну|A,*nominative.pl=антилопы-гну,*genitive.sg=антилопы-гну,*genitive.pl=антилоп-гну,*dative.sg=антилопе-гну,*dative.pl=антилопам-гну,*accusative.sg=антилопу-гну,*accusative.pl=антилоп-гну,*instrumental.sg=антилопой-гну,*instrumental.pl=антилопами-гну,*prepositional.sg=антилопе-гну,*prepositional.pl=антилопах-гну
антиномист|A
антиномистка|A
антиохиец|A
антиохийка|A,*genitive.pl=антиохиек,*accusative.pl=антиохиек
антипод|A
антисемит|A
антисемитка|A
антифашист|A
антифашистка|A
антихрист|A
антрополог|A
анчоус|A
анчутка|A
аорта|p
апатрид|A
апач|A
апачка|A
апликант|A
апликантка|A
аплодисменты|*genitive.sg=аплодисментов,*dative.sg=аплодисментам,*instrumental.sg=аплодисментами,*prepositional.sg=аплодисментах
аполлон|A
апологет|A
апостиль|cm
апостол|A
аппаратчик|A
аппаратчица|A
аппликант|A
аппликантка|A
аппойнтмент|A
апрель|cm
апсель|cm
аптекарь|cm,A
араб|A
аравитянин|sаравитян,nе,p,A,*genitive.sg=аравитянина,*dative.sg=аравитянину,*accusative.sg=аравитянина,*instrumental.sg=аравитянином,*prepositional.sg=аравитянине
арамеец|A
арамей|A
арамейка|A,*genitive.pl=арамеек,*accusative.pl=арамеек
арап|A
арба|p
арбитр|A
аргентинец|A
аргентинка|A
аргонавт|A
аренда|p
арендатор|A
арестант|A
арестантка|A
арианин|sариан,nе,p,A,*genitive.sg=арианина,*dative.sg=арианину,*accusative.sg=арианина,*instrumental.sg=арианином,*prepositional.sg=арианине
ариец|A
арийка|A,*genitive.pl=ариек,*accusative.pl=ариек
аристарх|A
аристократ|A
аристократка|A
арменист|A
арменовед|A
армянин|A,*nominative.pl=армяне,*genitive.pl=армян,*dative.pl=армянам,*instrumental.pl=армянами,*prepositional.pl=армянах
армянофил|A
армянофоб|A
аромун|A
аромунка|A
аромунский|*genitive.sg=аромунского,*dative.sg=аромунскому,*instrumental.sg=аромунским,*prepositional.sg=аромунском
арт-дилер|A
артикль|cm
артиллерист|A
артист|A
артистка|A
арумын|A
арумынка|A
арумынский|*genitive.sg=арумынского,*dative.sg=арумынскому,*instrumental.sg=арумынским,*prepositional.sg=арумынском
арфа|p
архангел|A
архат|A
археолог|A
археоптерикс|A
архивариус|A
архиепископ|A
архиепископство|cm,sархиепископств,nа,p
архиерей|A
архимандрит|A
архитектор|A
архонт|A
арчинский|*genitive.sg=арчинского,*dative.sg=арчинскому,*instrumental.sg=арчинским,*prepositional.sg=арчинском
ас|A
аскет|A
аспирант|A
аспирантка|A
ассамблея|pй
ассириец|A
ассирийка|A,*genitive.pl=ассириек,*accusative.pl=ассириек
ассирийский|*genitive.sg=ассирийского,*dative.sg=ассирийскому,*instrumental.sg=ассирийским,*prepositional.sg=ассирийском
ассириянин|sассириян,nе,p,A,*genitive.sg=ассириянина,*dative.sg=ассириянину,*accusative.sg=ассириянина,*instrumental.sg=ассириянином,*prepositional.sg=ассириянине
ассистент|A
ассистентка|A
астма|p
астра|p
астролог|A
астронавт|A
астроном|A
асура|A
атакующий|A,*genitive.sg=атакующего,*dative.sg=атакующему,*accusative.sg=атакующего,*instrumental.sg=атакующим,*prepositional.sg=атакующем
атаман|A
атаяльский|*genitive.sg=атаяльского,*dative.sg=атаяльскому,*instrumental.sg=атаяльским,*prepositional.sg=атаяльском
атеист|A
атеистка|A
атлет|A
атлетка|A
аудиолог|A
аудитор|A
аутист|A
аутсайдер|A
афалина|A
афган|A
афганец|A
афганка|A
афганский|*nominative.sg=афганского,*genitive.sg=афганскому,*instrumental.sg=афганским,*prepositional.sg=афганском
аферист|A
афинянин|A,*nominative.pl=афиняне,*genitive.pl=афинян,*dative.pl=афинянам,*instrumental.pl=афинянами,*prepositional.pl=афинянах
афинянка|A
африкандер|A
африканер|A
африканец|A
африканист|A
африканистка|A
африканка|A
афро-американец|A
афро-американка|A
афроамериканец|A
афроамериканка|A
афта|p
ахеменид|A
ахинея|pй
ацтек|A
ашуг|A
аэрограмма|p
аэрозоль|cm
аятолла|p,A
бабёнка|A
бабник|A
бабуин|A
бабулька|A,*genitive.pl=бабулек,*accusative.pl=бабулек
бабуля|A,*genitive.pl=бабуль,*accusative.pl=бабуль
бабуся|A,*genitive.pl=бабусь,*accusative.pl=бабусь
бабушка|gа,dи,lе,*genitive.pl=бабушки,*dative.pl=бабушек
багаж|*instrumental.sg=багажом
багатур|A
багор|sбагр
бадья|iёй,*genitive.pl=бадей
бакалавр|A
бакалея|pй
бакенбарда|p
бакенбарды|*genitive.sg=бакенбард,*dative.sg=бакенбардам,*instrumental.sg=бакенбардами,*prepositional.sg=бакенбардах
бакинец|A
баклан|A
бакланка|A
бактериолог|A
бактриан|A
балаболка|A
балалайка|*genitive.pl=балалаек
баланда|p
балбес|A
балерина|A
балиториевые|cm,A,*genitive.sg=балиториевых,*dative.sg=балиториевым,*accusative.sg=балиториевых,*instrumental.sg=балиториевыми,*prepositional.sg=балиториевых
баловник|A
банда|p
бандеровец|A
банджоист|A
бандикут|A
бандит|A
банкир|A
банкрот|A
банкротство|cm,sбанкротств,nа,p
банщица|A
банька|*genitive.pl=банек
баран|A
барвинок|sбарвинк
бард|A
баржа|p
барин|sбар,nе,p,A,*genitive.sg=барина,*dative.sg=барину,*accusative.sg=барина,*instrumental.sg=барином,*prepositional.sg=барине
бармен|A
барон|A
баронесса|p,A
баррель|cm
барс|A
барсук|A
барсучонок|sбарсучат,nа,p,A,*genitive.sg=барсучонка,*dative.sg=барсучонку,*accusative.sg=барсучонка,*instrumental.sg=барсучонком,*prepositional.sg=барсучонке
барыня|A,*genitive.pl=барынь,*accusative.pl=барынь
барышня|A,*genitive.pl=барышень,*accusative.pl=барышень
баск|A
басконка|A
баскский|*genitive.sg=баскского,*dative.sg=баскскому,*instrumental.sg=баскским,*prepositional.sg=баскском
басмач|A,*instrumental.sg=басмачом
басмачество|cm,sбасмачеств,nа,p
баснописец|A
басоля|*genitive.pl=басоль
бастард|A
басурманин|sбасурман,nе,p,A,*genitive.sg=басурманина,*dative.sg=басурманину,*accusative.sg=басурманина,*instrumental.sg=басурманином,*prepositional.sg=басурманине
батарейка|*genitive.pl=батареек
батарея|pй
батенька|A,*genitive.pl=батенек,*accusative.pl=батенек
батрак|A
батрачонок|sбатрачат,nа,p,A,*genitive.sg=батрачонка,*dative.sg=батрачонку,*accusative.sg=батрачонка,*instrumental.sg=батрачонком,*prepositional.sg=батрачонке
батька|A,*genitive.pl=батек,*accusative.pl=батек
бахвальство|cm,sбахвальств,nа,p
бахча|pей,*instrumental.sg=бахчой
бациллоноситель|cm,sбацллоносител,A,*nominative.sg=бацллоноситель
бачок|sбачк
башка|*genitive.pl=башок
башкир|p,A
башкирский|*genitive.sg=башкирского,*dative.sg=башкирскому,*instrumental.sg=башкирским,*prepositional.sg=башкирском
башли|*genitive.sg=башлей,*dative.sg=башлям,*instrumental.sg=башлями,*prepositional.sg=башлях
башмачник|A
баянист|A
баянистка|A
бег|nа
бегемот|A
беглец|sбеглец,A,*genitive.pl=беглецов,*accusative.pl=беглецов,*instrumental.sg=беглецом
беготня|iёй,pей
бегство|cm,sбегств,nа,p
бегун|A
бедняга|A
бедняжка|A
бедняк|A
бедолага|A
бедро|cm,sбёдр,nа,*genitive.sg=бедра,*genitive.pl=бёдер,*dative.sg=бедру,*instrumental.sg=бедром,*prepositional.sg=бедре
бёдрышко|nы
бедуин|A
беженец|A
беженка|A
безбожник|A
безбожница|A
безводье|cm,sбезводь,nя,S,*genitive.pl=безводий
бездарь|A
безделье|cm,sбездель,nя,S,*genitive.pl=безделий
бездельник|A
безденежье|cm,sбезденежь,nя,S,*genitive.pl=безденежий
бездна|p
беззубка|A
безобразник|A
безобразница|A
безрукавка|p
безумец|A
бек|A
бекас|A
бекасёнок|sбекасят,nа,p,A,*genitive.sg=бекасёнка,*dative.sg=бекасёнку,*accusative.sg=бекасёнка,*instrumental.sg=бекасёнком,*prepositional.sg=бекасёнке
белильня|*genitive.pl=белилен
белладонна|p
белогвардеец|A
белорус|A
белоруска|A
белорусский|*nominative.sg=белорусского,*genitive.sg=белорусскому,*instrumental.sg=белорусским,*prepositional.sg=белорусском
белоручка|A
белошвейка|A,*genitive.pl=белошвеек,*accusative.pl=белошвеек
белуга|A
белуха|A
бельгиец|A
бельгийка|A,*genitive.pl=бельгиек,*accusative.pl=бельгиек
бельчонок|sбельчат,nа,p,A,*genitive.sg=бельчонка,*dative.sg=бельчонку,*accusative.sg=бельчонка,*instrumental.sg=бельчонком,*prepositional.sg=бельчонке
беляк|A
бемоль|cm
бенгальский|*genitive.sg=бенгальского,*dative.sg=бенгальскому,*instrumental.sg=бенгальским,*prepositional.sg=бенгальском
бербер|A
бёрдо|cm,sбёрд,nа,p
бердыш|*instrumental.sg=бердышом
бережок|sбережк
беремя|cm,sберемен,gи,dи,iем,lи,nа
беркут|A
бесёнок|sбесенят,nа,p,A,*genitive.sg=бесёнка,*dative.sg=бесёнку,*accusative.sg=бесёнка,*instrumental.sg=бесёнком,*prepositional.sg=бесёнке
беспамятство|cm,sбеспамятств,nа,p
беспокойство|cm,sбеспокойств,nа,p
беспорядок|sбеспорядк
беспризорник|A
бешенство|cm,sбешенств,nа,p
библиотекарша|p,A
библиотекарь|cm,A
библиофил|A
бивень|cm,sбивн
бизнесмен|A
бизон|A
бинокль|cm
биограф|A
биолог|A
биржа|p
бирманец|A
бирманка|A
бирюк|A
бисексуал|A
битва|p
битник|A
биток|sбитк
битьё|cm,sбить,iём,nя,S,*genitive.pl=битей
благодетель|cm,A
благородство|cm,sблагородств,nа,p
благостыня|*genitive.pl=благостынь
благоустройство|cm,sблагоустройств,nа,p
блаженство|cm,sблаженств,nа,p
блатной|A,*genitive.sg=блатного,*dative.sg=блатному,*accusative.sg=блатного,*instrumental.sg=блатным,*prepositional.sg=блатном
блесна|cm,sблёсн,*genitive.sg=блесны,*genitive.pl=блёсен,*dative.sg=блесне,*accusative.sg=блесну,*instrumental.sg=блесной,*prepositional.sg=блесне
близкие|cm,A,*genitive.sg=близких,*dative.sg=близким,*accusative.sg=близких,*instrumental.sg=близкими,*prepositional.sg=близких
близнец|sблизнец,A,*genitive.pl=близнецов,*accusative.pl=близнецов,*instrumental.sg=близнецом
блиндаж|*instrumental.sg=блиндажом
блоггер|A
блогер|A
блондин|A
блондинка|A
блудник|A
блудница|A
блузник|A
блюдечко|nы
блюдце|cm,sблюдц,nа,*genitive.pl=блюдец
блядство|cm,sблядств,nа,p
бобёр|sбобр
богадельня|*genitive.pl=богаделен
богатство|cm,sбогатств,nа,p
богатырь|cm,iём,A
богач|A,*instrumental.sg=богачом
богиня|A,*genitive.pl=богинь,*accusative.pl=богинь
богомол|A
богомолец|A
богослов|A
богохульство|cm,sбогохульств,nа,p
боеприпасы|*genitive.sg=боеприпасов,*dative.sg=боеприпасам,*instrumental.sg=боеприпасами,*prepositional.sg=боеприпасах
боец|A,*genitive.pl=бойцов,*instrumental.sg=бойцом
божество|cm,sбожеств,nа,p,A,*accusative.sg=божество
бойня|*genitive.pl=боен
бойфренд|A
боксёр|A
боксеры|*genitive.sg=боксеров,*dative.sg=боксерам,*instrumental.sg=боксерами,*prepositional.sg=боксерах
болван|A
болгарин|sболгар,p,A,*genitive.sg=болгарина,*dative.sg=болгарину,*accusative.sg=болгарина,*instrumental.sg=болгарином,*prepositional.sg=болгарине
болельщик|A
болеутоляющее|cm,*nominative.pl=болеутоляющие,*genitive.sg=болеутоляющего,*genitive.pl=болеутоляющих,*dative.sg=болеутоляющему,*dative.pl=болеутоляющим,*accusative.pl=болеутоляющие,*instrumental.sg=болеутоляющим,*instrumental.pl=болеутоляющими,*prepositional.sg=болеутоляющем,*prepositional.pl=болеутоляющих
болотце|cm,sболотц,nа
болтовня|iёй,pей
болтун|A
больная|pй,A
больничный|*genitive.sg=больничного,*dative.sg=больничному,*instrumental.sg=больничным,*prepositional.sg=больничном
большевик|A
бомба|p
бомбардир|A
бомбист|A
бомбоубежище|cm,sбомбоубежищ,nа,p
бомж|A,*instrumental.sg=бомжом
бонбоньерка|p
бондарь|cm,A
бонза|p,A
бордель|cm
борец|*genitive.pl=борцов,*instrumental.sg=борцом
борзая|cm,A,*nominative.pl=борзые,*genitive.sg=борзой,*genitive.pl=борзых,*dative.sg=борзой,*dative.pl=борзым,*accusative.sg=борзую,*accusative.pl=борзых,*instrumental.sg=борзой,*instrumental.pl=борзыми,*prepositional.sg=борзой,*prepositional.pl=борзых
боровичанин|sборовичан,nе,p,A,*genitive.sg=боровичанина,*dative.sg=боровичанину,*accusative.sg=боровичанина,*instrumental.sg=боровичанином,*prepositional.sg=боровичанине
бородавочник|A
бородач|A,*instrumental.sg=бородачом
борозда|p
бортник|A
борщ|*instrumental.sg=борщом
босниец|A
боснийка|A,*genitive.pl=босниек,*accusative.pl=босниек
босс|A
босяк|A
ботинкометатель|cm,A
ботинок|cn,sботинк,nы
ботиночек|cn,sботиночк,nы
боцман|A
бочок|sбочк
бочонок|sбочонк
боярин|sбояр,nе,p,A,*genitive.sg=боярина,*dative.sg=боярину,*accusative.sg=боярина,*instrumental.sg=боярином,*prepositional.sg=боярине
боярыня|A,*genitive.pl=боярынь,*accusative.pl=боярынь
боярышня|A,*genitive.pl=боярышень,*accusative.pl=боярышень
брадобрей|A
бражник|A
бразды|*genitive.sg=бразд,*dative.sg=браздам,*instrumental.sg=браздами,*prepositional.sg=браздах
бразилец|A
бразильянка|A
браконьер|A
брамсель|cm
брат|nья,A,*genitive.pl=братьев,*dative.pl=братьям,*instrumental.pl=братьями,*prepositional.pl=братьях
братан|A
братец|A
братишка|A
браток|sбратк,A
братоубийца|p,A
братство|cm,sбратств,nа,p
братыня|*genitive.pl=братынь
брачущиеся|cm,A,*genitive.sg=брачущихся,*dative.sg=брачущимся,*accusative.sg=брачущихся,*instrumental.sg=брачущимися,*prepositional.sg=брачущихся
брачующиеся|cm,A,*genitive.sg=брачующихся,*dative.sg=брачующимся,*accusative.sg=брачующихся,*instrumental.sg=брачующимися,*prepositional.sg=брачующихся
бревно|cm,sбрёвн,nа,*genitive.sg=бревна,*genitive.pl=брёвен,*dative.sg=бревну,*instrumental.sg=бревном,*prepositional.sg=бревне
бредень|cm,sбредн
бремя|gя,*genitive.pl=бремена,*dative.sg=бремени,*dative.pl=бремён,*instrumental.sg=бременем,*instrumental.pl=бременами,*prepositional.sg=бремени,*prepositional.pl=бременах
бретонец|A
брехня|iёй,pей
брешь|cm,gи,dи,iью,lи,S0
бригадир|A
британец|A
британка|A
бритва|p
бритт|A
бритьё|iём
брифы|*genitive.sg=брифов,*dative.sg=брифам,*instrumental.sg=брифами,*prepositional.sg=брифах
брод|*genitive.sg=брод,*genitive.pl=броды,*dative.sg=брода,*dative.pl=бродов
бродяга|A
брокер|A
бронеавтомобиль|cm
бронекатер|nа
бронепоезд|nа
бронесилы|*genitive.sg=бронесил,*dative.sg=бронесилам,*instrumental.sg=бронесилами,*prepositional.sg=бронесилах
бронестекло|sбронестёкл,*genitive.sg=бронестекла,*dative.sg=бронестеклу,*instrumental.sg=бронестеклом,*prepositional.sg=бронестекле
бронза|p
бросок|sброск
брошь|cm,gи,dи,iью,lи,S0
брус|nья,*genitive.pl=брусьев,*dative.pl=брусьям,*instrumental.pl=брусьями,*prepositional.pl=брусьях
брусок|sбруск
брызги|*genitive.sg=брызг,*dative.sg=брызгам,*instrumental.sg=брызгами,*prepositional.sg=брызгах
брюква|p
брюки-галифе|cm,*genitive.sg=брюк-галифе,*dative.sg=брюкам-галифе,*instrumental.sg=брюками-галифе,*prepositional.sg=брюках-галифе
брюнетка|A
брюхо|cm,sбрюх,p
брюхоногие|cm,A,*genitive.sg=брюхоногих,*dative.sg=брюхоногим,*accusative.sg=брюхоногих,*instrumental.sg=брюхоногими,*prepositional.sg=брюхоногих
брюхоногий|A,*genitive.sg=брюхоногого,*dative.sg=брюхоногому,*accusative.sg=брюхоногого,*instrumental.sg=брюхоногим,*prepositional.sg=брюхоногом
буби|*genitive.sg=бубей,*dative.sg=бубям,*instrumental.sg=бубями,*prepositional.sg=бубях
бугай|iём,pёв,A
бугель|cm
бугор|sбугр
бугорок|sбугорк
будда|p,A
буддист|A
будущее|cm,*nominative.pl=будущие,*genitive.sg=будущего,*genitive.pl=будущих,*dative.sg=будущему,*dative.pl=будущим,*accusative.pl=будущие,*instrumental.sg=будущим,*instrumental.pl=будущими,*prepositional.sg=будущем,*prepositional.pl=будущих
буер|nа
бузулукчанин|sбузулукчан,nе,p,A,*genitive.sg=бузулукчанина,*dative.sg=бузулукчанину,*accusative.sg=бузулукчанина,*instrumental.sg=бузулукчанином,*prepositional.sg=бузулукчанине
буй|pёв
буйвол|A
буква|p
букварь|cm,iём
буквоед|A
букля|pей
булла|p
булочная|cm,*nominative.pl=булочные,*genitive.sg=булочной,*genitive.pl=булочных,*dative.sg=булочной,*dative.pl=булочным,*accusative.sg=булочную,*instrumental.sg=булочной,*instrumental.pl=булочными,*prepositional.sg=булочной,*prepositional.pl=булочных
бульбаш|A,*instrumental.sg=бульбашом
бульдог|A
бумагопрядильня|*genitive.pl=бумагопрядилен
бункер|nа
бунтарь|cm,iём,A
бунтовщик|A
бургомистр|A
бургунд|A
буржуй|A
бурундук|A
бурят|A
бусы|*genitive.sg=бус,*dative.sg=бусам,*instrumental.sg=бусами,*prepositional.sg=бусах
буфер|nа
буфетчик|A
буфетчица|A
бухгалтер|A
бухгалтерша|p,A
бухма|p
бушель|cm
буян|A
быдло|cm,sбыдл,nа,p
былое|cm,*genitive.sg=былого,*dative.sg=былому,*instrumental.sg=былым,*prepositional.sg=былом
бытиё|cm,sбыти,iём,lе,nя,pй,S
бычок|sбычк
бэбиситтер|A
бюджетник|A
бюллетень|cm
бюрократ|A
вавилонянин|sвавилонян,nе,p,A,*genitive.sg=вавилонянина,*dative.sg=вавилонянину,*accusative.sg=вавилонянина,*instrumental.sg=вавилонянином,*prepositional.sg=вавилонянине
вагон-ресторан|sвагонам-ресторан,*nominative.pl=вагоны-рестораны,*genitive.sg=вагона-ресторана,*genitive.pl=вагонов-ресторанов,*dative.sg=вагону-ресторану,*accusative.pl=вагоны-рестораны,*instrumental.sg=вагоном-рестораном,*instrumental.pl=вагонами-ресторанами,*prepositional.sg=вагоне-ресторане,*prepositional.pl=вагонах-ресторанах
вагоновожатый|A
вадим|A
вайшья|pев
вайя|*genitive.pl=ваий
вакса|p
валенок|cn,sваленк,nы
валлонский|*genitive.sg=валлонского,*dative.sg=валлонскому,*instrumental.sg=валлонским,*prepositional.sg=валлонском
валок|sвалк
валторна|p
валькирия|A
вампир|A
вандал|A
ванна|p
ванная|cm,*nominative.pl=ванные,*genitive.sg=ванной,*genitive.pl=ванных,*dative.sg=ванной,*dative.pl=ванным,*accusative.sg=ванную,*instrumental.sg=ванной,*instrumental.pl=ванными,*prepositional.sg=ванной,*prepositional.pl=ванных
варвар|A
варварство|cm,sварварств,nа,p
варенье|cm,sварень,nя,S,*genitive.pl=варений
варшавянин|sваршавян,nе,p,A,*genitive.sg=варшавянина,*dative.sg=варшавянину,*accusative.sg=варшавянина,*instrumental.sg=варшавянином,*prepositional.sg=варшавянине
варяг|A
василёк|sвасильк
вассал|A
вахтенный|A,*genitive.sg=вахтенного,*dative.sg=вахтенному,*accusative.sg=вахтенного,*instrumental.sg=вахтенным,*prepositional.sg=вахтенном
вахтёр|A
вдовец|sвдовец,A,*genitive.pl=вдовецов,*accusative.pl=вдовецов,*instrumental.sg=вдовецом
вдохновитель|cm,A
веблица|A
вегетарианец|A
ведёрко|nы
ведомство|cm,sведомств,nа,p
ведущая|cm,A,*nominative.pl=ведущие,*genitive.sg=ведущей,*genitive.pl=ведущих,*dative.sg=ведущей,*dative.pl=ведущим,*accusative.sg=ведущую,*accusative.pl=ведущих,*instrumental.sg=ведущей,*instrumental.pl=ведущими,*prepositional.sg=ведущей,*prepositional.pl=ведущих
веды|*genitive.sg=Вед,*dative.sg=Ведам,*instrumental.sg=Ведами,*prepositional.sg=Ведах
ведьма|p,A
веер|nа
веко|cm,sвек,p
вексель|cm,nя
великан|A
величество|cm,sвеличеств,nа,p
велосипедист|A
велосипедистка|A
вельможа|A
венгр|A
венеролог|A
венетский|*genitive.sg=венетского,*dative.sg=венетскому,*instrumental.sg=венетским,*prepositional.sg=венетском
вензель|cm,nя
венокол|A
вентерь|cm
вентиль|cm
вепрь|cm,A
вепс|A
вепсский|*genitive.sg=вепсского,*dative.sg=вепсскому,*instrumental.sg=вепсским,*prepositional.sg=вепсском
веранда|p
верба|p
верблюд|A
веред|nа
веретено|cf,iом,*genitive.sg=веретено,*genitive.pl=веретёна,*dative.sg=веретена,*dative.pl=веретён,*instrumental.pl=веретёнами,*prepositional.pl=веретёнах
верзила|A
вериги|*genitive.sg=вериг,*dative.sg=веригам,*instrumental.sg=веригами,*prepositional.sg=веригах
верноподданный|A,*genitive.sg=верноподданного,*dative.sg=верноподданному,*accusative.sg=верноподданного,*instrumental.sg=верноподданным,*prepositional.sg=верноподданном
вероломство|cm,sвероломств,nа,p
версификатор|A
верста|gа,*genitive.pl=вёрсты,*dative.sg=версты,*dative.pl=вёрст,*instrumental.pl=вёрстами,*prepositional.pl=вёрстах
верстальщик|A
вертихвостка|A
вертишейка|A,*genitive.pl=вертишеек,*accusative.pl=вертишеек
вертухай|A
верующий|A,*genitive.sg=верующего,*dative.sg=верующему,*accusative.sg=верующего,*instrumental.sg=верующим,*prepositional.sg=верующем
верховой|A,*genitive.sg=верхового,*dative.sg=верховому,*accusative.sg=верхового,*instrumental.sg=верховым,*prepositional.sg=верховом
верховье|cm,sверховь,nя,S,*genitive.pl=верховий
верша|p
вершок|sвершк
веселье|cm,sвесель,nя,S,*genitive.pl=веселий
вестгот|A
вестибюль|cm
вестовой|A,*nominative.pl=вестовые,*genitive.sg=вестового,*genitive.pl=вестовых,*dative.sg=вестовому,*dative.pl=вестовым,*accusative.sg=вестового,*accusative.pl=вестовых,*instrumental.sg=вестовым,*instrumental.pl=вестовыми,*prepositional.sg=вестовом,*prepositional.pl=вестовых
ветеран|A
ветеринар|A
ветерок|sветерк
ветла|cm,sвётл,*genitive.sg=ветлы,*genitive.pl=вётел,*dative.sg=ветле,*accusative.sg=ветлу,*instrumental.sg=ветлой,*prepositional.sg=ветле
ветлужанин|sветлужан,nе,p,A,*genitive.sg=ветлужанина,*dative.sg=ветлужанину,*accusative.sg=ветлужанина,*instrumental.sg=ветлужанином,*prepositional.sg=ветлужанине
ветошь|cm,gи,dи,iью,lи,S0
ветродвигатель|cm,sвтродвигател,*nominative.sg=втродвигатель,*accusative.sg=втродвигатель
ветроуказатель|cm,sвтроуказател,*nominative.sg=втроуказатель,*accusative.sg=втроуказатель
ветфельдшер|nа,A
вече|cm,sвеч,nа,p
вещество|cm,sвеществ,nа,p
вещмешок|sвещмешк
вещь|cm,gи,dи,iью,lи,S0
взаимопомощь|cm,gи,dи,iью,lи,S0
взломщик|A
взрывчатка|p
взыскатель|cm,A
видеоигра|p
византиец|A
визирь|cm,A
визитёр|A
викарий|A
викинг|A
виконт|A
вилла|p
виллан|A
вилы|*genitive.sg=вил,*dative.sg=вилам,*instrumental.sg=вилами,*prepositional.sg=вилах
винище|cm,sвинищ,nа,p
винкель|cm
виновник|A
виноградарь|cm,A
винодел|A
винодельня|*genitive.pl=виноделен
винокур|A
виноторговец|A
винцо|cm,sвинц,nа,*genitive.pl=винец,*instrumental.sg=винцом
виртуоз|A
висок|sвиск
витебец|A
витеблянин|sвитеблян,nе,p,A,*genitive.sg=витеблянина,*dative.sg=витеблянину,*accusative.sg=витеблянина,*instrumental.sg=витеблянином,*prepositional.sg=витеблянине
витебчанин|sвитебчан,nе,p,A,*genitive.sg=витебчанина,*dative.sg=витебчанину,*accusative.sg=витебчанина,*instrumental.sg=витебчанином,*prepositional.sg=витебчанине
виток|sвитк
витраж|*instrumental.sg=витражом
витязь|cm,A
вихор|sвихр
вихрь|cm
вице-губернатор|A
вице-президент|A
вице-президентство|cm,sвице-президентств,nа,p
вице-премьер|A
вице-спикер|A
вкладчик|A
влагалище|cm,sвлагалищ,nа,p
владислав|A
владыка|A
властелин|A
властитель|cm,A
властительница|A
вмешательство|cm,sвмешательств,nа,p
внук|A
внутренности|*genitive.sg=внутренностей,*dative.sg=внутренностям,*instrumental.sg=внутренностями,*prepositional.sg=внутренностях
внучок|sвнучк,A
внучонок|sвнучат,nа,p,A,*genitive.sg=внучонка,*dative.sg=внучонку,*accusative.sg=внучонка,*instrumental.sg=внучонком,*prepositional.sg=внучонке
вобла|p,A
вогул|A
водила|A
водитель|cm,A
водник|A
воднолыжник|A
водогрейня|*genitive.pl=водогреен
водолаз|A
водолей|A
водонагреватель|cm
водонька|*genitive.pl=водонек
водоросель|cm,sводоросл,gи,dи,lи,*instrumental.sg=водороселью
водохранилище|cm,sводохранилищ,nа,p
водочник|A
водочница|A
водяной|A,*genitive.sg=водяного,*dative.sg=водяному,*accusative.sg=водяного,*instrumental.sg=водяным,*prepositional.sg=водяном
водятел|sводятл,A
воевода|A
воеводство|cm,sвоеводств,nа,p
военачальник|A
военнопленный|nе,A,*genitive.sg=военнопленного,*genitive.pl=военнопленных,*dative.sg=военнопленному,*dative.pl=военнопленным,*accusative.sg=военнопленного,*accusative.pl=военнопленных,*instrumental.sg=военнопленным,*instrumental.pl=военнопленными,*prepositional.sg=военнопленном,*prepositional.pl=военнопленных
военнослужащий|nе,A,*genitive.sg=военнослужащего,*genitive.pl=военнослужащих,*dative.sg=военнослужащему,*dative.pl=военнослужащим,*accusative.sg=военнослужащего,*accusative.pl=военнослужащих,*instrumental.sg=военнослужащим,*instrumental.pl=военнослужащими,*prepositional.sg=военнослужащем,*prepositional.pl=военнослужащих
военрук|A
вожак|A
вождь|cm,iём,A
вожжа|pей,*instrumental.sg=вожжой
вожжи|*genitive.sg=вожжей,*dative.sg=вожжам,*instrumental.sg=вожжами,*prepositional.sg=вожжах
возбудитель|cm
воздухоочиститель|cm
возлюбленная|cm,A,*nominative.pl=возлюбленные,*genitive.sg=возлюбленной,*genitive.pl=возлюбленных,*dative.sg=возлюбленной,*dative.pl=возлюбленным,*accusative.sg=возлюбленную,*accusative.pl=возлюбленных,*instrumental.sg=возлюбленной,*instrumental.pl=возлюбленными,*prepositional.sg=возлюбленной,*prepositional.pl=возлюбленных
возлюбленный|A,*genitive.sg=возлюбленного,*dative.sg=возлюбленному,*accusative.sg=возлюбленного,*instrumental.sg=возлюбленным,*prepositional.sg=возлюбленном
возница|A
возня|iёй,pей
воин|*genitive.sg=воин,*genitive.pl=воины,*dative.sg=воина,*dative.pl=воинов
воинство|cm,sвоинств,nа,p
воитель|cm,A
войска|cm,*genitive.sg=войск,*dative.sg=войскам,*instrumental.sg=войсками,*prepositional.sg=войсках
войско|cm,sвойск,nа,p
вокалист|A
вокалистка|A
вол|A
волдырь|cm,iём
волжанин|sволжан,nе,p,A,*genitive.sg=волжанина,*dative.sg=волжанину,*accusative.sg=волжанина,*instrumental.sg=волжанином,*prepositional.sg=волжанине
волк|A
волкодав|A
волколак|A
волкулак|A
вологжанин|sвологжан,nе,p,A,*genitive.sg=вологжанина,*dative.sg=вологжанину,*accusative.sg=вологжанина,*instrumental.sg=вологжанином,*prepositional.sg=вологжанине
волоконце|cm,sволоконц,nа,*genitive.pl=волоконец
волонтёр|A
волосня|iёй,pей
волосок|sволоск
волох|A
волочанин|sволочан,nе,p,A,*genitive.sg=волочанина,*dative.sg=волочанину,*accusative.sg=волочанина,*instrumental.sg=волочанином,*prepositional.sg=волочанине
волочильня|*genitive.pl=волочилен
волхв|A
волчица|A
волчище|cm,sволчищ,p,A
волчок|sволчк
волчонок|sволчат,nа,p,A,*genitive.sg=волчонка,*dative.sg=волчонку,*accusative.sg=волчонка,*instrumental.sg=волчонком,*prepositional.sg=волчонке
волшебник|A
волынянин|sволынян,nе,p,A,*genitive.sg=волынянина,*dative.sg=волынянину,*accusative.sg=волынянина,*instrumental.sg=волынянином,*prepositional.sg=волынянине
вольнодумец|A
вольт-ампер|p
воля|*genitive.pl=воль
вомбат|A
вонючка|A
вопль|cm
воровка|A
воронко|cm,sворонк,A
воротничок|sворотничк
воротца|cm,*genitive.sg=воротец,*dative.sg=воротцам,*instrumental.sg=воротцами,*prepositional.sg=воротцах
ворох|nа
ворсильня|*genitive.pl=ворсилен
ворсовальня|*genitive.pl=ворсовален
воскобойня|*genitive.pl=воскобоен
воскресенье|cm,sвоскресень,nя,S,*genitive.pl=воскресений
воспитанник|A
воспитатель|cm,A
воспитательница|A
воспроизводство|cm,sвоспроизводств,nа,p
восточноармянский|*genitive.sg=восточноармянского,*dative.sg=восточноармянскому,*instrumental.sg=восточноармянским,*prepositional.sg=восточноармянском
вошка|A
вошь|cm,sвш,gи,dи,lи,S0,*instrumental.sg=вошью
вояка|A
враг|A
враньё|iём
врата|cm,*genitive.sg=врат,*dative.sg=вратам,*instrumental.sg=вратами,*prepositional.sg=вратах
вратарь|cm,iём,A
врач|A,*instrumental.sg=врачом
врачиха|A
вредитель|cm,A
вредительство|cm,sвредительств,nа,p
врун|A
всадник|A
всевышний|nе,A,*genitive.sg=всевышнего,*genitive.pl=всевышних,*dative.sg=всевышнему,*dative.pl=всевышним,*accusative.sg=всевышнего,*accusative.pl=всевышних,*instrumental.sg=всевышним,*instrumental.pl=всевышними,*prepositional.sg=всевышнем,*prepositional.pl=всевышних
всезнайка|A,*genitive.pl=всезнаек,*accusative.pl=всезнаек
вселенная|cm,*nominative.pl=вселенные,*genitive.sg=вселенной,*genitive.pl=вселенных,*dative.sg=вселенной,*dative.pl=вселенным,*accusative.sg=вселенную,*accusative.pl=вселенные,*instrumental.sg=вселенной,*instrumental.pl=вселенными,*prepositional.sg=вселенной,*prepositional.pl=вселенных
вселенная|cm,*nominative.pl=Вселенные,*genitive.sg=Вселенной,*genitive.pl=Вселенных,*dative.sg=Вселенной,*dative.pl=Вселенным,*accusative.sg=Вселенную,*accusative.pl=Вселенные,*instrumental.sg=Вселенной,*instrumental.pl=Вселенными,*prepositional.sg=Вселенной,*prepositional.pl=Вселенных
всенощная|cm,*nominative.pl=всенощные,*genitive.sg=всенощной,*genitive.pl=всенощных,*dative.sg=всенощной,*dative.pl=всенощным,*accusative.sg=всенощную,*accusative.pl=всенощные,*instrumental.sg=всенощной,*instrumental.pl=всенощными,*prepositional.sg=всенощной,*prepositional.pl=всенощных
встречка|p
встречный|A,*genitive.sg=встречного,*dative.sg=встречному,*accusative.sg=встречного,*instrumental.sg=встречным,*prepositional.sg=встречном
второе|cm,*nominative.pl=вторые,*genitive.sg=второго,*genitive.pl=вторых,*dative.sg=второму,*dative.pl=вторым,*accusative.pl=вторые,*instrumental.sg=вторым,*instrumental.pl=вторыми,*prepositional.sg=втором,*prepositional.pl=вторых
второкурсник|A
вуй|A
вулканолог|A
вульва|p
вундеркинд|A
вурдалак|A
выборы|*genitive.sg=выборов,*dative.sg=выборам,*instrumental.sg=выборами,*prepositional.sg=выборах
выводок|sвыводк
выгрузчик|A
выдра|gа,*genitive.pl=выдры,*dative.sg=выдры,*dative.pl=выдр
выключатель|cm
вымогательство|cm,sвымогательств,nа,p
вымысел|sвымысл
вымя|cm,sвымен,gи,dи,iем,lи,nа,*genitive.pl=вымён
выплавка|p
выпускник|A
выпь|A
выродок|sвыродк,A
вырубка|p
выруский|*genitive.sg=выруского,*dative.sg=вырускому,*instrumental.sg=выруским,*prepositional.sg=выруском
выскочка|A
высочество|cm,sвысочеств,nа,p
вытрезвитель|cm
выходец|A
выходные|cm,*genitive.sg=выходных,*dative.sg=выходным,*instrumental.sg=выходными,*prepositional.sg=выходных
выхухоль|cm,A
вычитаемое|cm,*nominative.pl=вычитаемые,*genitive.sg=вычитаемого,*genitive.pl=вычитаемых,*dative.sg=вычитаемому,*dative.pl=вычитаемым,*accusative.pl=вычитаемые,*instrumental.sg=вычитаемым,*instrumental.pl=вычитаемыми,*prepositional.sg=вычитаемом,*prepositional.pl=вычитаемых
вышибала|A
вьетнамец|A
вьетнамка|A
вэньянь|cm
вязальщик|A
г-жа|*instrumental.sg=г-жой
г-н|A
гаваец|A
гавайский|*genitive.sg=гавайского,*dative.sg=гавайскому,*instrumental.sg=гавайским,*prepositional.sg=гавайском
гага|A
гагарка|A
гагауз|A
гад|A
гадалка|A
гадина|A
газетчик|A
гаитянин|sгаитян,nе,p,A,*genitive.sg=гаитянина,*dative.sg=гаитянину,*accusative.sg=гаитянина,*instrumental.sg=гаитянином,*prepositional.sg=гаитянине
гаишник|A
гай|pёв
гайдук|A
гайка|*genitive.pl=гаек
галантерея|pй
галерея|pй
галилеянин|sгалилеян,nе,p,A,*genitive.sg=галилеянина,*dative.sg=галилеянину,*accusative.sg=галилеянина,*instrumental.sg=галилеянином,*prepositional.sg=галилеянине
галиматья|iёй,*genitive.pl=галиматей
галиотис|A
галичанин|sгаличан,nе,p,A,*genitive.sg=галичанина,*dative.sg=галичанину,*accusative.sg=галичанина,*instrumental.sg=галичанином,*prepositional.sg=галичанине
галька|*genitive.pl=галек
гамма|p
гангстер|A
гараж|*instrumental.sg=гаражом
гарант|A
гарда|p
гармонист|A
гаситель|cm
гастарбайтер|A
гастропод|A
гаубица-пушка|cm,sгаубицам-пушк,*nominative.pl=гаубицы-пушки,*genitive.sg=гаубицы-пушки,*genitive.pl=гаубиц-пушек,*dative.sg=гаубице-пушке,*accusative.sg=гаубицу-пушку,*accusative.pl=гаубицы-пушки,*instrumental.sg=гаубицей-пушкой,*instrumental.pl=гаубицами-пушками,*prepositional.sg=гаубице-пушке,*prepositional.pl=гаубицах-пушках
гауптвахта|p
гафель|cm
гвардеец|A
гедонист|A
гей-пропаганда|p
гей-сообщество|cm,sгей-сообществ,nа,p
гей-фестиваль|cm
гейша|p,A
геккон|A
гель|cm
гендиректор|nа,A
генеалог|A
генерал-лейтенант|A
генерал-майор|A
генерал-майорство|cm,sгенерал-майорств,nа,p
генерал-полковник|A
генералиссимус|A
генеральша|p,A
гений|A
гениталии|*genitive.sg=гениталий,*dative.sg=гениталиям,*instrumental.sg=гениталиями,*prepositional.sg=гениталиях
генпрокурор|A
генсек|A
географ|A
геолог|A
гепард|A
германец|A
гермафродит|A
героиня|*genitive.pl=героинь
герой|A
геройство|cm,sгеройств,nа,p
герр|A
герц|p
герцогиня|A,*genitive.pl=герцогинь,*accusative.pl=герцогинь
герцогство|cm,sгерцогств,nа,p
гетеросексуал|A
гетман|A
гетра|p
гибэдэдэшник|A
гигант|A
гид|A
гидра|p,A
гидрометла|cm,sгидромётл,*genitive.sg=гидрометлы,*genitive.pl=гидромётел,*dative.sg=гидрометле,*accusative.sg=гидрометлу,*instrumental.sg=гидрометлой,*prepositional.sg=гидрометле
гиена|A
гильза|p
гимназист|A
гинеколог|A
гиппопотам|A
гирлянда|p
гиря|*genitive.pl=гирь
гистограмма|p
гитарист|A
гитлеровец|A
главарь|cm,iём,A
главврач|A,*instrumental.sg=главврачом
главное|cm,*nominative.pl=главные,*genitive.sg=главного,*genitive.pl=главных,*dative.sg=главному,*dative.pl=главным,*accusative.pl=главные,*instrumental.sg=главным,*instrumental.pl=главными,*prepositional.sg=главном,*prepositional.pl=главных
главнокомандующий|nе,A,*genitive.sg=главнокомандующего,*genitive.pl=главнокомандующих,*dative.sg=главнокомандующему,*dative.pl=главнокомандующим,*accusative.sg=главнокомандующего,*accusative.pl=главнокомандующих,*instrumental.sg=главнокомандующим,*instrumental.pl=главнокомандующими,*prepositional.sg=главнокомандующем,*prepositional.pl=главнокомандующих
гладиатор|A
гладильня|*genitive.pl=гладилен
глазунья|*genitive.pl=глазуний
гланда|p
глупец|sглупец,A,*genitive.pl=глупецов,*accusative.pl=глупецов,*instrumental.sg=глупецом
глупыш|A,*instrumental.sg=глупышом
глухарь|cm,iём
глушитель|cm
гнида|A
гнойничок|*genitive.sg=гнойничка,*dative.sg=гнойничку,*instrumental.sg=гнойничком,*prepositional.sg=гнойничке
гном|A
гоблин|A
говнарь|cm,iём,A
говнище|cm,sговнищ,nа,p
говно|cm,sговн,nа,*genitive.pl=говен
говнюк|A
говорильня|*genitive.pl=говорилен
говорун|A
говорунья|A,*genitive.pl=говоруний,*accusative.pl=говоруний
гоголь|cm,A
гой|A
гойка|A,*genitive.pl=гоек,*accusative.pl=гоек
голем|A
голенище|cm,sголенищ,nа,p
голландец|A
голландка|A
головастик|A
головня|iёй,pей
головомойка|*genitive.pl=головомоек
головорез|A
голосок|sголоск
голубенький|nе,A,*genitive.sg=голубенького,*genitive.pl=голубеньких,*dative.sg=голубенькому,*dative.pl=голубеньким,*accusative.sg=голубенького,*accusative.pl=голубеньких,*instrumental.sg=голубеньким,*instrumental.pl=голубенькими,*prepositional.sg=голубеньком,*prepositional.pl=голубеньких
голубок|sголубк,A
голубцы|*genitive.sg=голубцов,*dative.sg=голубцам,*instrumental.sg=голубцами,*prepositional.sg=голубцах
голубчик|A
голубь|cm,A
голья|iёй,*genitive.pl=голей
гомик|A
гоминоид|A
гомосек|A
гомосексуал|A
гомосексуалист|A
гонец|A,*genitive.pl=гонцов,*accusative.pl=гонцов,*instrumental.sg=гонцом
гонорея|pй
гончар|A
гонщик|A
гопник|A
горбуша|A
горбылёвые|cm,A,*genitive.sg=горбылёвых,*dative.sg=горбылёвым,*accusative.sg=горбылёвых,*instrumental.sg=горбылёвыми,*prepositional.sg=горбылёвых
гордыня|*genitive.pl=гордынь
горе-критик|A
горилла|p,A
горлица|A
горлышко|nы
горничная|cm,A,*nominative.pl=горничные,*genitive.sg=горничной,*genitive.pl=горничных,*dative.sg=горничной,*dative.pl=горничным,*accusative.sg=горничную,*accusative.pl=горничных,*instrumental.sg=горничной,*instrumental.pl=горничными,*prepositional.sg=горничной,*prepositional.pl=горничных
горностай|A
горняк|A
городишко|nы
городничий|nе,A,*genitive.sg=городничего,*genitive.pl=городничих,*dative.sg=городничему,*dative.pl=городничим,*accusative.sg=городничего,*accusative.pl=городничих,*instrumental.sg=городничим,*instrumental.pl=городничими,*prepositional.sg=городничем,*prepositional.pl=городничих
городок|sгородк
горожанин|A,*nominative.pl=горожане,*genitive.pl=горожан,*dative.pl=горожанам,*instrumental.pl=горожанами,*prepositional.pl=горожанах
горошек|*genitive.sg=горошка,*dative.sg=горошку,*instrumental.sg=горошком,*prepositional.sg=горошке
горшеня|pей,A
горшечник|A
горшок|sгоршк
горьковчанин|sгорьковчан,nе,p,A,*genitive.sg=горьковчанина,*dative.sg=горьковчанину,*accusative.sg=горьковчанина,*instrumental.sg=горьковчанином,*prepositional.sg=горьковчанине
горючее|cm,*nominative.pl=горючие,*genitive.sg=горючего,*genitive.pl=горючих,*dative.sg=горючему,*dative.pl=горючим,*accusative.pl=горючие,*instrumental.sg=горючим,*instrumental.pl=горючими,*prepositional.sg=горючем,*prepositional.pl=горючих
горячее|cm,*nominative.pl=горячие,*genitive.sg=горячего,*genitive.pl=горячих,*dative.sg=горячему,*dative.pl=горячим,*accusative.pl=горячие,*instrumental.sg=горячим,*instrumental.pl=горячими,*prepositional.sg=горячем,*prepositional.pl=горячих
госпиталь|cm
господин|A,*nominative.pl=господа,*genitive.pl=господ,*dative.pl=господам,*instrumental.pl=господами,*prepositional.pl=господах
господство|cm,sгосподств,nа,p
госпожа|*instrumental.sg=госпожой
госсекретарь|cm,iём,A
госслужба|p
гостеприимство|cm,sгостеприимств,nа,p
гостиная|cm,*nominative.pl=гостиные,*genitive.sg=гостиной,*genitive.pl=гостиных,*dative.sg=гостиной,*dative.pl=гостиным,*accusative.sg=гостиную,*instrumental.sg=гостиной,*instrumental.pl=гостиными,*prepositional.sg=гостиной,*prepositional.pl=гостиных
гость|cm,A
гостья|A,*genitive.pl=гостий,*accusative.pl=гостий
государство|cm,sгосударств,nа,p
государство-донор|sгосударствам-донор,*nominative.pl=государства-доноры,*genitive.sg=государства-донора,*genitive.pl=государств-доноров,*dative.sg=государству-донору,*accusative.pl=государства-доноры,*instrumental.sg=государством-донором,*instrumental.pl=государствами-донорами,*prepositional.sg=государстве-доноре,*prepositional.pl=государствах-донорах
государство-участник|sгосударствам-участник,*nominative.pl=государства-участники,*genitive.sg=государства-участника,*genitive.pl=государств-участников,*dative.sg=государству-участнику,*accusative.pl=государства-участники,*instrumental.sg=государством-участником,*instrumental.pl=государствами-участниками,*prepositional.sg=государстве-участнике,*prepositional.pl=государствах-участниках
государь|cm,A
гот|A
готовальня|*genitive.pl=готовален
готский|*genitive.sg=готского,*dative.sg=готскому,*instrumental.sg=готским,*prepositional.sg=готском
грабарь|cm,iём,A
грабёж|sграбеж,*instrumental.sg=грабежом
грабельки|*genitive.sg=грабелек,*dative.sg=грабелькам,*instrumental.sg=грабельками,*prepositional.sg=грабельках
грабитель|cm,A
градостроительство|cm,sградостроительств,nа,p
гражданин|A,*nominative.pl=граждане,*genitive.pl=граждан,*dative.pl=гражданам,*instrumental.pl=гражданами,*prepositional.pl=гражданах
гражданство|cm,sгражданств,nа,p
гранильня|*genitive.pl=гранилен
грантодатель|cm,A
грантополучатель|cm,A
графиня|A,*genitive.pl=графинь,*accusative.pl=графинь
графство|cm,sграфств,nа,p
грач|A,*instrumental.sg=грачом
гребень|cm,sгребн
гребешок|sгребешк
гребля|*genitive.pl=гребель
грек|A
грелка|p
гренадер|A
гренландец|A
гренок|sгренк
гречанка|A
греческий|*genitive.sg=греческого,*dative.sg=греческому,*instrumental.sg=греческим,*prepositional.sg=греческом
грешник|A
грешница|A
грешок|sгрешк
грибок|sгрибк
гривенничек|sгривенничк
гриль|cm
грифель|cm
грифон|A
гроздь|cm,gи,dи,iью,lи,nья,*genitive.pl=гроздьев,*dative.pl=гроздьям,*instrumental.pl=гроздьями,*prepositional.pl=гроздьях
громкоговоритель|cm
гроссмейстер|A
грубиян|A
груздь|cm,iём
грузин|p,A
грузинка|A
грузовичок|sгрузовичк
грузоотправитель|cm,A
грузчик|A
грухва|p
грызня|iёй,pей
грызун|A
грядущее|cm,*nominative.pl=грядущие,*genitive.sg=грядущего,*genitive.pl=грядущих,*dative.sg=грядущему,*dative.pl=грядущим,*accusative.pl=грядущие,*instrumental.sg=грядущим,*instrumental.pl=грядущими,*prepositional.sg=грядущем,*prepositional.pl=грядущих
грязнуля|A,*genitive.pl=грязнуль,*accusative.pl=грязнуль
гуашь|cm,gи,dи,iью,lи,S0
губернатор|A
гувернантка|A
гудок|sгудк
гуж|*instrumental.sg=гужом
гузно|cm,sгузн,nа,*genitive.pl=гузен
гуляка|A
гулянье|cm,sгулянь,nя,S,*genitive.pl=гуляний
гуманист|A
гуманоид|A
гумно|cm,sгумн,nа,*genitive.pl=гумен
гуна|A
гунн|A
гуня|*genitive.pl=гунь
гурман|A
гусар|p,A
гусёнок|sгусят,nа,p,A,*genitive.sg=гусёнка,*dative.sg=гусёнку,*accusative.sg=гусёнка,*instrumental.sg=гусёнком,*prepositional.sg=гусёнке
гусли|*genitive.sg=гуслей,*dative.sg=гуслям,*instrumental.sg=гуслями,*prepositional.sg=гуслях
гусь|cm,A
гэбист|A
гюрза|p
гяур|A
давильня|*genitive.pl=давилен
дактиль|cm
далай-лама|A
дальнейшее|cm,*genitive.sg=дальнейшего,*dative.sg=дальнейшему,*instrumental.sg=дальнейшим,*prepositional.sg=дальнейшем
дальнобойщик|A
дамба|p
дамочка|A
данакильский|*genitive.sg=данакильского,*dative.sg=данакильскому,*instrumental.sg=данакильским,*prepositional.sg=данакильском
данник|A
данные|cm,*genitive.sg=данных,*dative.sg=данным,*instrumental.sg=данными,*prepositional.sg=данных
дантист|A
дань|cm,dи,iью,lи,*genitive.sg=дань,*genitive.pl=дани,*dative.pl=даней
дар|*genitive.sg=дар,*genitive.pl=дары,*dative.sg=дара,*dative.pl=даров
датский|*nominative.sg=датского,*genitive.sg=датскому,*instrumental.sg=датским,*prepositional.sg=датском
датчанин|sдатчан,nе,p,A,*genitive.sg=датчанина,*dative.sg=датчанину,*accusative.sg=датчанина,*instrumental.sg=датчанином,*prepositional.sg=датчанине
датчанка|A
дачник|A
дверца|*genitive.pl=дверец
двигатель|cm
движитель|cm
движок|sдвижк
двинянин|sдвинян,nе,p,A,*genitive.sg=двинянина,*dative.sg=двинянину,*accusative.sg=двинянина,*instrumental.sg=двинянином,*prepositional.sg=двинянине
двоежёнство|cm,sдвоежёнств,nа,p
двоечник|A
двоечница|A
двойка|*genitive.pl=двоек
двойник|A
двойня|*genitive.pl=двоен
двор|*genitive.sg=двор,*genitive.pl=дворы,*dative.sg=двора,*dative.pl=дворов
дворец|*genitive.pl=дворцов,*instrumental.sg=дворцом
дворянин|sдворян,nе,p,A,*genitive.sg=дворянина,*dative.sg=дворянину,*accusative.sg=дворянина,*instrumental.sg=дворянином,*prepositional.sg=дворянине
дворянка|A
дворянство|cm,sдворянств,nа,p
двуручка|p
двурушник|A
дебаты|*genitive.sg=дебатов,*dative.sg=дебатам,*instrumental.sg=дебатами,*prepositional.sg=дебатах
дебил|A
дебошир|A
деверь|cm,nья,A,*dative.pl=деверьям,*instrumental.pl=деверьями,*prepositional.pl=деверьях
девица|A
девка|A
девочка-подросток|sдевочкам-подросток,A,*nominative.pl=девочки-подростоки,*genitive.sg=девочки-подростока,*genitive.pl=девочк-подростоков,*dative.sg=девочке-подростоку,*accusative.sg=девочку-подростока,*accusative.pl=девочк-подростоков,*instrumental.sg=девочкой-подростоком,*instrumental.pl=девочками-подростоками,*prepositional.sg=девочке-подростоке,*prepositional.pl=девочках-подростоках
девственник|A
девственница|A
девчата|cm,A,*genitive.sg=девчат,*dative.sg=девчатам,*accusative.sg=девчат,*instrumental.sg=девчатами,*prepositional.sg=девчатах
девчонка|A
девчушка|A
дёготь|cm,*genitive.sg=дёготь,*genitive.pl=дёгти,*dative.sg=дёгтя,*dative.pl=дёгтей,*instrumental.sg=дёгтем,*instrumental.pl=дёгтями,*prepositional.sg=дёгте,*prepositional.pl=дёгтях
дедуля|A,*genitive.pl=дедуль,*accusative.pl=дедуль
дедушка|A
дежа|gа,dи,lе,*genitive.pl=дежи,*dative.pl=дежей,*instrumental.sg=дежой
дежурная|cm,A,*nominative.pl=дежурные,*genitive.sg=дежурной,*genitive.pl=дежурных,*dative.sg=дежурной,*dative.pl=дежурным,*accusative.sg=дежурную,*accusative.pl=дежурных,*instrumental.sg=дежурной,*instrumental.pl=дежурными,*prepositional.sg=дежурной,*prepositional.pl=дежурных
дежурство|cm,sдежурств,nа,p
дезертир|A
деист|A
действо|cm,sдейств,nа,p
декабрист|A
декабрь|cm,iём
декель|cm
дексель|cm
делегат|A
делец|A,*genitive.pl=дельцов,*accusative.pl=дельцов,*instrumental.sg=дельцом
делимое|cm,*nominative.pl=делимые,*genitive.sg=делимого,*genitive.pl=делимых,*dative.sg=делимому,*dative.pl=делимым,*accusative.pl=делимые,*instrumental.sg=делимым,*instrumental.pl=делимыми,*prepositional.sg=делимом,*prepositional.pl=делимых
делитель|cm
делишки|*genitive.sg=делишек,*dative.sg=делишкам,*instrumental.sg=делишками,*prepositional.sg=делишках
дельта|p
дельфин|A
демагог|A
дембель|cm
демиург|A
демократ|A
демонстрант|A
демонстрантка|A
денёк|sденьк
деньга|p
деньжата|cm,*genitive.sg=деньжат,*dative.sg=деньжатам,*instrumental.sg=деньжатами,*prepositional.sg=деньжатах
депутат|A
дервиш|A
деревенщина|A
деревенька|*genitive.pl=деревенек
деревня|*genitive.pl=деревень
деревообделочная|cm,*nominative.pl=деревообделочные,*genitive.sg=деревообделочной,*genitive.pl=деревообделочных,*dative.sg=деревообделочной,*dative.pl=деревообделочным,*accusative.sg=деревообделочную,*accusative.pl=деревообделочные,*instrumental.sg=деревообделочной,*instrumental.pl=деревообделочными,*prepositional.sg=деревообделочной,*prepositional.pl=деревообделочных
деревообделочник|A
деревцо|cm,sдеревц,nа,*genitive.pl=деревец,*instrumental.sg=деревцом
дереза|*genitive.pl=дерёз
держатель|cm
держидерево|cm,sдержидеревь,nя,S,*genitive.sg=держидерева,*dative.sg=держидереву,*instrumental.sg=держидеревом,*prepositional.sg=держидереве
десантник|A
десна|cm,sдёсн,*genitive.sg=десны,*genitive.pl=дёсен,*dative.sg=десне,*accusative.sg=десну,*instrumental.sg=десной,*prepositional.sg=десне
деспот|A
детдом|nа
детёнок|sдетят,nа,p,A,*genitive.sg=детёнка,*dative.sg=детёнку,*accusative.sg=детёнка,*instrumental.sg=детёнком,*prepositional.sg=детёнке
детёныш|A
детина|A
детишки|A,*genitive.sg=детишек,*dative.sg=детишкам,*accusative.sg=детишек,*instrumental.sg=детишками,*prepositional.sg=детишках
детище|cm,sдетищ,nа,p,A,*accusative.sg=детище
детка|A
деточка|A
детская|cm,*nominative.pl=детские,*genitive.sg=детской,*genitive.pl=детских,*dative.sg=детской,*dative.pl=детским,*accusative.sg=детскую,*accusative.pl=детские,*instrumental.sg=детской,*instrumental.pl=детскими,*prepositional.sg=детской,*prepositional.pl=детских
дехканин|sдехкан,nе,p,A,*genitive.sg=дехканина,*dative.sg=дехканину,*accusative.sg=дехканина,*instrumental.sg=дехканином,*prepositional.sg=дехканине
дешевизна|p
деятель|cm,A
деятельница|A
джентльмен|A
джигит|A
джинн|A
джоуль|cm
джунгли|*genitive.sg=джунглей,*dative.sg=джунглям,*instrumental.sg=джунглями,*prepositional.sg=джунглях
дзельква|p
диагност|A
диагностик|A
диаграмма|p
диакон|A
диафрагма|p
диверсант|A
дигамма|p
дизайнер|A
дизель|cm
дикарь|cm,iём,A
дикобраз|A
диктатор|A
диктор|A
дикторша|p,A
дикуша|A
дилемма|p
дилер|A
дилетант|A
дилетантка|A
динозавр|A
дипломант|A
дипломник|A
директор|nа,A
дирижабль|cm
дирижёр|A
дискутант|A
диспашер|A
диспетчер|A
диссидент|A
дистрибьютер|A
дистрибьютор|A
дитё|cm,sдит,iём,nя,pей,S,A,*accusative.sg=дитё
дитёнок|sдитят,nа,p,A,*genitive.sg=дитёнка,*dative.sg=дитёнку,*accusative.sg=дитёнка,*instrumental.sg=дитёнком,*prepositional.sg=дитёнке
дитя|ck,sдет,A,*genitive.sg=дитяти,*dative.sg=дитяти,*instrumental.sg=дитятей,*instrumental.pl=детьми,*prepositional.sg=дитяти
дневальный|nе,A,*genitive.sg=дневального,*genitive.pl=дневальных,*dative.sg=дневальному,*dative.pl=дневальным,*accusative.sg=дневального,*accusative.pl=дневальных,*instrumental.sg=дневальным,*instrumental.pl=дневальными,*prepositional.sg=дневальном,*prepositional.pl=дневальных
днище|cm,sднищ,nа,p
доберман-пинчер|A
доброволец|A
доброжелатель|cm,A
дог|A
догма|p
дож|A
дождь|cm,iём
дознаватель|cm,A
доказательство|cm,sдоказательств,nа,p
докладчик|A
доктор|nа,A
докторишка|A
долбоёб|A
долгоносик|A
долгопят|A
должник|A
должное|cm,*nominative.pl=должные,*genitive.sg=должного,*genitive.pl=должных,*dative.sg=должному,*dative.pl=должным,*accusative.pl=должные,*instrumental.sg=должным,*instrumental.pl=должными,*prepositional.sg=должном,*prepositional.pl=должных
долотцо|cm,sдолотц,nа,*genitive.pl=долотец,*instrumental.sg=долотцом
долька|*genitive.pl=долек
доля|pей
домашние|cm,A,*genitive.sg=домашних,*dative.sg=домашним,*accusative.sg=домашних,*instrumental.sg=домашними,*prepositional.sg=домашних
домбра|p
домбрист|A
домбристка|A
домишко|nы
домище|cm,sдомищ,nа,p
домна|*genitive.pl=домен
домовой|A,*genitive.sg=домового,*dative.sg=домовому,*accusative.sg=домового,*instrumental.sg=домовым,*prepositional.sg=домовом
домохозяин|sдомохозяев,nа,p,A,*genitive.sg=домохозяина,*dative.sg=домохозяину,*accusative.sg=домохозяина,*instrumental.sg=домохозяином,*prepositional.sg=домохозяине
домохозяйка|*genitive.pl=домохозяек
домохозяйство|cm,sдомохозяйств,nа,p
домочадец|A
домысел|sдомысл
донор|A
доносчик|A
донышко|nы
дороговизна|p
доспехи|*genitive.sg=доспехов,*dative.sg=доспехам,*instrumental.sg=доспехами,*prepositional.sg=доспехах
достаток|sдостатк
достоинство|cm,sдостоинств,nа,p
доула|A
доцент|A
доченька|A,*genitive.pl=доченек,*accusative.pl=доченек
дочка|A
дочурка|A
дочь|cm,sдочер,gи,dи,iью,lи,*instrumental.pl=дочерьми
дошколёнок|sдошколят,nа,p,A,*genitive.sg=дошколёнка,*dative.sg=дошколёнку,*accusative.sg=дошколёнка,*instrumental.sg=дошколёнком,*prepositional.sg=дошколёнке
дошкольник|A
доярка|A
дракон|A
драматург|A
драхма|p
древесница|A
древко|cm,sдревк
древлянин|sдревлян,nе,p,A,*genitive.sg=древлянина,*dative.sg=древлянину,*accusative.sg=древлянина,*instrumental.sg=древлянином,*prepositional.sg=древлянине
древнеанглийский|*genitive.sg=древнеанглийского,*dative.sg=древнеанглийскому,*instrumental.sg=древнеанглийским,*prepositional.sg=древнеанглийском
древневерхненемецкий|*nominative.sg=древневерхненемецкого,*genitive.sg=древневерхненемецкому,*instrumental.sg=древневерхненемецким,*prepositional.sg=древневерхненемецком
древнегреческий|*genitive.sg=древнегреческого,*dative.sg=древнегреческому,*instrumental.sg=древнегреческим,*prepositional.sg=древнегреческом
древнерусский|*nominative.sg=древнерусского,*genitive.sg=древнерусскому,*instrumental.sg=древнерусским,*prepositional.sg=древнерусском
древние|cm,A,*genitive.sg=древних,*dative.sg=древним,*accusative.sg=древних,*instrumental.sg=древними,*prepositional.sg=древних
древодел|A
древоеды|A,*genitive.sg=древоедов,*dative.sg=древоедам,*accusative.sg=древоедов,*instrumental.sg=древоедами,*prepositional.sg=древоедах
древоточец|A
древпластики|*genitive.sg=древпластиков,*dative.sg=древпластикам,*instrumental.sg=древпластиками,*prepositional.sg=древпластиках
дреколье|cm,sдреколь,nя,S
дрессировщик|A
дровни|*genitive.sg=дровней,*dative.sg=дровням,*instrumental.sg=дровнями,*prepositional.sg=дровнях
дровосек|A
дрожжи|*genitive.sg=дрожжей,*dative.sg=дрожжам,*instrumental.sg=дрожжами,*prepositional.sg=дрожжах
дрожь|cm,gи,dи,iью,lи,S0
дрозд|A
дромадер|A
дроп|A
дроссель|cm
дрофа|A
дружинник|A
дружище|cm,sдружищ,p,A
дружок|sдружк,A
дубильня|*genitive.pl=дубилен
дубль|cm
дубок|sдубк
дуга|gа,dи,lе,*genitive.pl=дуги,*dative.pl=дуг
дужка|p
дуля|*genitive.pl=дуль
думатель|cm
дунганин|sдунган,nе,p,A,*genitive.sg=дунганина,*dative.sg=дунганину,*accusative.sg=дунганина,*instrumental.sg=дунганином,*prepositional.sg=дунганине
дупель|cm,nя,A
дупло|cf,iом,*genitive.sg=дупло,*genitive.pl=дупла,*dative.sg=дупла,*dative.pl=дупел
дура|A
дурак|A
дурачок|sдурачк,A
дурень|cm,sдурн,A
дурочка|A
духовенство|cm,sдуховенств,nа,p
духовник|A
душеприказчик|A
душка|A
душман|A
дхарма|p
дщерь|A
дыня|*genitive.pl=дынь
дыхальце|cm,sдыхальц,nа,p
дьявол|A
дьяволёнок|sдьяволят,nа,p,A,*genitive.sg=дьяволёнка,*dative.sg=дьяволёнку,*accusative.sg=дьяволёнка,*instrumental.sg=дьяволёнком,*prepositional.sg=дьяволёнке
дьяк|A
дьякон|A
дьячество|cm,sдьячеств,nа,p
дюбель|cm
дяденька|A,*genitive.pl=дяденек,*accusative.pl=дяденек
дядька|A,*genitive.pl=дядек,*accusative.pl=дядек
дядюшка|A
дятел|sдятл,A
ёбарь|cm,A
ебля|*genitive.pl=ебель
евангелист|A
евнух|A
еврейка|A,*genitive.pl=евреек,*accusative.pl=евреек
еврейство|cm,sеврейств,nа,p
европеец|A
европейка|A,*genitive.pl=европеек,*accusative.pl=европеек
егерь|cm,nя,A
египетский|*genitive.sg=египетского,*dative.sg=египетскому,*instrumental.sg=египетским,*prepositional.sg=египетском
египтолог|A
египтянин|sегиптян,nе,p,A,*genitive.sg=египтянина,*dative.sg=египтянину,*accusative.sg=египтянина,*instrumental.sg=египтянином,*prepositional.sg=египтянине
египтянка|A
единоборство|cm,sединоборств,nа,p
единоверец|A
единомышленник|A
единорог|A
единоросс|A
единство|cm,sединств,nа,p
ёж|sеж,*instrumental.sg=ежом
ёжик|A
ежонок|sежат,nа,p,A,*genitive.sg=ежонка,*dative.sg=ежонку,*accusative.sg=ежонка,*instrumental.sg=ежонком,*prepositional.sg=ежонке
езид|A
ектенья|iёй,*genitive.pl=ектений
ельчанин|sельчан,nе,p,A,*genitive.sg=ельчанина,*dative.sg=ельчанину,*accusative.sg=ельчанина,*instrumental.sg=ельчанином,*prepositional.sg=ельчанине
енот|A
епарх|A
епископ|A
епитимья|iёй,*genitive.pl=епитимий
ермолай|A
ёрш|sерш,*instrumental.sg=ершом
есаул|A
ётун|A
ефрейтор|A
ехидна|p,A
жабра|p
жабры|*genitive.sg=жабр,*dative.sg=жабрам,*instrumental.sg=жабрами,*prepositional.sg=жабрах
жаворонок|sжаворонк,A
жадина|A
жажда|gа,*genitive.pl=жажды,*dative.sg=жажды,*dative.pl=жажд
жалейка|*genitive.pl=жалеек
жалованье|cm,sжаловань,nя,S,*genitive.pl=жалований
жандарм|A
жаркое|cm,*nominative.pl=жаркие,*genitive.sg=жаркого,*genitive.pl=жарких,*dative.sg=жаркому,*dative.pl=жарким,*accusative.pl=жаркие,*instrumental.sg=жарким,*instrumental.pl=жаркими,*prepositional.sg=жарком,*prepositional.pl=жарких
жатва|p
жевело|cm,sжевёл,nа,p,*genitive.sg=жевела,*dative.sg=жевелу,*instrumental.sg=жевелом,*prepositional.sg=жевеле
железнодорожник|A
желна|A,*genitive.pl=жёлн,*accusative.pl=жёлн
жёлоб|sжелоб,nа,*genitive.sg=жёлоба,*dative.sg=жёлобу,*instrumental.sg=жёлобом,*prepositional.sg=жёлобе
желток|sжелтк
желудок|sжелудк
жёлудь|cm,*genitive.pl=желудей,*dative.pl=желудям,*instrumental.pl=желудями,*prepositional.pl=желудях
жёлчь|cm,gи,dи,iью,lи,S0
жемчуг|nа
жена|cm,sжён,p,*genitive.sg=жены,*dative.sg=жене,*accusative.sg=жену,*instrumental.sg=женой,*prepositional.sg=жене
женитьба|p
жених|A
женоненавистник|A
женоненавистничество|cm,sженоненавистничеств,nа,p
женьшень|cm
жердь|cm,dи,iью,lи,*genitive.sg=жердь,*genitive.pl=жерди,*dative.pl=жердей
жеребёнок|sжеребят,nа,p,A,*genitive.sg=жеребёнка,*dative.sg=жеребёнку,*accusative.sg=жеребёнка,*instrumental.sg=жеребёнком,*prepositional.sg=жеребёнке
жеребец|A,*genitive.pl=жеребцов,*accusative.pl=жеребцов,*instrumental.sg=жеребцом
жерело|cf,iом,*genitive.sg=жерело,*genitive.pl=жерела,*dative.sg=жерела,*dative.pl=жерел
жерех|nа,A
жерло|cf,iом,*genitive.sg=жерло,*genitive.pl=жерла,*dative.sg=жерла,*dative.pl=жерл
жёрнов|sжернов,nа,*genitive.sg=жёрнова,*dative.sg=жёрнову,*instrumental.sg=жёрновом,*prepositional.sg=жёрнове
живописец|A
животноводство|cm,sживотноводств,nа,p
животное|A,*nominative.pl=животные,*genitive.sg=животного,*genitive.pl=животных,*dative.sg=животному,*dative.pl=животным,*accusative.pl=животных,*instrumental.sg=животным,*instrumental.pl=животными,*prepositional.sg=животном,*prepositional.pl=животных
жид|A
жилец|A,*genitive.pl=жильцов,*accusative.pl=жильцов,*instrumental.sg=жильцом
жилище|cm,sжилищ,nа,p
жиртрест|A
житель|cm,A
жительница|A
жительство|cm,sжительств,nа,p
житьё|iём
жлоб|A
жменя|pей
жнец|sжнец,A,*genitive.pl=жнецов,*accusative.pl=жнецов,*instrumental.sg=жнецом
жнивьё|cm,sжнивь,iём,nя,S
жонглёр|A
жополиз|A
жопошник|A
жрец|sжрец,A,*genitive.pl=жрецов,*accusative.pl=жрецов,*instrumental.sg=жрецом
жук|A
жук-носорог|sжукам-носорог,A,*nominative.pl=жуки-носороги,*genitive.sg=жука-носорога,*genitive.pl=жуков-носорогов,*dative.sg=жуку-носорогу,*accusative.sg=жука-носорога,*accusative.pl=жуков-носорогов,*instrumental.sg=жуком-носорогом,*instrumental.pl=жуками-носорогами,*prepositional.sg=жуке-носороге,*prepositional.pl=жуках-носорогах
жук-олень|cm,sжукам-олен,A,*nominative.pl=жуки-олени,*genitive.sg=жука-оленя,*genitive.pl=жуков-оленей,*dative.sg=жуку-оленю,*accusative.sg=жука-оленя,*accusative.pl=жуков-оленей,*instrumental.sg=жуком-оленем,*instrumental.pl=жуками-оленями,*prepositional.sg=жуке-олене,*prepositional.pl=жуках-оленях
жулик|A
журавль|cm,iём
журналист|A
жучок|sжучк
жэк|nи
забияка|A
забытьё|iём
зав|A
заведующая|cm,A,*nominative.pl=заведующие,*genitive.sg=заведующей,*genitive.pl=заведующих,*dative.sg=заведующей,*dative.pl=заведующим,*accusative.sg=заведующую,*accusative.pl=заведующих,*instrumental.sg=заведующей,*instrumental.pl=заведующими,*prepositional.sg=заведующей,*prepositional.pl=заведующих
завирушка|A
завиток|sзавитк
завод-подрядчик|sзаводам-подрядчик,*nominative.pl=заводы-подрядчики,*genitive.sg=завода-подрядчика,*genitive.pl=заводов-подрядчиков,*dative.sg=заводу-подрядчику,*accusative.pl=заводы-подрядчики,*instrumental.sg=заводом-подрядчиком,*instrumental.pl=заводами-подрядчиками,*prepositional.sg=заводе-подрядчике,*prepositional.pl=заводах-подрядчиках
завоеватель|cm,A
завсегдатай|A
завуч|A
завхоз|A
заговорщик|A
заголовок|sзаголовк
загребчанин|sзагребчан,nе,p,A,*genitive.sg=загребчанина,*dative.sg=загребчанину,*accusative.sg=загребчанина,*instrumental.sg=загребчанином,*prepositional.sg=загребчанине
загривок|sзагривк
загрузка|p
задаток|sзадатк
задворки|*genitive.sg=задворок,*dative.sg=задворкам,*instrumental.sg=задворками,*prepositional.sg=задворках
задира|A
задрот|A
заезжий|A,*genitive.sg=заезжего,*dative.sg=заезжему,*accusative.sg=заезжего,*instrumental.sg=заезжим,*prepositional.sg=заезжем
заём|sзайм
заёмщик|A
заика|A
зайка|*genitive.pl=заек
зайчонок|sзайчат,nа,p,A,*genitive.sg=зайчонка,*dative.sg=зайчонку,*accusative.sg=зайчонка,*instrumental.sg=зайчонком,*prepositional.sg=зайчонке
заказчик|A
законодатель|cm,A
законодательство|cm,sзаконодательств,nа,p
закоулок|sзакоулк
закрылок|sзакрылк
закупорка|p
закусочная|cm,*nominative.pl=закусочные,*genitive.sg=закусочной,*genitive.pl=закусочных,*dative.sg=закусочной,*dative.pl=закусочным,*accusative.sg=закусочную,*accusative.pl=закусочные,*instrumental.sg=закусочной,*instrumental.pl=закусочными,*prepositional.sg=закусочной,*prepositional.pl=закусочных
залежь|cm,gи,dи,iью,lи,S0
заложник|A
зам|A
замешательство|cm,sзамешательств,nа,p
заморозки|*genitive.sg=заморозков,*dative.sg=заморозкам,*instrumental.sg=заморозками,*prepositional.sg=заморозках
заморозок|sзаморозк
замполит|A
зампред|A
замужество|cm,sзамужеств,nа,p
замша|p
замысел|sзамысл
зануда|A
западник|A
западноармянский|*genitive.sg=западноармянского,*dative.sg=западноармянскому,*instrumental.sg=западноармянским,*prepositional.sg=западноармянском
западня|iёй,pей
заполнитель|cm
запуск|nа
запчасти|*genitive.sg=запчастей,*dative.sg=запчастям,*instrumental.sg=запчастями,*prepositional.sg=запчастях
запястье|cm,sзапясть,nя,S,*genitive.pl=запястий
запятая|cm,*nominative.pl=запятые,*genitive.sg=запятой,*genitive.pl=запятых,*dative.sg=запятой,*dative.pl=запятым,*accusative.sg=запятую,*accusative.pl=запятые,*instrumental.sg=запятой,*instrumental.pl=запятыми,*prepositional.sg=запятой,*prepositional.pl=запятых
заработок|sзаработк
зарубежье|cm,sзарубежь,nя,S,*genitive.pl=зарубежий
зарукавье|cm,sзарукавь,nя,S,*genitive.pl=зарукавий
заря|iёй,*nominative.pl=зори,*genitive.pl=зорь,*dative.pl=зорям,*instrumental.pl=зорями,*prepositional.pl=зорях
зарянка|A
заседатель|cm,A
засилье|cm,sзасиль,nя,S,*genitive.pl=засилий
засранец|A
застёжка-молния|cm,sзастёжкам-молни,S,*nominative.pl=застёжки-молнии,*genitive.sg=застёжки-молнии,*genitive.pl=застёжек-молний,*dative.sg=застёжке-молнии,*accusative.sg=застёжку-молнию,*instrumental.sg=застёжкой-молнией,*instrumental.pl=застёжками-молниями,*prepositional.sg=застёжке-молнии,*prepositional.pl=застёжках-молниях
застенок|sзастенк
застолье|cm,sзастоль,nя,S,*genitive.pl=застолий
застройка|*genitive.pl=застроек
застройщик|A
заступник|A
затворник|A
затейник|A
затея|pй
затишье|cm,sзатишь,nя,S,*genitive.pl=затиший
затылок|sзатылк
затылочек|cn,sзатылочк,nы
заутреня|*genitive.pl=заутрень
захватчик|A
захолустье|cm,sзахолусть,nя,S,*genitive.pl=захолустий
зацепер|A
защитник|A
защитница|A
заявитель|cm,A
заявительница|A
заяц|sзайц,A
звезда|cm,sзвёзд,p,*genitive.sg=звезды,*dative.sg=звезде,*accusative.sg=звезду,*instrumental.sg=звездой,*prepositional.sg=звезде
звено|cm,sзвень,nя,S,*genitive.sg=звена,*dative.sg=звену,*instrumental.sg=звеном,*prepositional.sg=звене
зверёк|sзверьк,A
зверёнок|sзверят,nа,p,A,*genitive.sg=зверёнка,*dative.sg=зверёнку,*accusative.sg=зверёнка,*instrumental.sg=зверёнком,*prepositional.sg=зверёнке
зверство|cm,sзверств,nа,p
зверь|cm,A
здоровье|cm,sздоровь,nя,S,*genitive.pl=здоровий
зевака|A
зек|A
зеленушка|A
зеленя|cm,*genitive.sg=зеленей,*dative.sg=зеленям,*instrumental.sg=зеленями,*prepositional.sg=зеленях
зелье|cf,iем,S,*genitive.sg=зелье,*genitive.pl=зелья,*dative.sg=зелья,*dative.pl=зелий
земледелец|A
землекоп|A
земляк|A
землянин|sземлян,nе,p,A,*genitive.sg=землянина,*dative.sg=землянину,*accusative.sg=землянина,*instrumental.sg=землянином,*prepositional.sg=землянине
земноводное|A,*nominative.pl=земноводные,*genitive.sg=земноводного,*genitive.pl=земноводных,*dative.sg=земноводному,*dative.pl=земноводным,*accusative.pl=земноводных,*instrumental.sg=земноводным,*instrumental.pl=земноводными,*prepositional.sg=земноводном,*prepositional.pl=земноводных
земство|cm,sземств,nа,p
зенитчик|A
зеркальце|cm,sзеркальц,nа,*genitive.pl=зеркалец
зерно|cf,iом,*genitive.sg=зерно,*genitive.pl=зёрна,*dative.sg=зерна,*dative.pl=зёрен,*instrumental.pl=зёрнами,*prepositional.pl=зёрнах
зёрнышко|nы
зимовщик|A
зимородок|sзимородк,A
златоуст|A
злодей|A
злодейка|A,*genitive.pl=злодеек,*accusative.pl=злодеек
злодейство|cm,sзлодейств,nа,p
злорадство|cm,sзлорадств,nа,p
злотый|nе,*genitive.sg=злотого,*genitive.pl=злотых,*dative.sg=злотому,*dative.pl=злотым,*instrumental.sg=злотым,*instrumental.pl=злотыми,*prepositional.sg=злотом,*prepositional.pl=злотых
злоумышленник|A
змеёнок|sзмеят,nа,p,A,*genitive.sg=змеёнка,*dative.sg=змеёнку,*accusative.sg=змеёнка,*instrumental.sg=змеёнком,*prepositional.sg=змеёнке
змеёныш|A
знакомая|cm,A,*nominative.pl=знакомые,*genitive.sg=знакомой,*genitive.pl=знакомых,*dative.sg=знакомой,*dative.pl=знакомым,*accusative.sg=знакомую,*accusative.pl=знакомых,*instrumental.sg=знакомой,*instrumental.pl=знакомыми,*prepositional.sg=знакомой,*prepositional.pl=знакомых
знакомец|A
знакомство|cm,sзнакомств,nа,p
знаменатель|cm
знаток|A
значок|sзначк
зодчество|cm,sзодчеств,nа,p
зодчий|nе,A,*genitive.sg=зодчего,*genitive.pl=зодчих,*dative.sg=зодчему,*dative.pl=зодчим,*accusative.sg=зодчего,*accusative.pl=зодчих,*instrumental.sg=зодчим,*instrumental.pl=зодчими,*prepositional.sg=зодчем,*prepositional.pl=зодчих
золовка|A
золотоискатель|cm,A
зоолог|A
зрачок|sзрачк
зрелище|cm,sзрелищ,nа,p
зритель|cm,A
зубец|*genitive.pl=зубцов,*instrumental.sg=зубцом
зубр|A
зурна|p
зырянин|sзырян,nе,p,A,*genitive.sg=зырянина,*dative.sg=зырянину,*accusative.sg=зырянина,*instrumental.sg=зырянином,*prepositional.sg=зырянине
зэк|A
зяблик|A
ибис|A
иволга|p,A
игла|p
игра|p
игрок|A
игуана|A
игумен|A
игуменья|A,*genitive.pl=игумений,*accusative.pl=игумений
идеалист|A
идеограмма|p
идеолог|A
идея|pй
идиот|A
идиотка|A
идол|A
идолопоклонник|A
иезуит|A
иерарх|A
иеромонах|A
изба|p
изба-читальня|cm,sизбам-читальн,S,*nominative.pl=избы-читальни,*genitive.sg=избы-читальни,*genitive.pl=изб-читален,*dative.sg=избе-читальне,*accusative.sg=избу-читальню,*accusative.pl=избы-читальни,*instrumental.sg=избой-читальней,*instrumental.pl=избами-читальнями,*prepositional.sg=избе-читальне,*prepositional.pl=избах-читальнях
избавитель|cm,A
избиратель|cm,A
избранник|A
избыток|sизбытк
изверг|A
извозчик|A
изгнанник|A
изгой|A
изголовье|cm,sизголовь,nя,S,*genitive.pl=изголовий
изготовитель|cm,A
издатель|cm,A
издательница|A
издательство|cm,sиздательств,nа,p
издевательство|cm,sиздевательств,nа,p
излишек|sизлишк
излишество|cm,sизлишеств,nа,p
изменник|A
изобретатель|cm,A
изогипса|p
изотерма|p
израильтянин|sизраильтян,nе,p,A,*genitive.sg=израильтянина,*dative.sg=израильтянину,*accusative.sg=израильтянина,*instrumental.sg=израильтянином,*prepositional.sg=израильтянине
израильтянка|A
изящество|cm,sизяществ,nа,p
икра|p
имам|A
имбецил|A
имбирь|cm,iём
именинник|A
именины|*genitive.sg=именин,*dative.sg=именинам,*instrumental.sg=именинами,*prepositional.sg=именинах
имитатор|A
иммигрант|A
иммигрантка|A
император|A
императрица|A
империалист|A
импортёр|A
импотент|A
импрессионист|A
импровизатор|A
имущество|cm,sимуществ,nа,p
имя-отчество|cm,sименам-отчеств,*nominative.pl=имена-отчества,*genitive.sg=имени-отчества,*genitive.pl=имён-отчеств,*dative.sg=имени-отчеству,*accusative.pl=имена-отчества,*instrumental.sg=именем-отчеством,*instrumental.pl=именами-отчествами,*prepositional.sg=имени-отчестве,*prepositional.pl=именах-отчествах
инвалид|A
инвалидка|A
инвентарь|cm,iём
инвестор|A
ингуш|A,*instrumental.sg=ингушом
индеец|A
индейка|*genitive.pl=индеек
индианка|A
индивид|A
индивидуум|A
индиец|A
индоевропеец|A
индолог|A
индонезиец|A
индонезийка|A,*genitive.pl=индонезиек,*accusative.pl=индонезиек
индус|A
индюк|A
индюшка|A
индюшонок|sиндюшат,nа,p,A,*genitive.sg=индюшонка,*dative.sg=индюшонку,*accusative.sg=индюшонка,*instrumental.sg=индюшонком,*prepositional.sg=индюшонке
инженер|A
инициатор|A
инкассатор|A
инквизитор|A
инкуб|A
иноверец|A
инок|A
инопланетянин|sинопланетян,nе,p,A,*genitive.sg=инопланетянина,*dative.sg=инопланетянину,*accusative.sg=инопланетянина,*instrumental.sg=инопланетянином,*prepositional.sg=инопланетянине
инопланетянка|A
инородец|A
иностранец|A
иностранка|A
инспектор|A
инструктор|A
интеллектуал|A
интеллигент|A
интеллигентка|A
интервьюер|A
интернационалист|A
интернист|A
интурист|A
иорданец|A
иосифлянин|sиосифлян,nе,p,A,*genitive.sg=иосифлянина,*dative.sg=иосифлянину,*accusative.sg=иосифлянина,*instrumental.sg=иосифлянином,*prepositional.sg=иосифлянине
иранец|A
иранка|A
иркутянин|sиркутян,nе,p,A,*genitive.sg=иркутянина,*dative.sg=иркутянину,*accusative.sg=иркутянина,*instrumental.sg=иркутянином,*prepositional.sg=иркутянине
ирландец|A
ирландка|A
ирландский|*genitive.sg=ирландского,*dative.sg=ирландскому,*instrumental.sg=ирландским,*prepositional.sg=ирландском
ирха|p
искатель|cm
искра|p
искусство|cm,sискусств,nа,p
искусствовед|A
исландец|A
исландка|A
исландский|*genitive.sg=исландского,*dative.sg=исландскому,*instrumental.sg=исландским,*prepositional.sg=исландском
испанец|A
испанка|A
исповедальня|*genitive.pl=исповедален
исповедник|A
исполин|A
исполнитель|cm,A
исполнительница|A
исправник|A
испытатель|cm,A
исследовательница|A
истец|A,*genitive.pl=истцов,*accusative.pl=истцов,*instrumental.sg=истцом
историк|A
истребитель|cm
истребитель-бомбардировщик|sистребителям-бомбардировщик,*nominative.pl=истребители-бомбардировщики,*genitive.sg=истребителя-бомбардировщика,*genitive.pl=истребителей-бомбардировщиков,*dative.sg=истребителю-бомбардировщику,*accusative.pl=истребители-бомбардировщики,*instrumental.sg=истребителем-бомбардировщиком,*instrumental.pl=истребителями-бомбардировщиками,*prepositional.sg=истребителе-бомбардировщике,*prepositional.pl=истребителях-бомбардировщиках
итальянец|A
итальянка|A
итальяшка|A
иудей|A
ихтиолог|A
ишак|A
ишхан|A
ищейка|A,*genitive.pl=ищеек,*accusative.pl=ищеек
июль|cm
июнь|cm
йотун|A
кабан|A
кабарга|A
кабель|cm
каблучок|sкаблучк
кавалер|A
кавалергард|A
кавказец|A
кавказско-албанский|*genitive.sg=кавказско-албанского,*dative.sg=кавказско-албанскому,*instrumental.sg=кавказско-албанским,*prepositional.sg=кавказско-албанском
кавычки|*genitive.sg=кавычек,*dative.sg=кавычкам,*instrumental.sg=кавычками,*prepositional.sg=кавычках
кагебешник|A
казарма|p
казах|A
казачество|cm,sказачеств,nа,p
казачок|sказачк
казачонок|sказачат,nа,p,A,*genitive.sg=казачонка,*dative.sg=казачонку,*accusative.sg=казачонка,*instrumental.sg=казачонком,*prepositional.sg=казачонке
казашка|A
казна|p
каин|A
кайма|*genitive.pl=каём
кайман|A
калач|*instrumental.sg=калачом
калаш|*instrumental.sg=калашом
калашников|*genitive.pl=калашниковых,*dative.pl=калашниковым,*instrumental.sg=калашниковым,*instrumental.pl=калашниковыми,*prepositional.pl=калашниковых
калека|A
календарь|cm,iём
калиф|A
калкан|A
калмык|A
калужанин|sкалужан,nе,p,A,*genitive.sg=калужанина,*dative.sg=калужанину,*accusative.sg=калужанина,*instrumental.sg=калужанином,*prepositional.sg=калужанине
калька|*genitive.pl=калек
кальмар|A
кальсоны|*genitive.sg=кальсон,*dative.sg=кальсонам,*instrumental.sg=кальсонами,*prepositional.sg=кальсонах
камбала|A
камбаловые|cm,A,*genitive.sg=камбаловых,*dative.sg=камбаловым,*accusative.sg=камбаловых,*instrumental.sg=камбаловыми,*prepositional.sg=камбаловых
камбалообразные|cm,A,*genitive.sg=камбалообразных,*dative.sg=камбалообразным,*accusative.sg=камбалообразных,*instrumental.sg=камбалообразными,*prepositional.sg=камбалообразных
камбоджиец|A
камбоджийка|A,*genitive.pl=камбоджиек,*accusative.pl=камбоджиек
каменолом|A
каменщик|A
камень|cm,sкамн
камергер|A
камердинер|A
камеристка|A
камешек|sкамешк
камлейка|*genitive.pl=камлеек
камушек|sкамушк
камыш|*instrumental.sg=камышом
камышница|A
канадец|A
канадка|A
канарейка|A,*genitive.pl=канареек,*accusative.pl=канареек
кандалы|*genitive.sg=кандалов,*dative.sg=кандалам,*instrumental.sg=кандалами,*prepositional.sg=кандалах
кандидат|A
канистра|p
каннибал|A
кантонский|*nominative.sg=кантонского,*genitive.sg=кантонскому,*instrumental.sg=кантонским,*prepositional.sg=кантонском
канцлер|A
канюк|A
капелла|p
капеллан|A
капелька|*genitive.pl=капелек
капиталист|A
капитан|A
капище|cm,sкапищ,nа,p
капли|*genitive.sg=капель,*dative.sg=каплям,*instrumental.sg=каплями,*prepositional.sg=каплях
капля|*genitive.pl=капель
капоэйра|p
каппа|p
капрал|A
капсель|cm
капсюль|cm
капуста|p
каракал|A
каракатица|A
каракуля|pей
карамболь|cm
карамель|cm
карандаш|*instrumental.sg=карандашом
карапуз|A
карась|cm,iём,A
каратель|cm,A
караульный|A,*genitive.sg=караульного,*dative.sg=караульному,*accusative.sg=караульного,*instrumental.sg=караульным,*prepositional.sg=караульном
караульня|*genitive.pl=караулен
карга|p,A
кардинал|A
кардиолог|A
карикатурист|A
карлик|A
карлица|A
карма|p
карманник|A
карповые|cm,A,*genitive.sg=карповых,*dative.sg=карповым,*accusative.sg=карповых,*instrumental.sg=карповыми,*prepositional.sg=карповых
карпообразные|cm,A,*genitive.sg=карпообразных,*dative.sg=карпообразным,*accusative.sg=карпообразных,*instrumental.sg=карпообразными,*prepositional.sg=карпообразных
карта|p
картёжник|A
картечь|cm,gи,dи,iью,lи,S0
картограф|A
карты|*genitive.sg=карт,*dative.sg=картам,*instrumental.sg=картами,*prepositional.sg=картах
карфагенянин|sкарфагенян,nе,p,A,*genitive.sg=карфагенянина,*dative.sg=карфагенянину,*accusative.sg=карфагенянина,*instrumental.sg=карфагенянином,*prepositional.sg=карфагенянине
карьерист|A
карьеристка|A
каскадёр|A
касса|p
кассир|A
кассирша|p
каста|p
кастрюлька|*genitive.pl=кастрюлек
кастрюля|*genitive.pl=кастрюль
каталанский|*nominative.sg=каталанского,*genitive.sg=каталанскому,*instrumental.sg=каталанским,*prepositional.sg=каталанском
катанок|cn,sкатанк,nы
катаракта|p
катер|nа
катерист|A
катерище|cm,sкатерищ,nа,p
катерник|A
катерок|sкатерк
катеростроитель|cm,A
катерочек|cn,sкатерочк,nы
каток|sкатк
католик|A
каторга|p
каторжанин|sкаторжан,nе,p,A,*genitive.sg=каторжанина,*dative.sg=каторжанину,*accusative.sg=каторжанина,*instrumental.sg=каторжанином,*prepositional.sg=каторжанине
кафедра|p
кафель|cm
кацап|A
качели|*genitive.sg=качелей,*dative.sg=качелям,*instrumental.sg=качелями,*prepositional.sg=качелях
качество|cm,sкачеств,nа,p
качок|sкачк,A
кашалот|A
кашель|cm,sкашл
кварта|p
квартирохозяин|sквартирохозяев,nа,p,A,*genitive.sg=квартирохозяина,*dative.sg=квартирохозяину,*accusative.sg=квартирохозяина,*instrumental.sg=квартирохозяином,*prepositional.sg=квартирохозяине
квасцы|*genitive.sg=квасцов,*dative.sg=квасцам,*instrumental.sg=квасцами,*prepositional.sg=квасцах
кегля|pей
кельнер|A
кельня|*genitive.pl=келен
келья|*genitive.pl=келий
кенгурёнок|sкенгурят,nа,p,A,*genitive.sg=кенгурёнка,*dative.sg=кенгурёнку,*accusative.sg=кенгурёнка,*instrumental.sg=кенгурёнком,*prepositional.sg=кенгурёнке
кент|A
кентавр|A
керосинщик|A
керосинщица|A
кефаль|A
кивер|nа
кивок|sкивк
киевлянин|sкиевлян,nе,p,A,*genitive.sg=киевлянина,*dative.sg=киевлянину,*accusative.sg=киевлянина,*instrumental.sg=киевлянином,*prepositional.sg=киевлянине
кижуч|A
кий|pёв
кикимора|A
киллер|A
киловольт-ампер|p
киль|cm
килька|A,*genitive.pl=килек,*accusative.pl=килек
кинематографист|A
кинозвезда|cm,sкинозвёзд,p,A,*genitive.sg=кинозвезды,*dative.sg=кинозвезде,*accusative.sg=кинозвезду,*instrumental.sg=кинозвездой,*prepositional.sg=кинозвезде
кинорежиссёр|A
киносъёмка|p
кинофестиваль|cm
киприот|A
киприотка|A
кипчак|A
киргиз|A
киргизка|A
кирза|p
кирпич|*instrumental.sg=кирпичом
киса|A
кисель|cm,iём
киска|A
кистень|cm,iём
кит|A
китаёза|A
китаец|A
китайчонок|sкитайчат,nа,p,A,*genitive.sg=китайчонка,*dative.sg=китайчонку,*accusative.sg=китайчонка,*instrumental.sg=китайчонком,*prepositional.sg=китайчонке
китаянка|A
китель|cm
китёнок|sкитят,nа,p,A,*genitive.sg=китёнка,*dative.sg=китёнку,*accusative.sg=китёнка,*instrumental.sg=китёнком,*prepositional.sg=китёнке
китоврас|A
китолов|A
кишка|*genitive.pl=кишок
клад|*genitive.sg=клад,*genitive.pl=клады,*dative.sg=клада,*dative.pl=кладов
кладбище|cm,sкладбищ,nа,p
кладовая|cm,*nominative.pl=кладовые,*genitive.sg=кладовой,*genitive.pl=кладовых,*dative.sg=кладовой,*dative.pl=кладовым,*accusative.sg=кладовую,*accusative.pl=кладовые,*instrumental.sg=кладовой,*instrumental.pl=кладовыми,*prepositional.sg=кладовой,*prepositional.pl=кладовых
кларнетист|A
клеветник|A
клеврет|A
клеймо|cm,sклейм,nа,p
клепсидра|p
клептоман|A
клептоманка|A
клерк|A
клешня|iёй,pей
клещ|A,*instrumental.sg=клещом
кливер|nа
клиент|A
клизма|p
кликун|A
клин|nья,*genitive.pl=клиньев,*dative.pl=клиньям,*instrumental.pl=клиньями,*prepositional.pl=клиньях
клинкер|nа
клинок|sклинк
клинчанин|sклинчан,nе,p,A,*genitive.sg=клинчанина,*dative.sg=клинчанину,*accusative.sg=клинчанина,*instrumental.sg=клинчанином,*prepositional.sg=клинчанине
клирошанин|sклирошан,nе,p,A,*genitive.sg=клирошанина,*dative.sg=клирошанину,*accusative.sg=клирошанина,*instrumental.sg=клирошанином,*prepositional.sg=клирошанине
клок|sклочь,nя,S,*genitive.sg=клока,*dative.sg=клоку,*instrumental.sg=клоком,*prepositional.sg=клоке
клоп|A
клоун|A
клочок|sклочк
клубень|cm,sклубн
клубок|sклубк
клумба|p
клюква|p
клякса|p
клятва|p
кляча|A
княгиня|A,*genitive.pl=княгинь,*accusative.pl=княгинь
княжество|cm,sкняжеств,nа,p
княжна|A,*genitive.pl=княжон,*accusative.pl=княжон
коала|A
коалёнок|sкоалят,nа,p,A,*genitive.sg=коалёнка,*dative.sg=коалёнку,*accusative.sg=коалёнка,*instrumental.sg=коалёнком,*prepositional.sg=коалёнке
кобель|cm,iём,A
кобза|p
кобра|p,A
кобылка|A
коварство|cm,sковарств,nа,p
ковбой|A
ковбойка|*genitive.pl=ковбоек
ковёр|sковр
ковёр-самолёт|sковрам-самолёт,*nominative.pl=ковры-самолёты,*genitive.sg=ковра-самолёта,*genitive.pl=ковров-самолётов,*dative.sg=ковру-самолёту,*accusative.pl=ковры-самолёты,*instrumental.sg=ковром-самолётом,*instrumental.pl=коврами-самолётами,*prepositional.sg=ковре-самолёте,*prepositional.pl=коврах-самолётах
ковш|*instrumental.sg=ковшом
коготь|cm,sкогт
когтище|cm,sкогтищ,p
кодла|p
козёл|sкозл
козерог|A
козлёнок|sкозлят,nа,p,A,*genitive.sg=козлёнка,*dative.sg=козлёнку,*accusative.sg=козлёнка,*instrumental.sg=козлёнком,*prepositional.sg=козлёнке
козопас|A
козырёк|sкозырьк
козырь|cm
койка|*genitive.pl=коек
койот|A
кокарда|p
кокетка|A
кокетство|cm,sкокетств,nа,p
кокиль|cm,nя
коктейль|cm
колба|p
колдун|A
колдунья|A,*genitive.pl=колдуний,*accusative.pl=колдуний
колёсико|cm,sколёсик
колесо|cm,sколёс,nа,p,*genitive.sg=колеса,*dative.sg=колесу,*instrumental.sg=колесом,*prepositional.sg=колесе
колечко|nы
колея|iёй,pй
количество|cm,sколичеств,nа,p
коллекционер|A
колокол|nа
колокольня|*genitive.pl=колоколен
колонизатор|A
колонист|A
колонна|p
колонок|sколонк,A
колос|nья,*genitive.pl=колосьев,*dative.pl=колосьям,*instrumental.pl=колосьями,*prepositional.pl=колосьях
колхозник|A
колыбельная|cm,*nominative.pl=колыбельные,*genitive.sg=колыбельной,*genitive.pl=колыбельных,*dative.sg=колыбельной,*dative.pl=колыбельным,*accusative.sg=колыбельную,*instrumental.sg=колыбельной,*instrumental.pl=колыбельными,*prepositional.sg=колыбельной,*prepositional.pl=колыбельных
колымка|p
колымчанин|sколымчан,nе,p,A,*genitive.sg=колымчанина,*dative.sg=колымчанину,*accusative.sg=колымчанина,*instrumental.sg=колымчанином,*prepositional.sg=колымчанине
колышек|sколышк
кольцо|cm,sкольц,nа,*genitive.pl=колец,*instrumental.sg=кольцом
колюшка|A
команда|p
командир|A
командировочный|A,*genitive.sg=командировочного,*dative.sg=командировочному,*accusative.sg=командировочного,*instrumental.sg=командировочным,*prepositional.sg=командировочном
командор|A
командующий|A,*genitive.sg=командующего,*dative.sg=командующему,*accusative.sg=командующего,*instrumental.sg=командующим,*prepositional.sg=командующем
команчский|*genitive.sg=команчского,*dative.sg=команчскому,*instrumental.sg=команчским,*prepositional.sg=команчском
комар|A
комбат|A
комдив|A
комендант|A
коми-зырянин|sкоми-зырян,nе,p,A,*genitive.sg=коми-зырянина,*dative.sg=коми-зырянину,*accusative.sg=коми-зырянина,*instrumental.sg=коми-зырянином,*prepositional.sg=коми-зырянине
комик|A
комиссар|A
комиссионер|A
комментатор|A
коммерсант|A
коммунар|A
коммунист|A
коммунистка|A
комок|sкомк
коморец|A
коморский|*genitive.sg=коморского,*dative.sg=коморскому,*instrumental.sg=коморским,*prepositional.sg=коморском
комочек|sкомочк
компаньон|A
компаньонка|A
комплектующие|cm,*genitive.sg=комплектующих,*dative.sg=комплектующим,*instrumental.sg=комплектующими,*prepositional.sg=комплектующих
композитор|A
компоновка|p
комсомолец|A
комсомолка|A
конвоир|A
кондитерская|cm,*nominative.pl=кондитерские,*genitive.sg=кондитерской,*genitive.pl=кондитерских,*dative.sg=кондитерской,*dative.pl=кондитерским,*accusative.sg=кондитерскую,*accusative.pl=кондитерские,*instrumental.sg=кондитерской,*instrumental.pl=кондитерскими,*prepositional.sg=кондитерской,*prepositional.pl=кондитерских
кондуктор|nа,A
кондырь|cm
конёк|sконьк
конкурент|A
конопля|iёй,pей
консерватор|A
консигнатор|A
конспиратор|A
константа|p
констебль|cm,A
консул|A
консульство|cm,sконсульств,nа,p
консультант|A
консультантка|A
контрабанда|p
контролёр|A
контроль|cm
контрольная|cm,*nominative.pl=контрольные,*genitive.sg=контрольной,*genitive.pl=контрольных,*dative.sg=контрольной,*dative.pl=контрольным,*accusative.sg=контрольную,*accusative.pl=контрольные,*instrumental.sg=контрольной,*instrumental.pl=контрольными,*prepositional.sg=контрольной,*prepositional.pl=контрольных
контрреволюционер|A
конунг|A
концлагерь|cm,nя
коньячок|sконьячк
конюх|A
координатор|A
копейка|*genitive.pl=копеек
копёр|sкопр
копна|*genitive.pl=копён
коптилка|p
коптильня|*genitive.pl=коптилен
копыл|nья,*genitive.pl=копыльев,*dative.pl=копыльям,*instrumental.pl=копыльями,*prepositional.pl=копыльях
копьё|cm,sкопь,iём,nя,S,*genitive.pl=копий
корабел|A
корабль|cm,iём
кореец|A
кореш|A
корешок|sкорешк
кореянка|A
корж|*instrumental.sg=коржом
корзно|cm,sкорзн,nа,*genitive.pl=корзен
коридорный|A,*genitive.sg=коридорного,*dative.sg=коридорному,*accusative.sg=коридорного,*instrumental.sg=коридорным,*prepositional.sg=коридорном
коринфянин|sкоринфян,nе,p,A,*genitive.sg=коринфянина,*dative.sg=коринфянину,*accusative.sg=коринфянина,*instrumental.sg=коринфянином,*prepositional.sg=коринфянине
корифей|A
кормилец|A
корневище|cm,sкорневищ,nа,p
короб|nа
коробейник|A
коровка|A
королевич|A
королевство|cm,sкоролевств,nа,p
королёк|sкорольк
коромысло|cm,sкоромысл,nа,p
коротышка|p,A
корреспондент|A
коррупционер|A
корточки|*genitive.sg=корточек,*dative.sg=корточкам,*instrumental.sg=корточками,*prepositional.sg=корточках
корча|pей
коршун|A
корюшка|p,A
косарь|cm,sкосарь,iём
косец|A,*genitive.pl=косцов,*accusative.pl=косцов,*instrumental.sg=косцом
космонавт|A
космополит|A
космы|*genitive.sg=косм,*dative.sg=космам,*instrumental.sg=космами,*prepositional.sg=космах
костёр|sкостр
кострец|sкострец,*genitive.pl=кострецов,*instrumental.sg=кострецом
костромской|A,*genitive.sg=костромского,*dative.sg=костромскому,*accusative.sg=костромского,*instrumental.sg=костромским,*prepositional.sg=костромском
костыль|cm,iём
косуля|A,*genitive.pl=косуль,*accusative.pl=косуль
кот|A
котдивуарец|A
котёл|sкотл
котелок|sкотелк
котельная|cm,*nominative.pl=котельные,*genitive.sg=котельной,*genitive.pl=котельных,*dative.sg=котельной,*dative.pl=котельным,*accusative.sg=котельную,*accusative.pl=котельные,*instrumental.sg=котельной,*instrumental.pl=котельными,*prepositional.sg=котельной,*prepositional.pl=котельных
котёнок|sкотят,nа,p,A,*genitive.sg=котёнка,*dative.sg=котёнку,*accusative.sg=котёнка,*instrumental.sg=котёнком,*prepositional.sg=котёнке
котяра|A
коуч|A
кофейня|*genitive.pl=кофеен
кофта|p
кочевник|A
кочегар|A
кочерга|*genitive.pl=кочерёг
кочкарь|cm,iём,A
кошелёк|sкошельк
кошечка|A
кощунство|cm,sкощунств,nа,p
краб|A
краешек|sкраешк
кракозябра|p
кракозябры|*genitive.sg=кракозябр,*dative.sg=кракозябрам,*instrumental.sg=кракозябрами,*prepositional.sg=кракозябрах
краниолог|A
красавец|A
красавчик|A
красильня|*genitive.pl=красилен
краситель|cm
красноармеец|A
краснобай|A
красногвардеец|A
красноярец|A
красноярка|A
красотка|A
креатура|A
кредитор|A
крейсер|nа
кремень|cm,sкремн,iём
кремлебот|A
кремль|cm,iём
кремлядь|A
крендель|cm
крепостничество|cm,sкрепостничеств,nа,p
крепостной|A,*genitive.sg=крепостного,*dative.sg=крепостному,*accusative.sg=крепостного,*instrumental.sg=крепостным,*prepositional.sg=крепостном
крепостца|*genitive.pl=крепостец,*instrumental.sg=крепостцой
кресло|cm,sкресл,nа,*genitive.pl=кресел
крёстная|cm,A,*nominative.pl=крёстные,*genitive.sg=крёстной,*genitive.pl=крёстных,*dative.sg=крёстной,*dative.pl=крёстным,*accusative.sg=крёстную,*accusative.pl=крёстных,*instrumental.sg=крёстной,*instrumental.pl=крёстными,*prepositional.sg=крёстной,*prepositional.pl=крёстных
крестник|A
крестница|A
крестьянин|A,*nominative.pl=крестьяне,*genitive.pl=крестьян,*dative.pl=крестьянам,*instrumental.pl=крестьянами,*prepositional.pl=крестьянах
крестьянка|A
крестьянство|cm,sкрестьянств,nа,p
кретин|A
кривая|cm,*nominative.pl=кривые,*genitive.sg=кривой,*genitive.pl=кривых,*dative.sg=кривой,*dative.pl=кривым,*accusative.sg=кривую,*accusative.pl=кривые,*instrumental.sg=кривой,*instrumental.pl=кривыми,*prepositional.sg=кривой,*prepositional.pl=кривых
кривда|p
криминалист|A
криминолог|A
крипта|p
критянин|sкритян,nе,p,A,*genitive.sg=критянина,*dative.sg=критянину,*accusative.sg=критянина,*instrumental.sg=критянином,*prepositional.sg=критянине
кровля|*genitive.pl=кровель
крокозябра|p
кролик|A
крольчиха|A
крольчонок|sкрольчат,nа,p,A,*genitive.sg=крольчонка,*dative.sg=крольчонку,*accusative.sg=крольчонка,*instrumental.sg=крольчонком,*prepositional.sg=крольчонке
кросна|cm,*genitive.sg=кросен,*dative.sg=кроснам,*instrumental.sg=кроснами,*prepositional.sg=кроснах
крот|A
кружевце|cm,sкружевц,nа,*genitive.pl=кружевец
кружок|sкружк
кружочек|sкружочк
крылечко|nы
крылышко|nы
крыльцо|cm,sкрыльц,nа,*genitive.pl=крылец,*instrumental.sg=крыльцом
крымскотатарский|*genitive.sg=крымскотатарского,*dative.sg=крымскотатарскому,*instrumental.sg=крымскотатарским,*prepositional.sg=крымскотатарском
крымчанин|sкрымчан,nе,p,A,*genitive.sg=крымчанина,*dative.sg=крымчанину,*accusative.sg=крымчанина,*instrumental.sg=крымчанином,*prepositional.sg=крымчанине
крыса|A
крысёнок|sкрысят,nа,p,A,*genitive.sg=крысёнка,*dative.sg=крысёнку,*accusative.sg=крысёнка,*instrumental.sg=крысёнком,*prepositional.sg=крысёнке
крючок|sкрючк
ксёндз|sксендз,A
кубинец|A
кубинка|A
кубок|sкубк
кувалда|p
кудри|*genitive.sg=кудрей,*dative.sg=кудрям,*instrumental.sg=кудрями,*prepositional.sg=кудрях
кузен|A
кузина|A
кузнец|sкузнец,A,*genitive.pl=кузнецов,*accusative.pl=кузнецов,*instrumental.sg=кузнецом
кузнечик|A
кузов|nа
кузьма|p,A
кукабара|A
куклёнок|sкуклят,nа,p,A,*genitive.sg=куклёнка,*dative.sg=куклёнку,*accusative.sg=куклёнка,*instrumental.sg=куклёнком,*prepositional.sg=куклёнке
куколь|cm
кулачок|sкулачк
кулёк|sкульк
кулуары|*genitive.sg=кулуаров,*dative.sg=кулуарам,*instrumental.sg=кулуарами,*prepositional.sg=кулуарах
культпросветучилище|cm,sкультпросветучилищ,nа,p
культурист|A
кумжа|p,A
куница|A
купальня|*genitive.pl=купален
купанье|cm,sкупань,nя,S,*genitive.pl=купаний
купец|A,*genitive.pl=купцов,*accusative.pl=купцов,*instrumental.sg=купцом
купля|*genitive.pl=купель
купля-продажа|cm,sкуплям-продаж,*nominative.pl=купли-продажи,*genitive.sg=купли-продажи,*genitive.pl=купель-продаж,*dative.sg=купле-продаже,*accusative.sg=куплю-продажу,*accusative.pl=купли-продажи,*instrumental.sg=куплей-продажей,*instrumental.pl=куплями-продажами,*prepositional.sg=купле-продаже,*prepositional.pl=куплях-продажах
купол|nа
купчая|cm,*nominative.pl=купчие,*genitive.sg=купчей,*genitive.pl=купчих,*dative.sg=купчей,*dative.pl=купчим,*accusative.sg=купчую,*accusative.pl=купчие,*instrumental.sg=купчей,*instrumental.pl=купчими,*prepositional.sg=купчей,*prepositional.pl=купчих
кураж|*instrumental.sg=куражом
куратор|A
курва|p,A
курд|A
курильчанин|sкурильчан,nе,p,A,*genitive.sg=курильчанина,*dative.sg=курильчанину,*accusative.sg=курильчанина,*instrumental.sg=курильчанином,*prepositional.sg=курильчанине
курильщик|A
курица|cm,sкур,p,*genitive.sg=курицы,*dative.sg=курице,*accusative.sg=курицу,*instrumental.sg=курицей,*prepositional.sg=курице
куркуль|cm,iём,A
курок|sкурк
куропатка|A
курсант|A
курсиха|A
куртизанка|A
курьер|A
курянин|sкурян,nе,p,A,*genitive.sg=курянина,*dative.sg=курянину,*accusative.sg=курянина,*instrumental.sg=курянином,*prepositional.sg=курянине
курящий|*nominative.sg=курящего,*genitive.sg=курящему,*instrumental.sg=курящим,*prepositional.sg=курящем
кусок|sкуск
кусочек|sкусочк
кутёж|sкутеж,*instrumental.sg=кутежом
кутила|A
кухарка|A
кухня|*genitive.pl=кухонь
кухонька|*genitive.pl=кухонек
кучер|nа,A
кшатрия|pев,A
кыпчак|A
лаборант|A
лабрадор-ретривер|sлабрадорам-ретривер,A,*nominative.pl=лабрадоры-ретриверы,*genitive.sg=лабрадора-ретривера,*genitive.pl=лабрадоров-ретриверов,*dative.sg=лабрадору-ретриверу,*accusative.sg=лабрадора-ретривера,*accusative.pl=лабрадоров-ретриверов,*instrumental.sg=лабрадором-ретривером,*instrumental.pl=лабрадорами-ретриверами,*prepositional.sg=лабрадоре-ретривере,*prepositional.pl=лабрадорах-ретриверах
лаваш|*instrumental.sg=лавашом
лавра|p
лагерь|cm,nя
ладоши|*genitive.sg=ладош,*dative.sg=ладошам,*instrumental.sg=ладошами,*prepositional.sg=ладошах
лазанья|*genitive.pl=лазаний
лазейка|*genitive.pl=лазеек
лазутчик|A
лакедемонянин|sлакедемонян,nе,p,A,*genitive.sg=лакедемонянина,*dative.sg=лакедемонянину,*accusative.sg=лакедемонянина,*instrumental.sg=лакедемонянином,*prepositional.sg=лакедемонянине
лакей|A
лакомка|A
лакомство|cm,sлакомств,nа,p
лакса|p
ламантин|A
лампа|p
лампочка|p
лангобард|A
лангуст|A
ландграф|A
ланка|A
лань|A
лаосец|A
лаоска|A
лаотянин|sлаотян,nе,p,A,*genitive.sg=лаотянина,*dative.sg=лаотянину,*accusative.sg=лаотянина,*instrumental.sg=лаотянином,*prepositional.sg=лаотянине
лапоть|cm,sлапт
лапша|pей,*instrumental.sg=лапшой
ларёк|sларьк
ласта|p
латимерия|A
латинист|A
латинянин|sлатинян,nе,p,A,*genitive.sg=латинянина,*dative.sg=латинянину,*accusative.sg=латинянина,*instrumental.sg=латинянином,*prepositional.sg=латинянине
латыш|A,*instrumental.sg=латышом
латышка|A
латышский|*genitive.sg=латышского,*dative.sg=латышскому,*instrumental.sg=латышским,*prepositional.sg=латышском
лауреат|A
лгун|A
лебедёнок|sлебедят,nа,p,A,*genitive.sg=лебедёнка,*dative.sg=лебедёнку,*accusative.sg=лебедёнка,*instrumental.sg=лебедёнком,*prepositional.sg=лебедёнке
левак|A
левантинец|A
левша|pей,A,*instrumental.sg=левшой
легенда|p
легионер|A
легкоатлет|A
легкоатлетка|A
лёгкое|cm,*nominative.pl=лёгкие,*genitive.sg=лёгкого,*genitive.pl=лёгких,*dative.sg=лёгкому,*dative.pl=лёгким,*instrumental.sg=лёгким,*instrumental.pl=лёгкими,*prepositional.sg=лёгком,*prepositional.pl=лёгких
легкотня|iёй
леденец|*genitive.pl=леденцов,*instrumental.sg=леденцом
леер|nа
лейб-кучер|A
лейка|*genitive.pl=леек
лейтенант|A
лекарство|cm,sлекарств,nа,p
лекарь|cm,A
лексикограф|A
лексиколог|A
лектор|A
лемех|nа
лемма|p
лемур|A
ленивец|A
ленинградец|A
ленинец|A
лента|p
лентяй|A
леопард|A
лепесток|sлепестк
лепёшка|p
лепта|p
лесовод|A
лесопильня|*genitive.pl=лесопилен
лесопосадки|*genitive.sg=лесопосадок,*dative.sg=лесопосадкам,*instrumental.sg=лесопосадками,*prepositional.sg=лесопосадках
лесопромышленник|A
лесоруб|A
лесотундра|p
лесоустройство|cm,sлесоустройств,nа,p
лётчик|A
леший|nе,A,*genitive.sg=лешего,*genitive.pl=леших,*dative.sg=лешему,*dative.pl=лешим,*accusative.sg=лешего,*accusative.pl=леших,*instrumental.sg=лешим,*instrumental.pl=лешими,*prepositional.sg=лешем,*prepositional.pl=леших
лещ|*instrumental.sg=лещом
лжец|sлжец,A,*genitive.pl=лжецов,*accusative.pl=лжецов,*instrumental.sg=лжецом
либерал|A
либераст|A
ливанец|A
ливень|cm,sливн
ливиец|A
ливийка|A,*genitive.pl=ливиек,*accusative.pl=ливиек
ливрея|pй
лидер|A
лидерство|cm,sлидерств,nа,p
лизоблюд|A
лилипут|A
лимфа|p
лингвист|A
линейка|*genitive.pl=линеек
линза|p
лис|A
лисель|cm
лисёнок|sлисят,nа,p,A,*genitive.sg=лисёнка,*dative.sg=лисёнку,*accusative.sg=лисёнка,*instrumental.sg=лисёнком,*prepositional.sg=лисёнке
лисица|A
листок|sлистк
листочек|sлисточк
литавра|p
литавры|*genitive.sg=литавр,*dative.sg=литаврам,*instrumental.sg=литаврами,*prepositional.sg=литаврах
литератор|A
литературовед|A
литовец|A
литовка|A
литовский|*genitive.sg=литовского,*dative.sg=литовскому,*instrumental.sg=литовским,*prepositional.sg=литовском
литьё|iём
лихва|p
лиходейка|A,*genitive.pl=лиходеек,*accusative.pl=лиходеек
лицемер|A
лицемерка|A
лицензиар|A
лицензиат|A
личико|cm,sличик
личинка|A
лишнее|cm,*nominative.pl=лишние,*genitive.sg=лишнего,*genitive.pl=лишних,*dative.sg=лишнему,*dative.pl=лишним,*accusative.pl=лишние,*instrumental.sg=лишним,*instrumental.pl=лишними,*prepositional.sg=лишнем,*prepositional.pl=лишних
лобок|sлобк
лоботряс|A
лобстер|A
ловелас|A
ловкач|A,*instrumental.sg=ловкачом
ловля|*genitive.pl=ловель
лодырь|cm,A
локоть|cm,sлокт
ломака|A
ломоть|cm,sломт,iём
лондонец|A
лондонка|A
лоно|cf,iом,*genitive.sg=лоно,*genitive.pl=лона,*dative.sg=лона,*dative.pl=лон
лопаточка|p
лорд|A
лососёвые|cm,A,*genitive.sg=лососёвых,*dative.sg=лососёвым,*accusative.sg=лососёвых,*instrumental.sg=лососёвыми,*prepositional.sg=лососёвых
лососеобразные|cm,A,*genitive.sg=лососеобразных,*dative.sg=лососеобразным,*accusative.sg=лососеобразных,*instrumental.sg=лососеобразными,*prepositional.sg=лососеобразных
лосось|cm,A
лось|cm,A
лотарингец|A
лотерея|pй
лоток|sлотк
лохмотья|cm,*genitive.sg=лохмотьев,*dative.sg=лохмотьям,*instrumental.sg=лохмотьями,*prepositional.sg=лохмотьях
лошадка|A
лошадь|cm,gи,dи,iью,lи,*instrumental.pl=лошадьми
лошак|A
луб|nья,*genitive.pl=лубьев,*dative.pl=лубьям,*instrumental.pl=лубьями,*prepositional.pl=лубьях
лужайка|*genitive.pl=лужаек
лужичанин|sлужичан,nе,p,A,*genitive.sg=лужичанина,*dative.sg=лужичанину,*accusative.sg=лужичанина,*instrumental.sg=лужичанином,*prepositional.sg=лужичанине
лузер|A
лук-порей|sлукам-поре,*nominative.pl=луки-пореи,*genitive.sg=лука-порея,*genitive.pl=луков-пореев,*dative.sg=луку-порею,*accusative.pl=луки-пореи,*instrumental.sg=луком-пореем,*instrumental.pl=луками-пореями,*prepositional.sg=луке-порее,*prepositional.pl=луках-пореях
лукавство|cm,sлукавств,nа,p
лучник|A
лучница|A
лучшее|cm,*nominative.pl=лучшие,*genitive.sg=лучшего,*genitive.pl=лучших,*dative.sg=лучшему,*dative.pl=лучшим,*accusative.pl=лучшие,*instrumental.sg=лучшим,*instrumental.pl=лучшими,*prepositional.sg=лучшем,*prepositional.pl=лучших
лыжник|A
лыжня|iёй,pей
лыко|cm,sлык,p
львёнок|sльвят,nа,p,A,*genitive.sg=львёнка,*dative.sg=львёнку,*accusative.sg=львёнка,*instrumental.sg=львёнком,*prepositional.sg=львёнке
льнопрядильня|*genitive.pl=льнопрядилен
льносемя|cm,sльносемен,gи,dи,iем,lи,nа,*genitive.pl=льносемян
льстец|sльстец,A,*genitive.pl=льстецов,*accusative.pl=льстецов,*instrumental.sg=льстецом
любимая|cm,A,*nominative.pl=любимые,*genitive.sg=любимой,*genitive.pl=любимых,*dative.sg=любимой,*dative.pl=любимым,*accusative.sg=любимую,*accusative.pl=любимых,*instrumental.sg=любимой,*instrumental.pl=любимыми,*prepositional.sg=любимой,*prepositional.pl=любимых
любимец|A
любитель|cm,A
любительница|A
любовник|A
любопытство|cm,sлюбопытств,nа,p
людишки|A,*genitive.sg=людишек,*dative.sg=людишкам,*accusative.sg=людишек,*instrumental.sg=людишками,*prepositional.sg=людишках
людоед|A
люлька|*genitive.pl=люлек
люстра|p
лютеранин|sлютеран,nе,p,A,*genitive.sg=лютеранина,*dative.sg=лютеранину,*accusative.sg=лютеранина,*instrumental.sg=лютеранином,*prepositional.sg=лютеранине
люцерна|p
лягушонок|sлягушат,nа,p,A,*genitive.sg=лягушонка,*dative.sg=лягушонку,*accusative.sg=лягушонка,*instrumental.sg=лягушонком,*prepositional.sg=лягушонке
лядвея|pй
лярва|p,A
мавр|A
маг|A
магараджа|pей,A
магистр|A
магма|p
магнат|A
магометанин|sмагометан,nе,p,A,*genitive.sg=магометанина,*dative.sg=магометанину,*accusative.sg=магометанина,*instrumental.sg=магометанином,*prepositional.sg=магометанине
мадемуазель|A
мадмуазель|A
мадонна|p,A
мадьяр|A
мазло|cm,sмазл,A,*accusative.sg=мазло
мазня|iёй,pей
мазок|sмазк
майка|*genitive.pl=маек
майор|A
макака|A
макарошки|*genitive.sg=макарошек,*dative.sg=макарошкам,*instrumental.sg=макарошками,*prepositional.sg=макарошках
македонец|A
македонка|A
македонянин|sмакедонян,nе,p,A,*genitive.sg=македонянина,*dative.sg=македонянину,*accusative.sg=македонянина,*instrumental.sg=македонянином,*prepositional.sg=македонянине
маклер|A
макрель|A
малаец|A
малайзиец|A
малайзийка|A,*genitive.pl=малайзиек,*accusative.pl=малайзиек
малайка|A,*genitive.pl=малаек,*accusative.pl=малаек
маланга|p
малиец|A
малийка|A,*genitive.pl=малиек,*accusative.pl=малиек
малое|cm,*nominative.pl=малые,*genitive.sg=малого,*genitive.pl=малых,*dative.sg=малому,*dative.pl=малым,*accusative.pl=малые,*instrumental.sg=малым,*instrumental.pl=малыми,*prepositional.sg=малом,*prepositional.pl=малых
малолетка|A
малороссиянин|sмалороссиян,nе,p,A,*genitive.sg=малороссиянина,*dative.sg=малороссиянину,*accusative.sg=малороссиянина,*instrumental.sg=малороссиянином,*prepositional.sg=малороссиянине
малыш|A,*instrumental.sg=малышом
малышок|sмалышк,A
мальва|p
мальтиец|A
мальтийка|A,*genitive.pl=мальтиек,*accusative.pl=мальтиек
мальтийский|*genitive.sg=мальтийского,*dative.sg=мальтийскому,*instrumental.sg=мальтийским,*prepositional.sg=мальтийском
мальчик|A
мальчишка|A
малютка|A
малявка|A
маляр|A
мамаша|A
мамка|A
мамонт|A
манатки|*genitive.sg=манаток,*dative.sg=манаткам,*instrumental.sg=манатками,*prepositional.sg=манатках
манда|p
мандрил|A
манекенщица|A
мансарда|p
мантра|p
маньяк|A
маримба|p
маркграф|A
марксизм-ленинизм|*genitive.sg=марксизма-ленинизма,*dative.sg=марксизму-ленинизму,*instrumental.sg=марксизмом-ленинизмом,*prepositional.sg=марксизме-ленинизме
марксист|A
марля|pей
мародёр|A
марокканец|A
марсель|cm
марсианин|sмарсиан,nе,p,A,*genitive.sg=марсианина,*dative.sg=марсианину,*accusative.sg=марсианина,*instrumental.sg=марсианином,*prepositional.sg=марсианине
мартышка|A
маршал|A
маслобойка|*genitive.pl=маслобоек
маслобойня|*genitive.pl=маслобоен
маслодельня|*genitive.pl=маслоделен
масон|A
масонство|cm,sмасонств,nа,p
масса|p
мастер|nа,A
мастерица|A
мастерок|sмастерк
мастерская|cm,*nominative.pl=мастерские,*genitive.sg=мастерской,*genitive.pl=мастерских,*dative.sg=мастерской,*dative.pl=мастерским,*accusative.sg=мастерскую,*instrumental.sg=мастерской,*instrumental.pl=мастерскими,*prepositional.sg=мастерской,*prepositional.pl=мастерских
мастодонт|A
материалист|A
материнство|cm,sматеринств,nа,p
матерщинник|A
матерь|A
мати|ck,sматер,A
матрос|A
матросня|iёй,pей
матушка|A
мать|cm,sматер,gи,dи,iью,lи
мать-одиночка|cm,sматерям-одиночк,A,*nominative.pl=матери-одиночки,*genitive.sg=матери-одиночки,*genitive.pl=матерей-одиночек,*dative.sg=матери-одиночке,*accusative.sg=мать-одиночку,*accusative.pl=матерей-одиночек,*instrumental.sg=матерью-одиночкой,*instrumental.pl=матерями-одиночками,*prepositional.sg=матери-одиночке,*prepositional.pl=матерях-одиночках
маца|*instrumental.sg=мацой
мачеха|A
мачта|p
машинист|A
машинистка|A
маячок|sмаячк
мгла|gа,*genitive.pl=мглы,*dative.sg=мглы
мгновенье|cm,sмгновень,nя,S,*genitive.pl=мгновений
медведица|A
медведь|cm,A
медвежатник|A
медвежонок|sмедвежат,nа,p,A,*genitive.sg=медвежонка,*dative.sg=медвежонку,*accusative.sg=медвежонка,*instrumental.sg=медвежонком,*prepositional.sg=медвежонке
медиевист|A
медик|A
медиум|A
медсестра|*nominative.pl=медсёстры,*genitive.pl=медсестёр,*dative.pl=медсёстрам,*instrumental.pl=медсёстрами,*prepositional.pl=медсёстрах
медянка|p,A
межа|pей,*instrumental.sg=межой
мелочь|cm,gи,dи,iью,lи,S0
мельник|A
мельтешня|iёй,pей
мемуары|*genitive.sg=мемуаров,*dative.sg=мемуарам,*instrumental.sg=мемуарами,*prepositional.sg=мемуарах
менеджер|A
менестрель|cm,A
мент|A
ментор|A
меньшевик|A
меньшинство|cm,sменьшинств,nа,p
мера|gа,*genitive.pl=меры,*dative.sg=меры,*dative.pl=мер
мергель|cm
мерзавец|A
мерзляк|A
мертвец|sмертвец,A,*genitive.pl=мертвецов,*accusative.pl=мертвецов,*instrumental.sg=мертвецом
мессия|A
местечко|nы
место|cm,sмест,nа,p
местожительство|cm,sместожительств,nа,p
месячные|cm,*genitive.sg=месячных,*dative.sg=месячным,*instrumental.sg=месячными,*prepositional.sg=месячных
металлург|A
метеоролог|A
метла|*nominative.pl=мётлы,*genitive.pl=мётел,*dative.pl=мётлам,*instrumental.pl=мётлами,*prepositional.pl=мётлах
методист|A
механизатор|A
меценат|A
меч|*instrumental.sg=мечом
мечта|*genitive.pl=мечтаний
мечтатель|cm,A
мешок|sмешк
мешочек|sмешочк
мещанинишка|A
мещанка|A
мещанство|cm,sмещанств,nа,p
миг|nи
мигрант|A
мидянин|sмидян,nе,p,A,*genitive.sg=мидянина,*dative.sg=мидянину,*accusative.sg=мидянина,*instrumental.sg=мидянином,*prepositional.sg=мидянине
микроампер|p
микроб|A
микроволна|p
микрокатер|nа
микросекунда|p
милашка|A
милая|cm,A,*nominative.pl=милые,*genitive.sg=милой,*genitive.pl=милых,*dative.sg=милой,*dative.pl=милым,*accusative.sg=милую,*accusative.pl=милых,*instrumental.sg=милой,*instrumental.pl=милыми,*prepositional.sg=милой,*prepositional.pl=милых
милиционер|A
миллиампер|p
миллиардер|A
миллионер|A
миллисекунда|p
милорд|A
милостыня|*genitive.pl=милостынь
миля|*genitive.pl=миль
мина|gа,*genitive.pl=мины,*dative.sg=мины,*dative.pl=мин
мина-ловушка|cm,sминам-ловушк,*nominative.pl=мины-ловушки,*genitive.sg=мины-ловушки,*genitive.pl=мин-ловушек,*dative.sg=мине-ловушке,*accusative.sg=мину-ловушку,*accusative.pl=мины-ловушки,*instrumental.sg=миной-ловушкой,*instrumental.pl=минами-ловушками,*prepositional.sg=мине-ловушке,*prepositional.pl=минах-ловушках
миндаль|cm,iём
минералог|A
минетчик|A
министерство|cm,sминистерств,nа,p
министр|A
минога|A
минчанин|sминчан,nе,p,A,*genitive.sg=минчанина,*dative.sg=минчанину,*accusative.sg=минчанина,*instrumental.sg=минчанином,*prepositional.sg=минчанине
минчанка|A
миньетчик|A
мираж|*instrumental.sg=миражом
миротворец|A
мирра|p
мирянин|sмирян,nе,p,A,*genitive.sg=мирянина,*dative.sg=мирянину,*accusative.sg=мирянина,*instrumental.sg=мирянином,*prepositional.sg=мирянине
миссионер|A
мистер|A
мистик|A
митрополит|A
мичман|A
мишка|A
мишка|A
младенец|A
младенчество|cm,sмладенчеств,nа,p
млекопитающее|cm,*genitive.sg=млекопитающее,*genitive.pl=млекопитающие,*dative.sg=млекопитающего,*dative.pl=млекопитающих,*instrumental.sg=млекопитающим,*instrumental.pl=млекопитающими,*prepositional.sg=млекопитающем,*prepositional.pl=млекопитающих
мненье|cm,sмнень,nя,S,*genitive.pl=мнений
многобожец|A
множество|cm,sмножеств,nа,p
множимое|cm,*nominative.pl=множимые,*genitive.sg=множимого,*genitive.pl=множимых,*dative.sg=множимому,*dative.pl=множимым,*accusative.pl=множимые,*instrumental.sg=множимым,*instrumental.pl=множимыми,*prepositional.sg=множимом,*prepositional.pl=множимых
множитель|cm
моавитянин|sмоавитян,nе,p,A,*genitive.sg=моавитянина,*dative.sg=моавитянину,*accusative.sg=моавитянина,*instrumental.sg=моавитянином,*prepositional.sg=моавитянине
мовешка|A
могиканин|sмогикан,nе,p,A,*genitive.sg=могиканина,*dative.sg=могиканину,*accusative.sg=могиканина,*instrumental.sg=могиканином,*prepositional.sg=могиканине
могущество|cm,sмогуществ,nа,p
модельер|A
модератор|A
моджахед|A
модистка|A
модуль|cm
мозжечок|sмозжечк
мойка|*genitive.pl=моек
мокасин|p
мокрица|A
мокшанин|sмокшан,nе,p,A,*genitive.sg=мокшанина,*dative.sg=мокшанину,*accusative.sg=мокшанина,*instrumental.sg=мокшанином,*prepositional.sg=мокшанине
молдаванин|sмолдаван,nе,p,A,*genitive.sg=молдаванина,*dative.sg=молдаванину,*accusative.sg=молдаванина,*instrumental.sg=молдаванином,*prepositional.sg=молдаванине
молдаванка|A
молдавский|*genitive.sg=молдавского,*dative.sg=молдавскому,*instrumental.sg=молдавским,*prepositional.sg=молдавском
молебен|sмолебн
молельня|*genitive.pl=молелен
моллюск|A
молодожён|A
молодчик|A
молодчина|A
молоканин|sмолокан,nе,p,A,*genitive.sg=молоканина,*dative.sg=молоканину,*accusative.sg=молоканина,*instrumental.sg=молоканином,*prepositional.sg=молоканине
молоток|sмолотк
молофья|iёй
молчун|A
мольба|p
монах|A
монахиня|A,*genitive.pl=монахинь,*accusative.pl=монахинь
монашество|cm,sмонашеств,nа,p
монашка|A
монгол|A
монголка|A
монгольский|*genitive.sg=монгольского,*dative.sg=монгольскому,*instrumental.sg=монгольским,*prepositional.sg=монгольском
моногород|nа
монокль|cm
монополист|A
монополька|*genitive.pl=монополек
монстр|A
монтаж|*instrumental.sg=монтажом
мопс|A
моралист|A
морда|p
морж|A,*instrumental.sg=моржом
мормон|A
мороженое|cm,*nominative.pl=мороженые,*genitive.sg=мороженого,*genitive.pl=мороженых,*dative.sg=мороженому,*dative.pl=мороженым,*instrumental.sg=мороженым,*instrumental.pl=морожеными,*prepositional.sg=мороженом,*prepositional.pl=мороженых
моряк|A
москаль|cm,iём,A
москвитянин|sмосквитян,nе,p,A,*genitive.sg=москвитянина,*dative.sg=москвитянину,*accusative.sg=москвитянина,*instrumental.sg=москвитянином,*prepositional.sg=москвитянине
москвич|*instrumental.sg=москвичом
москвичка|A
москит|A
мостовая|cm,*nominative.pl=мостовые,*genitive.sg=мостовой,*genitive.pl=мостовых,*dative.sg=мостовой,*dative.pl=мостовым,*accusative.sg=мостовую,*instrumental.sg=мостовой,*instrumental.pl=мостовыми,*prepositional.sg=мостовой,*prepositional.pl=мостовых
мот|A
мотель|cm
мотня|iёй,pей
мотылёк|sмотыльк,A
мохны|*genitive.sg=мохон,*dative.sg=мохнам,*instrumental.sg=мохнами,*prepositional.sg=мохнах
моча|*instrumental.sg=мочой
мошенник|A
мошенничество|cm,sмошенничеств,nа,p
мошна|*genitive.pl=мошон
мститель|cm,A
мстительница|A
мудак|A
мудо|cm,sмуд,gа,dу,iом,nе,pей,S
мудоёб|A
мудрец|sмудрец,A,*genitive.pl=мудрецов,*accusative.pl=мудрецов,*instrumental.sg=мудрецом
мужеложец|A
мужеложство|cm,sмужеложств,nа,p
мужененавистничество|cm,sмужененавистничеств,nа,p
мужество|cm,sмужеств,nа,p
мужик|A
мужичок|sмужичк,A
мужская|pй
муза|A
музыкант|A
мукомольня|*genitive.pl=мукомолен
мул|A
мулла|p,A
мумиё|cm,sмуми,iём,lе,nя,pй,S
муравей|sмуравь,iём,pёв
муравьед|A
мурзик|A
мурманчанин|sмурманчан,nе,p,A,*genitive.sg=мурманчанина,*dative.sg=мурманчанину,*accusative.sg=мурманчанина,*instrumental.sg=мурманчанином,*prepositional.sg=мурманчанине
мусульманин|sмусульман,nе,p,A,*genitive.sg=мусульманина,*dative.sg=мусульманину,*accusative.sg=мусульманина,*instrumental.sg=мусульманином,*prepositional.sg=мусульманине
мусульманство|cm,sмусульманств,nа,p
мутант|A
муфель|cm
муфлон|A
муфта|p
муфтий|A
мухлёж|sмухлеж,*instrumental.sg=мухлежом
мученик|A
мученица|A
мучитель|cm,A
мучительница|A
мушкель|cm
мушкетёр|A
муэдзин|A
мыслитель|cm,A
мытьё|iём
мышонок|sмышат,nа,p,A,*genitive.sg=мышонка,*dative.sg=мышонку,*accusative.sg=мышонка,*instrumental.sg=мышонком,*prepositional.sg=мышонке
мышоночек|cf,sмышатк,A,*genitive.sg=мышоночка,*dative.sg=мышоночку,*accusative.sg=мышоночка,*instrumental.sg=мышоночком,*prepositional.sg=мышоночке
мышца|p
мышь|cm,gи,dи,iью,lи,S0
мэр|A
мэтр|A
мямля|pей,A
мясник|A
мясохладобойня|*genitive.pl=мясохладобоен
мятеж|*instrumental.sg=мятежом
мятежник|A
мяч|*instrumental.sg=мячом
набережная|cm,*nominative.pl=набережные,*genitive.sg=набережной,*genitive.pl=набережных,*dative.sg=набережной,*dative.pl=набережным,*accusative.sg=набережную,*instrumental.sg=набережной,*instrumental.pl=набережными,*prepositional.sg=набережной,*prepositional.pl=набережных
наблюдатель|cm,A
набросок|sнаброск
навигатор|A
наводчик|A
нагайка|*genitive.pl=нагаек
нагель|cm
нагорье|cm,sнагорь,nя,S,*genitive.pl=нагорий
надежда|p
надзиратель|cm,A
надстройка|*genitive.pl=надстроек
наездник|A
наём|sнайм
наёмник|A
назареянин|sназареян,nе,p,A,*genitive.sg=назареянина,*dative.sg=назареянину,*accusative.sg=назареянина,*instrumental.sg=назареянином,*prepositional.sg=назареянине
назианзец|A
найдёныш|A
наклейка|*genitive.pl=наклеек
наковальня|*genitive.pl=наковален
налим|A
наличные|cm,*genitive.sg=наличных,*dative.sg=наличным,*instrumental.sg=наличными,*prepositional.sg=наличных
налоговик|A
налогоплательщик|A
наместник|A
намибиец|A
наниматель|cm,A
нанимательница|A
наносекунда|p
нападающий|A,*genitive.sg=нападающего,*dative.sg=нападающему,*accusative.sg=нападающего,*instrumental.sg=нападающим,*prepositional.sg=нападающем
нападки|*genitive.sg=нападок,*dative.sg=нападкам,*instrumental.sg=нападками,*prepositional.sg=нападках
напарник|A
напарница|A
напёрсток|sнапёрстк
напиток|sнапитк
нарком|A
наркоман|A
наркоманка|A
народ-богоносец|sнародам-богоносц,*nominative.pl=народы-богоносцы,*genitive.sg=народа-богоносца,*genitive.pl=народов-богоносцев,*dative.sg=народу-богоносцу,*accusative.pl=народы-богоносцы,*instrumental.sg=народом-богоносцем,*instrumental.pl=народами-богоносцами,*prepositional.sg=народе-богоносце,*prepositional.pl=народах-богоносцах
народишко|nы
народник|A
наручни|*genitive.sg=наручней,*dative.sg=наручням,*instrumental.sg=наручнями,*prepositional.sg=наручнях
наручники|*genitive.sg=наручников,*dative.sg=наручникам,*instrumental.sg=наручниками,*prepositional.sg=наручниках
нарушитель|cm,A
нарушительница|A
насекомое|A,*nominative.pl=насекомые,*genitive.sg=насекомого,*genitive.pl=насекомых,*dative.sg=насекомому,*dative.pl=насекомым,*accusative.pl=насекомых,*instrumental.sg=насекомым,*instrumental.pl=насекомыми,*prepositional.sg=насекомом,*prepositional.pl=насекомых
насильник|A
насильница|A
наследник|A
наследница|A
наследство|cm,sнаследств,nа,p
насосная|cm,*nominative.pl=насосные,*genitive.sg=насосной,*genitive.pl=насосных,*dative.sg=насосной,*dative.pl=насосным,*accusative.sg=насосную,*accusative.pl=насосные,*instrumental.sg=насосной,*instrumental.pl=насосными,*prepositional.sg=насосной,*prepositional.pl=насосных
наставник|A
наставница|A
настойка|*genitive.pl=настоек
настоятель|cm,A
настоятельница|A
настоящее|cm,*genitive.sg=настоящего,*dative.sg=настоящему,*instrumental.sg=настоящим,*prepositional.sg=настоящем
настройка|*genitive.pl=настроек
настройщик|A
натурал|A
натыльник|A
науатль|cm
наушник|A
наушники|*genitive.sg=наушников,*dative.sg=наушникам,*instrumental.sg=наушниками,*prepositional.sg=наушниках
нахал|A
нахальство|cm,sнахальств,nа,p
нахлебник|A
нахлебница|A
националист|A
нацист|A
нацистка|A
начальник|A
начальница|A
начальство|cm,sначальств,nа,p
начинающий|A,*genitive.sg=начинающего,*dative.sg=начинающему,*accusative.sg=начинающего,*instrumental.sg=начинающим,*prepositional.sg=начинающем
наяда|A
небеса|cm,*genitive.sg=небес,*dative.sg=небесам,*instrumental.sg=небесами,*prepositional.sg=небесах
небо|cm,sнебес,nа,p,*genitive.sg=неба,*dative.sg=небу,*instrumental.sg=небом,*prepositional.sg=небе
небожитель|cm,A
невежа|A
невежда|p,A
невежество|cm,sневежеств,nа,p
неверующая|cm,A,*nominative.pl=неверующие,*genitive.sg=неверующей,*genitive.pl=неверующих,*dative.sg=неверующей,*dative.pl=неверующим,*accusative.sg=неверующую,*accusative.pl=неверующих,*instrumental.sg=неверующей,*instrumental.pl=неверующими,*prepositional.sg=неверующей,*prepositional.pl=неверующих
невеста|p
невестка|A
невмешательство|cm,sневмешательств,nа,p
невод|nа
невольник|A
неволя|*genitive.pl=неволь
негодяй|A
негритос|A
негритянка|A
неделька|*genitive.pl=неделек
неделя|*genitive.pl=недель
недоброе|cm,*nominative.pl=недобрые,*genitive.sg=недоброго,*genitive.pl=недобрых,*dative.sg=недоброму,*dative.pl=недобрым,*accusative.pl=недобрые,*instrumental.sg=недобрым,*instrumental.pl=недобрыми,*prepositional.sg=недобром,*prepositional.pl=недобрых
недоброжелатель|cm,A
недовольство|cm,sнедовольств,nа,p
недостаток|sнедостатк
недра|cm,*genitive.sg=недр,*dative.sg=недрам,*instrumental.sg=недрами,*prepositional.sg=недрах
недруг|A
незнакомец|A
незнакомка|A
некромант|A
некрополь|cm
некрофил|A
нелегал|A
нелегалка|A
нелюбовь|cm,sнелюбв,gи,dи,lи,*instrumental.sg=нелюбовью
нелюдь|cm,A
немец|A
немка|A
немногое|cm,*nominative.pl=немногие,*genitive.sg=немногого,*genitive.pl=немногих,*dative.sg=немногому,*dative.pl=немногим,*accusative.pl=немногие,*instrumental.sg=немногим,*instrumental.pl=немногими,*prepositional.sg=немногом,*prepositional.pl=немногих
немощь|cm,gи,dи,iью,lи,S0
ненастье|cm,sненасть,nя,S,*genitive.pl=ненастий
ненец|A
неонацист|A
неофашист|A
непокорство|cm,sнепокорств,nа,p
непоседа|A
неправда|p
неприятель|cm,A
неприятельница|A
неравенство|cm,sнеравенств,nа,p
неровня|pей,A
нерпа|p
нерусский|A,*genitive.sg=нерусского,*dative.sg=нерусскому,*accusative.sg=нерусского,*instrumental.sg=нерусским,*prepositional.sg=нерусском
несовершенство|cm,sнесовершенств,nа,p
несторианство|cm,sнесторианств,nа,p
нестяжатель|cm,A
несчастье|cm,sнесчасть,nя,S,*genitive.pl=несчастий
нетопырь|cm,iём,A
неудачник|A
неудобство|cm,sнеудобств,nа,p
неуч|A
нефтепродукт|sнфтепродукт,*nominative.sg=нфтепродукт,*accusative.sg=нфтепродукт
нефтяник|A
нивхка|A
ниггер|A
нигилист|A
нидерландец|A
нидерландка|A
нидерландский|*nominative.sg=нидерландского,*genitive.sg=нидерландскому,*instrumental.sg=нидерландским,*prepositional.sg=нидерландском
никель|cm
никонианин|sникониан,nе,p,A,*genitive.sg=никонианина,*dative.sg=никонианину,*accusative.sg=никонианина,*instrumental.sg=никонианином,*prepositional.sg=никонианине
нимфа|p,A
нимфоманка|A
ниппель|cm
ничтожество|cm,sничтожеств,nа,p
ничья|*genitive.sg=ничьей,*genitive.pl=ничьих,*dative.sg=ничьей,*dative.pl=ничьим,*instrumental.pl=ничьими,*prepositional.sg=ничьей,*prepositional.pl=ничьих
новатор|A
новаторство|cm,sноваторств,nа,p
новелла|p
новенький|A,*genitive.sg=новенького,*dative.sg=новенькому,*accusative.sg=новенького,*instrumental.sg=новеньким,*prepositional.sg=новеньком
новиаль|cm
новичок|sновичк,A
новоангличанин|sновоангличан,nе,p,A,*genitive.sg=новоангличанина,*dative.sg=новоангличанину,*accusative.sg=новоангличанина,*instrumental.sg=новоангличанином,*prepositional.sg=новоангличанине
новобранец|A
новогреческий|*genitive.sg=новогреческого,*dative.sg=новогреческому,*instrumental.sg=новогреческим,*prepositional.sg=новогреческом
новое|cm,*nominative.pl=новые,*genitive.sg=нового,*genitive.pl=новых,*dative.sg=новому,*dative.pl=новым,*accusative.pl=новые,*instrumental.sg=новым,*instrumental.pl=новыми,*prepositional.sg=новом,*prepositional.pl=новых
новозеландец|A
новозеландка|A
новорождённый|A,*genitive.sg=новорождённого,*dative.sg=новорождённому,*accusative.sg=новорождённого,*instrumental.sg=новорождённым,*prepositional.sg=новорождённом
новоселье|cm,sновосель,nя,S,*genitive.pl=новоселий
новости|*genitive.sg=новостей,*dative.sg=новостям,*instrumental.sg=новостями,*prepositional.sg=новостях
новостройка|*genitive.pl=новостроек
новшество|cm,sновшеств,nа,p
ноготок|sноготк
ноготочек|sноготочк
ноготь|cm,sногт
нож|*instrumental.sg=ножом
ноженька|*genitive.pl=ноженек
ножны|*genitive.sg=ножен,*dative.sg=ножнам,*instrumental.sg=ножнами,*prepositional.sg=ножнах
ноздря|iёй,pей
нойон|A
номад|A
номер|nа
нонконформист|A
норвежец|A
норвежка|A
норвежский|*nominative.sg=норвежского,*genitive.sg=норвежскому,*instrumental.sg=норвежским,*prepositional.sg=норвежском
норма|p
носач|A,*instrumental.sg=носачом
носилки|*genitive.sg=носилок,*dative.sg=носилкам,*instrumental.sg=носилками,*prepositional.sg=носилках
носильщик|A
носитель|cm
носок|sноск
носорог|A
носуха|A
нотариус|A
ноябрь|cm,iём
нуб|A
нудист|A
нужда|p
нукер|A
нумизмат|A
нутрия|A
нытик|A
нытьё|iём
ньюйоркец|A
нюня|pей,A
нюхач|A,*instrumental.sg=нюхачом
нянька|A,*genitive.pl=нянек,*accusative.pl=нянек
няня|*genitive.pl=нянь
обаим|A
обакша|p,A
обатур|A
обвинитель|cm,A
обвиняемый|*nominative.sg=обвиняемого,*genitive.sg=обвиняемому,*instrumental.sg=обвиняемым,*prepositional.sg=обвиняемом
обезболивающее|A,*nominative.pl=обезболивающие,*genitive.sg=обезболивающего,*genitive.pl=обезболивающих,*dative.sg=обезболивающему,*dative.pl=обезболивающим,*accusative.pl=обезболивающих,*instrumental.sg=обезболивающим,*instrumental.pl=обезболивающими,*prepositional.sg=обезболивающем,*prepositional.pl=обезболивающих
обезьянка|A
обезьяночеловек|A,*nominative.pl=обезьянолюди,*genitive.pl=обезьянолюдей,*dative.pl=обезьянолюдям,*accusative.pl=обезьянолюдей,*instrumental.pl=обезьянолюдьми,*prepositional.pl=обезьянолюдях
обжа|pей
обжора|A
обидчик|A
обиталище|cm,sобиталищ,nа,p
обитатель|cm,A
обладатель|cm,A
облако|cm,sоблак,nа
облачко|cm,sоблачк,nа
обличье|cm,sобличь,nя,S,*genitive.pl=обличий
обломок|sобломк
обманщик|A
обогреватель|cm
обод|nья,*genitive.pl=ободьев,*dative.pl=ободьям,*instrumental.pl=ободьями,*prepositional.pl=ободьях
обожатель|cm,A
обожательница|A
обозреватель|cm
обойки|*genitive.sg=обоек,*dative.sg=обойкам,*instrumental.sg=обойками,*prepositional.sg=обойках
обойма|p
оборотень|cm,sоборотн,A
образец|*genitive.pl=образцов,*instrumental.sg=образцом
обрезок|sобрезк
обрывок|sобрывк
обстоятельство|cm,sобстоятельств,nа,p
обтекатель|cm
обустройство|cm,sобустройств,nа,p
обушок|sобушк
обшлаг|nа
объебос|A
объедья|cm,*genitive.sg=объедьев,*dative.sg=объедьям,*instrumental.sg=объедьями,*prepositional.sg=объедьях
объятье|cm,sобъять,nя,S,*genitive.pl=объятий
обыватель|cm,A
обязательство|cm,sобязательств,nа,p
овен|sовн,A
овёс|sовс
овечка|A
овод|nа,A
овца|A,*genitive.pl=овец,*accusative.pl=овец,*instrumental.sg=овцой
овцебык|A
овчар|A
овчарка|A
оглобля|*genitive.pl=оглобель
огнепоклонничество|cm,sогнепоклонничеств,nа,p
огнетушитель|cm
огнищанин|sогнищан,nе,p,A,*genitive.sg=огнищанина,*dative.sg=огнищанину,*accusative.sg=огнищанина,*instrumental.sg=огнищанином,*prepositional.sg=огнищанине
огнь|cm,iём
огонёк|sогоньк
огонь|cm,sогн,iём
огрызок|sогрызк
огурец|*genitive.pl=огурцов,*instrumental.sg=огурцом
одежда|p
одессит|A
одиночество|cm,sодиночеств,nа,p
одиночка|A
однокашник|A
одноклассник|A
одноклассница|A
однокурсник|A
однополчанин|sоднополчан,nе,p,A,*genitive.sg=однополчанина,*dative.sg=однополчанину,*accusative.sg=однополчанина,*instrumental.sg=однополчанином,*prepositional.sg=однополчанине
односельчанин|sодносельчан,nе,p,A,*genitive.sg=односельчанина,*dative.sg=односельчанину,*accusative.sg=односельчанина,*instrumental.sg=односельчанином,*prepositional.sg=односельчанине
одночасье|cm,sодночась,nя,S,*genitive.pl=одночасий
ожерелье|cm,sожерель,nя,S,*genitive.pl=ожерелий
оживитель|cm,A
оживительница|A
ожидальня|*genitive.pl=ожидален
озвучка|p
озеро|cm,sозёр,nа,p,*genitive.sg=озера,*dative.sg=озеру,*instrumental.sg=озером,*prepositional.sg=озере
оккупант|A
око|cf,iом,*genitive.sg=око,*genitive.pl=очи,*dative.sg=ока,*dative.pl=очей,*instrumental.pl=очами,*prepositional.pl=очах
оконце|cm,sоконц,nа,*genitive.pl=оконец
окорок|nа
окошечко|nы
окошко|nы
окружающее|A,*nominative.pl=окружающие,*genitive.sg=окружающего,*genitive.pl=окружающих,*dative.sg=окружающему,*dative.pl=окружающим,*accusative.pl=окружающих,*instrumental.sg=окружающим,*instrumental.pl=окружающими,*prepositional.sg=окружающем,*prepositional.pl=окружающих
окружающие|cm,A,*genitive.sg=окружающих,*dative.sg=окружающим,*accusative.sg=окружающих,*instrumental.sg=окружающими,*prepositional.sg=окружающих
октябрёнок|sоктябрят,nа,p,A,*genitive.sg=октябрёнка,*dative.sg=октябрёнку,*accusative.sg=октябрёнка,*instrumental.sg=октябрёнком,*prepositional.sg=октябрёнке
октябрь|cm,iём
окунь|cm,A
окурок|sокурк
оладья|*genitive.pl=оладий
оленёнок|sоленят,nа,p,A,*genitive.sg=оленёнка,*dative.sg=оленёнку,*accusative.sg=оленёнка,*instrumental.sg=оленёнком,*prepositional.sg=оленёнке
олигарх|A
олончанин|sолончан,nе,p,A,*genitive.sg=олончанина,*dative.sg=олончанину,*accusative.sg=олончанина,*instrumental.sg=олончанином,*prepositional.sg=олончанине
ольха|p
омар|A
омбудсмен|A
омуль|cm,A
ондатра|p,A
ономатопея|pй
опарыш|A
опекун|A
опёнок|sопят,nа,p,*genitive.sg=опёнка,*dative.sg=опёнку,*instrumental.sg=опёнком,*prepositional.sg=опёнке
оперативник|A
оператор|A
оперетта|p
оползень|cm,sоползн
опоссум|A
опочанин|sопочан,nе,p,A,*genitive.sg=опочанина,*dative.sg=опочанину,*accusative.sg=опочанина,*instrumental.sg=опочанином,*prepositional.sg=опочанине
опочивальня|*genitive.pl=опочивален
оппозиционер|A
оппонент|A
оппортунист|A
опреснитель|cm
опричник|A
оптимист|A
орангутан|A
оранжерея|pй
оратор|A
ораторша|p,A
организатор|A
орда|p
орёл|sорл,A
орешек|sорешк
орлёнок|sорлят,nа,p,A,*genitive.sg=орлёнка,*dative.sg=орлёнку,*accusative.sg=орлёнка,*instrumental.sg=орлёнком,*prepositional.sg=орлёнке
орлица|A
орнитолог|A
ортодокс|A
оруженосец|A
орфограмма|p
орхидея|pй
оса|gа,*genitive.pl=осы,*dative.sg=осы,*dative.pl=ос
осадки|*genitive.sg=осадков,*dative.sg=осадкам,*instrumental.sg=осадками,*prepositional.sg=осадках
осанна|p
освежитель|cm
осёл|sосл,A
оселок|sоселк
осетин|p,A
осетинка|A
осётр|sосетр,A
осколок|sосколк
ослёнок|sослят,nа,p,A,*genitive.sg=ослёнка,*dative.sg=ослёнку,*accusative.sg=ослёнка,*instrumental.sg=ослёнком,*prepositional.sg=ослёнке
ослик|A
основатель|cm,A
основное|cm,*genitive.sg=основного,*dative.sg=основному,*instrumental.sg=основным,*prepositional.sg=основном
основоположник|A
особа|A
особь|A
оспа|p
остальное|cm,*nominative.pl=остальные,*genitive.sg=остального,*genitive.pl=остальных,*dative.sg=остальному,*dative.pl=остальным,*accusative.pl=остальные,*instrumental.sg=остальным,*instrumental.pl=остальными,*prepositional.sg=остальном,*prepositional.pl=остальных
останки|*genitive.sg=останков,*dative.sg=останкам,*instrumental.sg=останками,*prepositional.sg=останках
остаток|sостатк
остгот|A
остриё|cm,sостри,iём,lе,nя,pёв,S
островитянин|sостровитян,nе,p,A,*genitive.sg=островитянина,*dative.sg=островитянину,*accusative.sg=островитянина,*instrumental.sg=островитянином,*prepositional.sg=островитянине
островок|sостровк
осьминог|A
ответчик|A
отговоры|*genitive.sg=отговоров,*dative.sg=отговорам,*instrumental.sg=отговорами,*prepositional.sg=отговорах
отголосок|sотголоск
отдыхающий|A,*genitive.sg=отдыхающего,*dative.sg=отдыхающему,*accusative.sg=отдыхающего,*instrumental.sg=отдыхающим,*prepositional.sg=отдыхающем
отель|cm
отечество|cm,sотечеств,nа,p
отказник|A
открытая|cm,*nominative.pl=открытые,*genitive.sg=открытой,*genitive.pl=открытых,*dative.sg=открытой,*dative.pl=открытым,*accusative.sg=открытую,*accusative.pl=открытые,*instrumental.sg=открытой,*instrumental.pl=открытыми,*prepositional.sg=открытой,*prepositional.pl=открытых
отличник|A
отморозок|sотморозк,A
оториноларинголог|A
отпечаток|sотпечатк
отправитель|cm,A
отпуск|nа
отребье|cm,sотребь,nя,S
отрезок|sотрезк
отрепье|cm,sотрепь,nя,S
отроковица|A
отросток|sотростк
отрочество|cm,sотрочеств,nа,p
отрывок|sотрывк
отступник|A
отступничество|cm,sотступничеств,nа,p
отходная|cm,*nominative.pl=отходные,*genitive.sg=отходной,*genitive.pl=отходных,*dative.sg=отходной,*dative.pl=отходным,*accusative.sg=отходную,*accusative.pl=отходные,*instrumental.sg=отходной,*instrumental.pl=отходными,*prepositional.sg=отходной,*prepositional.pl=отходных
отцовство|cm,sотцовств,nа,p
отчаянье|cm,sотчаянь,nя,S,*genitive.pl=отчаяний
отчизна|p
отчим|A
отшельник|A
офеня|pей,A
офицер|A
офицерня|iёй,pей
официант|A
охлопье|cm,sохлопь,nя,S
охлупень|cm,sохлупн
охотник|A
охотнорядец|A
охранник|A
оцелот|A
оцет|sоцт
очевидец|A
очко|cm,sочк
павиан|A
павлин|A
паводок|sпаводк
падеж|*instrumental.sg=падежом
падёж|sпадеж,*instrumental.sg=падежом
падишах|A
падла|p
падло|cm,sпадл,nа,p
падонак|sпадонк,A,*genitive.pl=падонкаф,*accusative.pl=падонкаф
падчерица|A
паёк|sпайк
паж|A,*instrumental.sg=пажом
пай|pёв
пакистанец|A
пакля|pей
паковка|p
палач|A,*instrumental.sg=палачом
палеоантрополог|A
палеонтолог|A
палестинец|A
палешанин|sпалешан,nе,p,A,*genitive.sg=палешанина,*dative.sg=палешанину,*accusative.sg=палешанина,*instrumental.sg=палешанином,*prepositional.sg=палешанине
палитра|p
палия|A
паломник|A
паломничество|cm,sпаломничеств,nа,p
палочник|A
палтус|A
пальма|p
памфлетист|A
пан|A
панголин|A
панграмма|p
панда|p,A
паникёр|A
паникёрство|cm,sпаникёрств,nа,p
паникёрша|p,A
пантеист|A
пантера|A
панцирь|cm
папик|A
папуас|A
парадигма|p
парадное|cm,*nominative.pl=парадные,*genitive.sg=парадного,*genitive.pl=парадных,*dative.sg=парадному,*dative.pl=парадным,*accusative.pl=парадные,*instrumental.sg=парадным,*instrumental.pl=парадными,*prepositional.sg=парадном,*prepositional.pl=парадных
паразит|A
паралич|*instrumental.sg=параличом
паранджа|pей,*instrumental.sg=паранджой
параноик|A
парашютист|A
паремья|iёй,*genitive.pl=паремий
паренёк|sпареньк
парень|cm,sпарн,A
парижанин|sпарижан,nе,p,A,*genitive.sg=парижанина,*dative.sg=парижанину,*accusative.sg=парижанина,*instrumental.sg=парижанином,*prepositional.sg=парижанине
парикмахер|A
парикмахерская|cm,*nominative.pl=парикмахерские,*genitive.sg=парикмахерской,*genitive.pl=парикмахерских,*dative.sg=парикмахерской,*dative.pl=парикмахерским,*accusative.sg=парикмахерскую,*instrumental.sg=парикмахерской,*instrumental.pl=парикмахерскими,*prepositional.sg=парикмахерской,*prepositional.pl=парикмахерских
парильня|*genitive.pl=парилен
пария|A
парламентарий|A
парнишка|A
парнокопытное|A,*nominative.pl=парнокопытные,*genitive.sg=парнокопытного,*genitive.pl=парнокопытных,*dative.sg=парнокопытному,*dative.pl=парнокопытным,*accusative.pl=парнокопытных,*instrumental.sg=парнокопытным,*instrumental.pl=парнокопытными,*prepositional.sg=парнокопытном,*prepositional.pl=парнокопытных
пароль|cm
пароходство|cm,sпароходств,nа,p
парта|p
партиец|A
партизан|p,A
партнёр|A
партнёрство|cm,sпартнёрств,nа,p
партнёрша|p,A
парторг|A
парубок|sпарубк,A
парус|nа
парфянин|sпарфян,nе,p,A,*genitive.sg=парфянина,*dative.sg=парфянину,*accusative.sg=парфянина,*instrumental.sg=парфянином,*prepositional.sg=парфянине
парча|pей,*instrumental.sg=парчой
паря|pей,A
пасечник|A
паска|p
паспорт|nа
пассажир|A
пассатижи|*genitive.sg=пассатижей,*dative.sg=пассатижам,*instrumental.sg=пассатижами,*prepositional.sg=пассатижах
пассия|A
паста|p
пастбище|cm,sпастбищ,nа,p
паства|p
пастор|A
пастух|A
пастушок|sпастушк,A
пастушонок|sпастушат,nа,p,A,*genitive.sg=пастушонка,*dative.sg=пастушонку,*accusative.sg=пастушонка,*instrumental.sg=пастушонком,*prepositional.sg=пастушонке
пастырь|cm,A
пасха|p
пасха|p
пасынок|sпасынк,A
патикус|A
патлы|*genitive.sg=патл,*dative.sg=патлам,*instrumental.sg=патлами,*prepositional.sg=патлах
патолог|A
патриарх|A
патриот|A
патрубок|sпатрубк
патруль|cm,iём
патрульный|A,*genitive.sg=патрульного,*dative.sg=патрульному,*accusative.sg=патрульного,*instrumental.sg=патрульным,*prepositional.sg=патрульном
паук|A
паук-волк|sпаукам-волк,A,*nominative.pl=пауки-волки,*genitive.sg=паука-волка,*genitive.pl=пауков-волков,*dative.sg=пауку-волку,*accusative.sg=паука-волка,*accusative.pl=пауков-волков,*instrumental.sg=пауком-волком,*instrumental.pl=пауками-волками,*prepositional.sg=пауке-волке,*prepositional.pl=пауках-волках
паук-птицеед|sпаукам-птицеед,A,*nominative.pl=пауки-птицееды,*genitive.sg=паука-птицееда,*genitive.pl=пауков-птицеедов,*dative.sg=пауку-птицееду,*accusative.sg=паука-птицееда,*accusative.pl=пауков-птицеедов,*instrumental.sg=пауком-птицеедом,*instrumental.pl=пауками-птицеедами,*prepositional.sg=пауке-птицееде,*prepositional.pl=пауках-птицеедах
пахан|A
пахта|p
пацан|A
пацанёнок|sпацанят,nа,p,A,*genitive.sg=пацанёнка,*dative.sg=пацанёнку,*accusative.sg=пацанёнка,*instrumental.sg=пацанёнком,*prepositional.sg=пацанёнке
пациент|A
пациентка|A
пацифист|A
пачкотня|iёй,pей
паша|pей,*instrumental.sg=пашой
паяц|A
певец|A,*genitive.pl=певцов,*accusative.pl=певцов,*instrumental.sg=певцом
певица|A
певчий|A,*genitive.sg=певчего,*dative.sg=певчему,*accusative.sg=певчего,*instrumental.sg=певчим,*prepositional.sg=певчем
педагог|A
педант|A
педель|cm,A
педераст|A
педик|A
педофил|A
пейзанин|sпейзан,nе,p,A,*genitive.sg=пейзанина,*dative.sg=пейзанину,*accusative.sg=пейзанина,*instrumental.sg=пейзанином,*prepositional.sg=пейзанине
пекарь|cm,A
пелена|*genitive.pl=пелён
пеликан|A
пеллагра|p
пельмень|cm
пемза|p
пенёк|sпеньк
пеночка-теньковка|cm,sпеночкам-теньковк,A,*nominative.pl=пеночки-теньковки,*genitive.sg=пеночки-теньковки,*genitive.pl=пеночек-теньковок,*dative.sg=пеночке-теньковке,*accusative.sg=пеночку-теньковку,*accusative.pl=пеночек-теньковок,*instrumental.sg=пеночкой-теньковкой,*instrumental.pl=пеночками-теньковками,*prepositional.sg=пеночке-теньковке,*prepositional.pl=пеночках-теньковках
пенсионер|A
пенсионерка|A
пень|cm,sпн,iём
пеня|pей
пепел|sпепл
первенец|A
первенство|cm,sпервенств,nа,p
первое|cm,*nominative.pl=первые,*genitive.sg=первого,*genitive.pl=первых,*dative.sg=первому,*dative.pl=первым,*accusative.pl=первые,*instrumental.sg=первым,*instrumental.pl=первыми,*prepositional.sg=первом,*prepositional.pl=первых
первокурсник|A
первопоселенец|A
первосвященник|A
перебежчик|A
переводчик|A
переводчица|A
перевозчик|A
перед|nа
передвижник|A
передняя|cm,*nominative.pl=передние,*genitive.sg=передней,*genitive.pl=передних,*dative.sg=передней,*dative.pl=передним,*accusative.sg=переднюю,*accusative.pl=передние,*instrumental.sg=передней,*instrumental.pl=передними,*prepositional.sg=передней,*prepositional.pl=передних
передовая|cm,*nominative.pl=передовые,*genitive.sg=передовой,*genitive.pl=передовых,*dative.sg=передовой,*dative.pl=передовым,*accusative.sg=передовую,*accusative.pl=передовые,*instrumental.sg=передовой,*instrumental.pl=передовыми,*prepositional.sg=передовой,*prepositional.pl=передовых
передок|sпередк
пережитое|cm,*nominative.pl=пережитые,*genitive.sg=пережитого,*genitive.pl=пережитых,*dative.sg=пережитому,*dative.pl=пережитым,*accusative.pl=пережитые,*instrumental.sg=пережитым,*instrumental.pl=пережитыми,*prepositional.sg=пережитом,*prepositional.pl=пережитых
пережиток|sпережитк
переизбыток|sпереизбытк
перекрёсток|sперекрёстк
переменная|cm,*nominative.pl=переменные,*genitive.sg=переменной,*genitive.pl=переменных,*dative.sg=переменной,*dative.pl=переменным,*accusative.sg=переменную,*accusative.pl=переменные,*instrumental.sg=переменной,*instrumental.pl=переменными,*prepositional.sg=переменной,*prepositional.pl=переменных
перенаём|sперенайм
перенастройка|p
перепел|A
переселенец|A
пересмешник|A
перестройка|*genitive.pl=перестроек
переулок|sпереулк
переустройство|cm,sпереустройств,nа,p
перечень|cm,sперечн
перешеек|sперешейк
перила|cm,*genitive.sg=перил,*dative.sg=перилам,*instrumental.sg=перилами,*prepositional.sg=перилах
перильца|cm,*genitive.sg=перилец,*dative.sg=перильцам,*instrumental.sg=перильцами,*prepositional.sg=перильцах
пермяк|A
перо|cm,sперь,nя,S,*genitive.sg=пера,*dative.sg=перу,*instrumental.sg=пером,*prepositional.sg=пере
перс|A
перси|*genitive.sg=персей,*dative.sg=персям,*instrumental.sg=персями,*prepositional.sg=персях
персидский|*nominative.sg=персидского,*genitive.sg=персидскому,*instrumental.sg=персидским,*prepositional.sg=персидском
персиянин|sперсиян,nе,p,A,*genitive.sg=персиянина,*dative.sg=персиянину,*accusative.sg=персиянина,*instrumental.sg=персиянином,*prepositional.sg=персиянине
персона|A
персонаж|A
перстень|cm,sперстн
пёрышко|nы
пёс|sпс,A
песец|A,*genitive.pl=песцов,*accusative.pl=песцов,*instrumental.sg=песцом
пескарь|cm,iём,A
пессимист|A
пест|*genitive.sg=пест,*genitive.pl=песты,*dative.sg=песта,*dative.pl=пестов
петарда|p
петербуржец|A
петля|*genitive.pl=петель
петух|A
петушок|sпетушк,A
пехотинец|A
печальник|A
печатник|A
печенег|A
печенье|cm,sпечень,nя,S,*genitive.pl=печений
печенька|*genitive.pl=печенек
пешеход|A
пешня|iёй,pей
пианист|A
пианистка|A
пивная|cm,*nominative.pl=пивные,*genitive.sg=пивной,*genitive.pl=пивных,*dative.sg=пивной,*dative.pl=пивным,*accusative.sg=пивную,*accusative.pl=пивные,*instrumental.sg=пивной,*instrumental.pl=пивными,*prepositional.sg=пивной,*prepositional.pl=пивных
пивовар|A
пигмей|A
пиджачок|sпиджачк
пидор|A
пидорас|A
пижма|p
пижон|A
пиздёж|sпиздеж,*instrumental.sg=пиздежом
пиздец|sпиздец,*genitive.pl=пиздецов,*instrumental.sg=пиздецом
пиздобол|A
пиздолиз|A
пиздун|A
пиздюк|A
пиздюшка|A
пиита|A
пикетчик|A
пиксель|cm
пикт|A
пиктограмма|p
пилигрим|A
пилот|A
пилюля|*genitive.pl=пилюль
пингвин|A
пиндос|A
пинок|sпинк
пиньинь|cm
пионер|A
пионерка|A
пипец|*genitive.pl=пипцов,*instrumental.sg=пипцом
пиписька|*genitive.pl=пиписек
пирайя|A
пиранья|A,*genitive.pl=пираний,*accusative.pl=пираний
пират|A
пиратство|cm,sпиратств,nа,p
пирожник|A
пирожное|cm,*nominative.pl=пирожные,*genitive.sg=пирожного,*genitive.pl=пирожных,*dative.sg=пирожному,*dative.pl=пирожным,*instrumental.sg=пирожным,*instrumental.pl=пирожными,*prepositional.sg=пирожном,*prepositional.pl=пирожных
пирожок|sпирожк
пироман|A
писарь|cm,A
писатель|cm,A
писательница|A
писец|A,*genitive.pl=писцов,*accusative.pl=писцов,*instrumental.sg=писцом
пискарь|cm,iём,A
пистолет-пулемёт|sпистолетам-пулемёт,*nominative.pl=пистолеты-пулемёты,*genitive.sg=пистолета-пулемёта,*genitive.pl=пистолетов-пулемётов,*dative.sg=пистолету-пулемёту,*accusative.pl=пистолеты-пулемёты,*instrumental.sg=пистолетом-пулемётом,*instrumental.pl=пистолетами-пулемётами,*prepositional.sg=пистолете-пулемёте,*prepositional.pl=пистолетах-пулемётах
писька|*genitive.pl=писек
письмена|cm,*genitive.sg=письмён,*dative.sg=письменам,*instrumental.sg=письменами,*prepositional.sg=письменах
письмо|cm,sписьм,nа,*genitive.pl=писем
питерец|A
питомец|A
питон|A
пихта|p
пицца|p
плавильня|*genitive.pl=плавилен
плавни|*genitive.sg=плавней,*dative.sg=плавням,*instrumental.sg=плавнями,*prepositional.sg=плавнях
плагиатор|A
плазма|p
плакса|p,A
пламя|cm,sпламен,gи,dи,iем,lи,nа,*genitive.pl=пламён
пластмасса|p
пластырь|cm
платёж|sплатеж,*instrumental.sg=платежом
плательщик|A
платок|sплатк
платочек|sплаточк
платформа|p
платье|cm,sплать,nя,S
платьице|cm,sплатьиц,nа,p
плацента|p
плацкарта|p
плащ|*instrumental.sg=плащом
плевок|sплевк
племянник|A
племянница|A
племяш|A,*instrumental.sg=племяшом
племяшка|A
пленник|A
плетень|cm,sплетн,iём
плешь|cm,gи,dи,iью,lи,S0
пловец|A,*genitive.pl=пловцов,*accusative.pl=пловцов,*instrumental.sg=пловцом
пломба|p
плоскогорье|cm,sплоскогорь,nя,S,*genitive.pl=плоскогорий
плоскозубцы|*genitive.sg=плоскозубцев,*dative.sg=плоскозубцам,*instrumental.sg=плоскозубцами,*prepositional.sg=плоскозубцах
плотник|A
плутня|pей
плюсна|*genitive.pl=плюсен
плющ|*instrumental.sg=плющом
победитель|cm,A
побережье|cm,sпобережь,nя,S,*genitive.pl=побережий
побои|*genitive.sg=побоев,*dative.sg=побоям,*instrumental.sg=побоями,*prepositional.sg=побоях
побоище|cm,sпобоищ,nа,p
побратим|A
повар|nа,A
поварёнок|sповарят,nа,p,A,*genitive.sg=поварёнка,*dative.sg=поварёнку,*accusative.sg=поварёнка,*instrumental.sg=поварёнком,*prepositional.sg=поварёнке
повелитель|cm,A
повелительница|A
поверенный|nе,A,*genitive.sg=поверенного,*genitive.pl=поверенных,*dative.sg=поверенному,*dative.pl=поверенным,*accusative.sg=поверенного,*accusative.pl=поверенных,*instrumental.sg=поверенным,*instrumental.pl=поверенными,*prepositional.sg=поверенном,*prepositional.pl=поверенных
поверье|cm,sповерь,nя,S,*genitive.pl=поверий
повидло|cm,sповидл,nа,p
повитуха|A
поводок|sповодк
повстанец|A
погибший|*genitive.sg=погибшего,*dative.sg=погибшему,*instrumental.sg=погибшим,*prepositional.sg=погибшем
поглотитель|cm
поголовье|cm,sпоголовь,nя,S,*genitive.pl=поголовий
погоня|*genitive.pl=погонь
погорелец|A
пограничник|A
погреб|nа
погромщик|A
погромщица|A
подагра|p
подарок|sподарк
податель|cm,A
подательница|A
подбородок|sподбородк
подвижник|A
подводник|A
подворотничок|sподворотничк
подворье|cm,sподворь,nя,S,*genitive.pl=подворий
подгруппа|p
подгузничек|sподгузничк
подданство|cm,sподданств,nа,p
подёнщик|A
поджигатель|cm,A
поджигательница|A
подземелье|cm,sподземель,nя,S,*genitive.pl=подземелий
подкаблучник|A
подкидыш|A
подлежащее|cm,*nominative.pl=подлежащие,*genitive.sg=подлежащего,*genitive.pl=подлежащих,*dative.sg=подлежащему,*dative.pl=подлежащим,*accusative.pl=подлежащие,*instrumental.sg=подлежащим,*instrumental.pl=подлежащими,*prepositional.sg=подлежащем,*prepositional.pl=подлежащих
подлец|sподлец,A,*genitive.pl=подлецов,*accusative.pl=подлецов,*instrumental.sg=подлецом
подлиза|A
подмастерье|cm,sподмастерь,nя,S,A
подмножество|cm,sподмножеств,nа,p
подмостки|*genitive.sg=подмостков,*dative.sg=подмосткам,*instrumental.sg=подмостками,*prepositional.sg=подмостках
поднаём|sподнайм
подноготная|cm,*genitive.sg=подноготной,*dative.sg=подноготной,*accusative.sg=подноготную,*instrumental.sg=подноготной,*prepositional.sg=подноготной
подножье|cm,sподножь,nя,S,*genitive.pl=подножий
подолянин|sподолян,nе,p,A,*genitive.sg=подолянина,*dative.sg=подолянину,*accusative.sg=подолянина,*instrumental.sg=подолянином,*prepositional.sg=подолянине
подонок|sподонк,A
подошва|p
подполковник|A
подполье|cm,sподполь,nя,S
подросток|sподростк,A
подружка|A
подрядчик|A
подсластитель|cm
подстрекатель|cm,A
подстрекательство|cm,sподстрекательств,nа,p
подсудимый|nе,A,*genitive.sg=подсудимого,*genitive.pl=подсудимых,*dative.sg=подсудимому,*dative.pl=подсудимым,*accusative.sg=подсудимого,*accusative.pl=подсудимых,*instrumental.sg=подсудимым,*instrumental.pl=подсудимыми,*prepositional.sg=подсудимом,*prepositional.pl=подсудимых
подсушка|p
подхалим|A
подхалимство|cm,sподхалимств,nа,p
поединок|sпоединк
пожарник|A
пожарный|A,*genitive.sg=пожарного,*dative.sg=пожарному,*accusative.sg=пожарного,*instrumental.sg=пожарным,*prepositional.sg=пожарном
позвонок|sпозвонк
позвоночное|A,*nominative.pl=позвоночные,*genitive.sg=позвоночного,*genitive.pl=позвоночных,*dative.sg=позвоночному,*dative.pl=позвоночным,*accusative.pl=позвоночных,*instrumental.sg=позвоночным,*instrumental.pl=позвоночными,*prepositional.sg=позвоночном,*prepositional.pl=позвоночных
позёр|A
пойма|p
показатель|cm
поклонник|A
поклонница|A
покои|*genitive.sg=покоев,*dative.sg=покоям,*instrumental.sg=покоями,*prepositional.sg=покоях
покойник|A
покойница|A
покровитель|cm,A
покупатель|cm,A
покупательница|A
пол-литра|cm,sполулитр
пол-очка|cm,sполуочк
полба|p
полведра|cm,sполувёдр,nа,*genitive.sg=полуведра,*genitive.pl=полувёдер,*dative.sg=полуведру,*accusative.sg=полуведро,*instrumental.sg=полуведром,*prepositional.sg=полуведре
полвека|cm,sполувек,nа
полгода|cm,sполугод
полдень|cm,sполудн,*nominative.pl=полдни,*genitive.pl=полдней,*accusative.pl=полдни
полдни|*genitive.sg=полдён,*dative.sg=полдням,*instrumental.sg=полднями,*prepositional.sg=полднях
полдороги|cn,gи,A
полено|cm,sполень,nя,S,*genitive.sg=полена,*dative.sg=полену,*instrumental.sg=поленом,*prepositional.sg=полене
полиглот|A
политеист|A
политкаторжанин|sполиткаторжан,nе,p,A,*genitive.sg=политкаторжанина,*dative.sg=политкаторжанину,*accusative.sg=политкаторжанина,*instrumental.sg=политкаторжанином,*prepositional.sg=политкаторжанине
политолог|A
политрук|A
политтехнолог|A
полицай|A
полицейский|*nominative.sg=полицейского,*genitive.sg=полицейскому,*instrumental.sg=полицейским,*prepositional.sg=полицейском
полкилометра|cm,sполукилометр
полковник|A
полковничиха|A
полководец|A
полмесяца|cm,sполумесяц
полметра|cm,sполуметр
полмиллиона|cm,sполумиллион
полминуты|*genitive.sg=полуминуты,*dative.sg=полуминуте,*accusative.sg=полуминуту,*instrumental.sg=полуминутой,*prepositional.sg=полуминуте
полночь|cm,sполуноч,gи,dи,iью,lи,S0,*nominative.pl=полночи,*genitive.pl=полночей,*accusative.sg=полуночь
половец|A
полонянин|sполонян,nе,p,A,*genitive.sg=полонянина,*dative.sg=полонянину,*accusative.sg=полонянина,*instrumental.sg=полонянином,*prepositional.sg=полонянине
полотенце|cm,sполотенц,nа,*genitive.pl=полотенец
полотнище|cm,sполотнищ,nа,p
полотно|cm,sполотн,nа,*genitive.pl=полотен
полочанин|sполочан,nе,p,A,*genitive.sg=полочанина,*dative.sg=полочанину,*accusative.sg=полочанина,*instrumental.sg=полочанином,*prepositional.sg=полочанине
полпред|A
полпути|cn,gи,lи,A
полслова|cm,*genitive.sg=полуслова,*prepositional.sg=полуслове
полсотни|cf,sполусотн,S
полтавчанин|sполтавчан,nе,p,A,*genitive.sg=полтавчанина,*dative.sg=полтавчанину,*accusative.sg=полтавчанина,*instrumental.sg=полтавчанином,*prepositional.sg=полтавчанине
полтысячи|cf,sполутысяч
полуботинок|cn,sполуботинк,nы
полуимя|cm,sполуимен,gи,dи,iем,lи,nа,*genitive.pl=полуимён
полуостров|nа
полупетля|iёй,*genitive.pl=полупетель
полустанок|sполустанк
получатель|cm,A
получательница|A
получеловек|A,*nominative.pl=полулюди,*genitive.pl=полулюдей,*dative.pl=полулюдям,*accusative.pl=полулюдей,*instrumental.pl=полулюдьми,*prepositional.pl=полулюдях
полушубок|sполушубк
полчанин|sполчан,nе,p,A,*genitive.sg=полчанина,*dative.sg=полчанину,*accusative.sg=полчанина,*instrumental.sg=полчанином,*prepositional.sg=полчанине
полчаса|cm,sполучас
полчище|cm,sполчищ,nа,p
полчок|sполчк,A
полымя|cn,iем
польза|p
пользователь|cm,A
пользовательница|A
полюдье|cm,sполюдь,nя,S,*genitive.pl=полюдий
поляк|A
полянин|sполян,nе,p,A,*genitive.sg=полянина,*dative.sg=полянину,*accusative.sg=полянина,*instrumental.sg=полянином,*prepositional.sg=полянине
полярник|A
помазанник|A
поместье|cm,sпоместь,nя,S,*genitive.pl=поместий
помещик|A
поминки|*genitive.sg=поминок,*dative.sg=поминкам,*instrumental.sg=поминками,*prepositional.sg=поминках
помои|*genitive.sg=помоев,*dative.sg=помоям,*instrumental.sg=помоями,*prepositional.sg=помоях
помойка|*genitive.pl=помоек
поморянин|sпоморян,nе,p,A,*genitive.sg=поморянина,*dative.sg=поморянину,*accusative.sg=поморянина,*instrumental.sg=поморянином,*prepositional.sg=поморянине
помощник|A
помощница|A
помощь|cm,gи,dи,iью,lи,S0
помысел|sпомысл
понтифик|A
понятой|A,*nominative.pl=понятые,*genitive.sg=понятого,*genitive.pl=понятых,*dative.sg=понятому,*dative.pl=понятым,*accusative.sg=понятого,*accusative.pl=понятых,*instrumental.sg=понятым,*instrumental.pl=понятыми,*prepositional.sg=понятом,*prepositional.pl=понятых
попёнок|sпопят,nа,p,A,*genitive.sg=попёнка,*dative.sg=попёнку,*accusative.sg=попёнка,*instrumental.sg=попёнком,*prepositional.sg=попёнке
попечитель|cm,A
поплавок|sпоплавк
попович|A
попойка|*genitive.pl=попоек
поприще|cm,sпоприщ,nа,p
попрошайка|A,*genitive.pl=попрошаек,*accusative.pl=попрошаек
попуститель|cm,A
попутчик|A
поработитель|cm,A
пораженец|A
порнограф|A
поросёнок|sпоросят,nа,p,A,*genitive.sg=поросёнка,*dative.sg=поросёнку,*accusative.sg=поросёнка,*instrumental.sg=поросёнком,*prepositional.sg=поросёнке
порошок|sпорошк
портки|*genitive.sg=портков,*dative.sg=порткам,*instrumental.sg=портками,*prepositional.sg=портках
портниха|A
портной|A,*nominative.pl=портные,*genitive.sg=портного,*genitive.pl=портных,*dative.sg=портному,*dative.pl=портным,*accusative.sg=портного,*accusative.pl=портных,*instrumental.sg=портным,*instrumental.pl=портными,*prepositional.sg=портном,*prepositional.pl=портных
португалец|A
португалка|A
портфель|cm
поручень|cm,sпоручн
поручик|A
порча|p
поршень|cm,sпоршн
посейдон|A
поселенец|A
посёлок|sпосёлк
поселянин|sпоселян,nе,p,A,*genitive.sg=поселянина,*dative.sg=поселянину,*accusative.sg=поселянина,*instrumental.sg=поселянином,*prepositional.sg=поселянине
посиделки|*genitive.sg=посиделок,*dative.sg=посиделкам,*instrumental.sg=посиделками,*prepositional.sg=посиделках
посланец|A
посланник|A
последователь|cm,A
послушник|A
посмешище|cm,sпосмешищ,nа,p
посольство|cm,sпосольств,nа,p
посредник|A
поссум|A
постав|nа
поставщик|A
постановщик|A
постеля|pей
посторонний|A,*genitive.sg=постороннего,*dative.sg=постороннему,*accusative.sg=постороннего,*instrumental.sg=посторонним,*prepositional.sg=постороннем
постоялец|A
пострелёнок|sпострелят,nа,p,A,*genitive.sg=пострелёнка,*dative.sg=пострелёнку,*accusative.sg=пострелёнка,*instrumental.sg=пострелёнком,*prepositional.sg=пострелёнке
постройка|*genitive.pl=построек
поступок|sпоступк
посыльный|nе,A,*genitive.sg=посыльного,*genitive.pl=посыльных,*dative.sg=посыльному,*dative.pl=посыльным,*accusative.sg=посыльного,*accusative.pl=посыльных,*instrumental.sg=посыльным,*instrumental.pl=посыльными,*prepositional.sg=посыльном,*prepositional.pl=посыльных
посягательство|cm,sпосягательств,nа,p
потаскуха|A
потаскушка|A
потерпевший|A,*genitive.sg=потерпевшего,*dative.sg=потерпевшему,*accusative.sg=потерпевшего,*instrumental.sg=потерпевшим,*prepositional.sg=потерпевшем
потолок|sпотолк
потомок|sпотомк,A
потомство|cm,sпотомств,nа,p
потребитель|cm,A
потребительница|A
потроха|cm,*genitive.sg=потрохов,*dative.sg=потрохам,*instrumental.sg=потрохами,*prepositional.sg=потрохах
похититель|cm,A
похитительница|A
похмелье|cm,sпохмель,nя,S,*genitive.pl=похмелий
початок|sпочатк
почва|p
почемучка|A
почести|*genitive.sg=почестей,*dative.sg=почестям,*instrumental.sg=почестями,*prepositional.sg=почестях
почивальня|*genitive.pl=почивален
почитатель|cm,A
почитательница|A
почта|p
почтальон|A
почтмейстер|A
поэт|A
поэтесса|p,A
пояс|nа
прабабушка|A
правда|p
праведник|A
правитель|cm,A
правительство|cm,sправительств,nа,p
правнук|A
правнучата|cm,A,*genitive.sg=правнучат,*dative.sg=правнучатам,*accusative.sg=правнучат,*instrumental.sg=правнучатами,*prepositional.sg=правнучатах
правнучка|A
правозащитник|A
правонарушитель|cm,A
правопорядок|sправопорядк
правша|pей,A,*instrumental.sg=правшой
прадед|A
прадедушка|A
пражанин|sпражан,nе,p,A,*genitive.sg=пражанина,*dative.sg=пражанину,*accusative.sg=пражанина,*instrumental.sg=пражанином,*prepositional.sg=пражанине
празднество|cm,sпразднеств,nа,p
праиндоевропеец|A
практик|A
праотец|A
прапорщик|A
прапрабабушка|A
праправнук|A
прапрадед|A
прапрадедушка|A
прародитель|cm,A
прачечная|cm,*nominative.pl=прачечные,*genitive.sg=прачечной,*genitive.pl=прачечных,*dative.sg=прачечной,*dative.pl=прачечным,*accusative.sg=прачечную,*accusative.pl=прачечные,*instrumental.sg=прачечной,*instrumental.pl=прачечными,*prepositional.sg=прачечной,*prepositional.pl=прачечных
прачка|A
праща|pей,*instrumental.sg=пращой
пращур|A
превосходительство|cm,sпревосходительств,nа,p
превосходство|cm,sпревосходств,nа,p
предатель|cm,A
предательство|cm,sпредательств,nа,p
предвесенье|cm,sпредвесень,nя,S,*genitive.pl=предвесений
предводитель|cm,A
предкрылок|sпредкрылк
предместье|cm,sпредместь,nя,S,*genitive.pl=предместий
предок|sпредк,A
предохранитель|cm
предплечье|cm,sпредплечь,nя,S,*genitive.pl=предплечий
предплюсна|*genitive.pl=предплюсен
предприниматель|cm,A
предпринимательница|A
предпринимательство|cm,sпредпринимательств,nа,p
предрассудок|sпредрассудк
председатель|cm,A
председательство|cm,sпредседательств,nа,p
председательствующий|A,*genitive.sg=председательствующего,*dative.sg=председательствующему,*accusative.sg=председательствующего,*instrumental.sg=председательствующим,*prepositional.sg=председательствующем
представитель|cm,A
представительница|A
представительство|cm,sпредставительств,nа,p
предтеча|A
предубежденье|cm,sпредубеждень,nя,S,*genitive.pl=предубеждений
предшественник|A
предшественница|A
преемник|A
президент|A
преимущество|cm,sпреимуществ,nа,p
преисподняя|cm,*nominative.pl=преисподние,*genitive.sg=преисподней,*genitive.pl=преисподних,*dative.sg=преисподней,*dative.pl=преисподним,*accusative.sg=преисподнюю,*instrumental.sg=преисподней,*instrumental.pl=преисподними,*prepositional.sg=преисподней,*prepositional.pl=преисподних
прелат|A
прелиминарии|*genitive.sg=прелиминариев,*dative.sg=прелиминариям,*instrumental.sg=прелиминариями,*prepositional.sg=прелиминариях
прелюбодей|A
прелюбодейка|A,*genitive.pl=прелюбодеек,*accusative.pl=прелюбодеек
премьер-министр|A
прения|cm,*genitive.sg=прений,*dative.sg=прениям,*instrumental.sg=прениями,*prepositional.sg=прениях
преобразователь|cm
преподаватель|cm,A
преподавательница|A
пресвитерианин|sпресвитериан,nе,p,A,*genitive.sg=пресвитерианина,*dative.sg=пресвитерианину,*accusative.sg=пресвитерианина,*instrumental.sg=пресвитерианином,*prepositional.sg=пресвитерианине
преследователь|cm,A
пресмыкающееся|cn,A,*nominative.pl=пресмыкающиеся,*genitive.sg=пресмыкающегося,*genitive.pl=пресмыкающихся,*dative.sg=пресмыкающемуся,*dative.pl=пресмыкающимся,*accusative.pl=пресмыкающихся,*instrumental.sg=пресмыкающимся,*instrumental.pl=пресмыкающимися,*prepositional.sg=пресмыкающемся,*prepositional.pl=пресмыкающихся
пресс-секретарша|p,A
пресс-секретарь|cm,iём,A
пресс-служба|p
престолонаследник|A
преступник|A
претендент|A
претендентка|A
префект|A
прибежище|cm,sприбежищ,nа,p
прибрежье|cm,sприбрежь,nя,S,*genitive.pl=прибрежий
приверженец|A
приверженка|A
привесок|sпривеск
пригорок|sпригорк
приданое|cm,*nominative.pl=приданые,*genitive.sg=приданого,*genitive.pl=приданых,*dative.sg=приданому,*dative.pl=приданым,*accusative.pl=приданые,*instrumental.sg=приданым,*instrumental.pl=придаными,*prepositional.sg=приданом,*prepositional.pl=приданых
придаток|sпридатк
придворный|A,*genitive.sg=придворного,*dative.sg=придворному,*accusative.sg=придворного,*instrumental.sg=придворным,*prepositional.sg=придворном
придурок|sпридурк,A
приёмная|cm,*nominative.pl=приёмные,*genitive.sg=приёмной,*genitive.pl=приёмных,*dative.sg=приёмной,*dative.pl=приёмным,*accusative.sg=приёмную,*accusative.pl=приёмные,*instrumental.sg=приёмной,*instrumental.pl=приёмными,*prepositional.sg=приёмной,*prepositional.pl=приёмных
призёр|A
призма|p
призрак|A
призывник|A
призывной|A,*genitive.sg=призывного,*dative.sg=призывному,*accusative.sg=призывного,*instrumental.sg=призывным,*prepositional.sg=призывном
прикащик|A
прилавок|sприлавк
прилагательное|cm,*nominative.pl=прилагательные,*genitive.sg=прилагательного,*genitive.pl=прилагательных,*dative.sg=прилагательному,*dative.pl=прилагательным,*instrumental.sg=прилагательным,*instrumental.pl=прилагательными,*prepositional.sg=прилагательном,*prepositional.pl=прилагательных
приморье|cm,sприморь,nя,S,*genitive.pl=приморий
принц|A
принцесса|p,A
припадок|sприпадк
припасы|*genitive.sg=припасов,*dative.sg=припасам,*instrumental.sg=припасами,*prepositional.sg=припасах
прислуга|A
присные|cm,A,*genitive.sg=присных,*dative.sg=присным,*accusative.sg=присных,*instrumental.sg=присными,*prepositional.sg=присных
пристав-исполнитель|cm,sприставам-исполнител,A,*nominative.pl=пристава-исполнители,*genitive.sg=пристава-исполнителя,*genitive.pl=приставов-исполнителей,*dative.sg=приставу-исполнителю,*accusative.sg=пристава-исполнителя,*accusative.pl=приставов-исполнителей,*instrumental.sg=приставом-исполнителем,*instrumental.pl=приставами-исполнителями,*prepositional.sg=приставе-исполнителе,*prepositional.pl=приставах-исполнителях
пристанище|cm,sпристанищ,nа,p
пристройка|*genitive.pl=пристроек
присутствующий|A,*genitive.sg=присутствующего,*dative.sg=присутствующему,*accusative.sg=присутствующего,*instrumental.sg=присутствующим,*prepositional.sg=присутствующем
присяжный|A,*genitive.sg=присяжного,*dative.sg=присяжному,*accusative.sg=присяжного,*instrumental.sg=присяжным,*prepositional.sg=присяжном
притворство|cm,sпритворств,nа,p
прихожанин|sприхожан,nе,p,A,*genitive.sg=прихожанина,*dative.sg=прихожанину,*accusative.sg=прихожанина,*instrumental.sg=прихожанином,*prepositional.sg=прихожанине
прихожая|cm,*nominative.pl=прихожие,*genitive.sg=прихожей,*genitive.pl=прихожих,*dative.sg=прихожей,*dative.pl=прихожим,*accusative.sg=прихожую,*instrumental.sg=прихожей,*instrumental.pl=прихожими,*prepositional.sg=прихожей,*prepositional.pl=прихожих
пришелец|A
приятель|cm,A
приятельница|A
приятельство|cm,sприятельств,nа,p
провайдер|A
провинциал|A
проводница|A
провокатор|A
проворство|cm,sпроворств,nа,p
программа|p
программа-дополнение|cm,sпрограммам-дополнени,S,*nominative.pl=программы-дополнения,*genitive.sg=программы-дополнения,*genitive.pl=программ-дополнений,*dative.sg=программе-дополнению,*accusative.sg=программу-дополнение,*accusative.pl=программы-дополнения,*instrumental.sg=программой-дополнением,*instrumental.pl=программами-дополнениями,*prepositional.sg=программе-дополнении,*prepositional.pl=программах-дополнениях
программист|A
продавец|A,*genitive.pl=продавцов,*instrumental.sg=продавцом
продюсер|A
проектировщик|A
прозаик|A
прозвище|cm,sпрозвищ,nа,p
проигравший|nе,A,*genitive.sg=проигравшего,*genitive.pl=проигравших,*dative.sg=проигравшему,*dative.pl=проигравшим,*accusative.sg=проигравшего,*accusative.pl=проигравших,*instrumental.sg=проигравшим,*instrumental.pl=проигравшими,*prepositional.sg=проигравшем,*prepositional.pl=проигравших
проигрыватель|cm
производитель|cm,A
производная|cm,*nominative.pl=производные,*genitive.sg=производной,*genitive.pl=производных,*dative.sg=производной,*dative.pl=производным,*accusative.sg=производную,*accusative.pl=производные,*instrumental.sg=производной,*instrumental.pl=производными,*prepositional.sg=производной,*prepositional.pl=производных
производство|cm,sпроизводств,nа,p
происки|*genitive.sg=происков,*dative.sg=проискам,*instrumental.sg=происками,*prepositional.sg=происках
происходящее|cm,*nominative.pl=происходящие,*genitive.sg=происходящего,*genitive.pl=происходящих,*dative.sg=происходящему,*dative.pl=происходящим,*accusative.pl=происходящие,*instrumental.sg=происходящим,*instrumental.pl=происходящими,*prepositional.sg=происходящем,*prepositional.pl=происходящих
проклятье|cm,sпроклять,nя,S,*genitive.pl=проклятий
прокрутка|p
прокурор|A
пролесье|cm,sпролесь,nя,S,*genitive.pl=пролесий
пролетарий|A
промежуток|sпромежутк
промысел|sпромысл
промышленник|A
пропаганда|p
пропагандист|A
проповедник|A
прораб|A
проректор|A
прорицатель|cm,A
пророк|A
пророчество|cm,sпророчеств,nа,p
просветитель|cm,A
просёлок|sпросёлк
проситель|cm,A
просительница|A
прослойка|*genitive.pl=прослоек
простак|A
простец|sпростец,A,*genitive.pl=простецов,*accusative.pl=простецов,*instrumental.sg=простецом
проститутка|A
пространство|cm,sпространств,nа,p
проступок|sпроступк
просьба|p
протагонист|A
протестант|A
противень|cm,sпротивн
противник|A
противница|A
противоборство|cm,sпротивоборств,nа,p
протоиерей|A
профан|A
профессионал|A
профессор|nа,A
профиль|cm
профорг|A
профсоюзник|A
профсоюзница|A
прохвост|A
проходимец|A
проходная|cm,*nominative.pl=проходные,*genitive.sg=проходной,*genitive.pl=проходных,*dative.sg=проходной,*dative.pl=проходным,*accusative.sg=проходную,*accusative.pl=проходные,*instrumental.sg=проходной,*instrumental.pl=проходными,*prepositional.sg=проходной,*prepositional.pl=проходных
процентщик|A
процентщица|A
прочее|cm,*nominative.pl=прочие,*genitive.sg=прочего,*genitive.pl=прочих,*dative.sg=прочему,*dative.pl=прочим,*accusative.pl=прочие,*instrumental.sg=прочим,*instrumental.pl=прочими,*prepositional.sg=прочем,*prepositional.pl=прочих
прошлое|cm,*nominative.pl=прошлые,*genitive.sg=прошлого,*genitive.pl=прошлых,*dative.sg=прошлому,*dative.pl=прошлым,*instrumental.sg=прошлым,*instrumental.pl=прошлыми,*prepositional.sg=прошлом,*prepositional.pl=прошлых
прощанье|cm,sпрощань,nя,S,*genitive.pl=прощаний
пружинка|p
прыжок|sпрыжк
прыщ|*instrumental.sg=прыщом
прядильня|*genitive.pl=прядилен
прямая|cm,*nominative.pl=прямые,*genitive.sg=прямой,*genitive.pl=прямых,*dative.sg=прямой,*dative.pl=прямым,*accusative.sg=прямую,*accusative.pl=прямые,*instrumental.sg=прямой,*instrumental.pl=прямыми,*prepositional.sg=прямой,*prepositional.pl=прямых
псалмописец|A
псалом|sпсалм
псинка|A
псих|A
психиатр|A
психолог|A
психопат|A
псковитянин|sпсковитян,nе,p,A,*genitive.sg=псковитянина,*dative.sg=псковитянину,*accusative.sg=псковитянина,*instrumental.sg=псковитянином,*prepositional.sg=псковитянине
пскович|A,*instrumental.sg=псковичом
птаха|A
пташка|A
птенец|A,*genitive.pl=птенцов,*instrumental.sg=птенцом
птица-адъютант|sптицам-адъютант,A,*nominative.pl=птицы-адъютанты,*genitive.sg=птицы-адъютанта,*genitive.pl=птиц-адъютантов,*dative.sg=птице-адъютанту,*accusative.sg=птицу-адъютанта,*accusative.pl=птиц-адъютантов,*instrumental.sg=птицей-адъютантом,*instrumental.pl=птицами-адъютантами,*prepositional.sg=птице-адъютанте,*prepositional.pl=птицах-адъютантах
птичка|A
публицист|A
пугач|*instrumental.sg=пугачом
пудель|cm,A
пудожанин|sпудожан,nе,p,A,*genitive.sg=пудожанина,*dative.sg=пудожанину,*accusative.sg=пудожанина,*instrumental.sg=пудожанином,*prepositional.sg=пудожанине
пудра|p
пузырёк|sпузырьк
пузырь|cm,iём
пукля|pей
пуля|*genitive.pl=пуль
пума|A
пупок|sпупк
пупсик|A
пурга|p
пурист|A
пуританин|sпуритан,nе,p,A,*genitive.sg=пуританина,*dative.sg=пуританину,*accusative.sg=пуританина,*instrumental.sg=пуританином,*prepositional.sg=пуританине
пуск|nа
пустельга|p,A
пустомеля|A,*genitive.pl=пустомель,*accusative.pl=пустомель
пустошь|cm,gи,dи,iью,lи,S0
пустыня|*genitive.pl=пустынь
пустырь|cm,iём
путана|A
путанка|A
путеводитель|cm
путешественник|A
путля|*genitive.pl=путель
путник|A
путы|*genitive.sg=пут,*dative.sg=путам,*instrumental.sg=путами,*prepositional.sg=путах
пучок|sпучк
пушка-гаубица|cm,sпушкам-гаубиц,*nominative.pl=пушки-гаубицы,*genitive.sg=пушки-гаубицы,*genitive.pl=пушек-гаубиц,*dative.sg=пушке-гаубице,*accusative.sg=пушку-гаубицу,*accusative.pl=пушки-гаубицы,*instrumental.sg=пушкой-гаубицей,*instrumental.pl=пушками-гаубицами,*prepositional.sg=пушке-гаубице,*prepositional.pl=пушках-гаубицах
пушок|sпушк
пчела|cm,sпчёл,p,A,*genitive.sg=пчелы,*dative.sg=пчеле,*accusative.sg=пчелу,*instrumental.sg=пчелой,*prepositional.sg=пчеле
пчёлка|A
пчеловод|A
пчеловодство|cm,sпчеловодств,nа,p
пчелоед|A
пшек|A
пыж|*instrumental.sg=пыжом
пыльца|*instrumental.sg=пыльцой
пьемонтский|*genitive.sg=пьемонтского,*dative.sg=пьемонтскому,*instrumental.sg=пьемонтским,*prepositional.sg=пьемонтском
пьянство|cm,sпьянств,nа,p
пьянчуга|A
пэр|A
пясть|cm,dи,iью,lи,*genitive.sg=пясть,*genitive.pl=пясти,*dative.pl=пястей
пятачок|sпятачк
пятерня|iёй,pей
пятно|cm,sпятн,nа,*genitive.pl=пятен
пятнышко|nы
раб|A
работник|A
работодатель|cm,A
работодательница|A
работорговля|*genitive.pl=работорговель
работяга|A
рабочая|cm,A,*nominative.pl=рабочие,*genitive.sg=рабочей,*genitive.pl=рабочих,*dative.sg=рабочей,*dative.pl=рабочим,*accusative.sg=рабочую,*accusative.pl=рабочих,*instrumental.sg=рабочей,*instrumental.pl=рабочими,*prepositional.sg=рабочей,*prepositional.pl=рабочих
рабство|cm,sрабств,nа,p
рабыня|A,*genitive.pl=рабынь,*accusative.pl=рабынь
раввин|A
равенство|cm,sравенств,nа,p
раджа|pей,A
радиограмма|p
радист|A
разбирательство|cm,sразбирательств,nа,p
разбойник|A
разбойница|A
разведчик|A
развратник|A
развратница|A
раздевальня|*genitive.pl=раздевален
раздолье|cm,sраздоль,nя,S,*genitive.pl=раздолий
раздражитель|cm
раздумье|cm,sраздумь,nя,S,*genitive.pl=раздумий
разиня|A,*genitive.pl=разинь,*accusative.pl=разинь
разночинец|A
разработчик|A
разрушитель|cm,A
разрыхлитель|cm
раиса|A
ракель|cm
ракля|pей
ракообразное|A,*nominative.pl=ракообразные,*genitive.sg=ракообразного,*genitive.pl=ракообразных,*dative.sg=ракообразному,*dative.pl=ракообразным,*accusative.pl=ракообразных,*instrumental.sg=ракообразным,*instrumental.pl=ракообразными,*prepositional.sg=ракообразном,*prepositional.pl=ракообразных
рало|cf,iом,*genitive.sg=рало,*genitive.pl=рала,*dative.sg=рала,*dative.pl=рал
расист|A
расистка|A
раскольник|A
раскопки|*genitive.sg=раскопок,*dative.sg=раскопкам,*instrumental.sg=раскопками,*prepositional.sg=раскопках
распиздяй|A
распорядитель|cm,A
распорядок|sраспорядк
распространитель|cm,A
распря|pей
распутье|cm,sраспуть,nя,S,*genitive.pl=распутий
рассказчик|A
расстройство|cm,sрасстройств,nа,p
рассудок|sрассудк
растворитель|cm
растеря|A,*genitive.pl=растерь,*accusative.pl=растерь
расхититель|cm,A
ратник|A
рацея|pй
рашпиль|cm
рвач|A,*instrumental.sg=рвачом
реалии|*genitive.sg=реалий,*dative.sg=реалиям,*instrumental.sg=реалиями,*prepositional.sg=реалиях
реалист|A
ребёночек|cf,sдетк,A,*genitive.sg=ребёночка,*dative.sg=ребёночку,*accusative.sg=ребёночка,*instrumental.sg=ребёночком,*prepositional.sg=ребёночке
ребятишки|A,*genitive.sg=ребятишек,*dative.sg=ребятишкам,*accusative.sg=ребятишек,*instrumental.sg=ребятишками,*prepositional.sg=ребятишках
ребятки|A,*genitive.sg=ребяток,*dative.sg=ребяткам,*accusative.sg=ребяток,*instrumental.sg=ребятками,*prepositional.sg=ребятках
ревизор|A
революционер|A
революционерка|A
регент|A
регентство|cm,sрегентств,nа,p
регентша|p,A
редька|*genitive.pl=редек
режиссёр|A
резец|*genitive.pl=резцов,*instrumental.sg=резцом
резидент|A
резня|iёй,pей
резьба|p
рейдерство|cm,sрейдерств,nа,p
рейтузы|*genitive.sg=рейтуз,*dative.sg=рейтузам,*instrumental.sg=рейтузами,*prepositional.sg=рейтузах
рекламодатель|cm,A
рекламодательница|A
рекордер|A
ректор|A
ремень|cm,sремн,iём
ремесленник|A
ремесло|cm,sремёсл,nа,*genitive.sg=ремесла,*genitive.pl=ремёсел,*dative.sg=ремеслу,*instrumental.sg=ремеслом,*prepositional.sg=ремесле
ремешок|sремешк
ренегат|A
рента|p
рентгенограмма|p
репей|sрепь,iём,pёв
репетитор|A
репортёр|A
рептилия|A
респондент|A
реставратор|A
ретушь|cm,gи,dи,iью,lи,S0
реформа|p
реформатор|A
рецензент|A
рецидивист|A
речник|A
решето|cm,sрешёт,nа,p,*genitive.sg=решета,*dative.sg=решету,*instrumental.sg=решетом,*prepositional.sg=решете
ржевитянин|sржевитян,nе,p,A,*genitive.sg=ржевитянина,*dative.sg=ржевитянину,*accusative.sg=ржевитянина,*instrumental.sg=ржевитянином,*prepositional.sg=ржевитянине
ригель|cm
риелтер|A
риелтор|A
рижанин|sрижан,nе,p,A,*genitive.sg=рижанина,*dative.sg=рижанину,*accusative.sg=рижанина,*instrumental.sg=рижанином,*prepositional.sg=рижанине
римлянин|sримлян,nе,p,A,*genitive.sg=римлянина,*dative.sg=римлянину,*accusative.sg=римлянина,*instrumental.sg=римлянином,*prepositional.sg=римлянине
рисунок|sрисунк
рифма|p
риэлтер|A
риэлтор|A
робот|A
ровесник|A
ровесница|A
ровня|pей,A
рог|nа
рогач|A,*instrumental.sg=рогачом
рогоносец|A
роддом|nа
родитель|cm,A
родительница|A
родич|A
родные|cm,A,*genitive.sg=родных,*dative.sg=родным,*accusative.sg=родных,*instrumental.sg=родными,*prepositional.sg=родных
родня|iёй,pей
родоначальник|A
родословная|cm,*nominative.pl=родословные,*genitive.sg=родословной,*genitive.pl=родословных,*dative.sg=родословной,*dative.pl=родословным,*accusative.sg=родословную,*instrumental.sg=родословной,*instrumental.pl=родословными,*prepositional.sg=родословной,*prepositional.pl=родословных
родственник|A
родственница|A
рок-группа|p
рок-н-ролл|*nominative.sg=рок-н-ролл-,*genitive.sg=рок-н-ролла-,*dative.sg=рок-н-роллу-,*accusative.sg=рок-н-ролл-,*instrumental.sg=рок-н-роллом-,*prepositional.sg=рок-н-ролле-
ронин|A
росомаха|A
россиянин|sроссиян,nе,p,A,*genitive.sg=россиянина,*dative.sg=россиянину,*accusative.sg=россиянина,*instrumental.sg=россиянином,*prepositional.sg=россиянине
россиянка|A
рост|nа
ростовчанин|sростовчан,nе,p,A,*genitive.sg=ростовчанина,*dative.sg=ростовчанину,*accusative.sg=ростовчанина,*instrumental.sg=ростовчанином,*prepositional.sg=ростовчанине
ростовщик|A
ростовщица|A
росток|sростк
рояль|cm
рубанок|sрубанк
рубеж|*instrumental.sg=рубежом
рубец|*genitive.pl=рубцов,*instrumental.sg=рубцом
рублишко|nы
рубль|cm,iём
ругательство|cm,sругательств,nа,p
руготня|iёй,pей
руда|gа,*genitive.pl=руды,*dative.sg=руды,*dative.pl=руд
ружейник|A
ружьё|cm,sружь,iём,nя,S,*genitive.pl=ружей
ружьецо|cm,sружьец,nа,p,*instrumental.sg=ружьецом
рукав|nа
рукаводержатель|cm
рукобитье|cm,sрукобить,nя,S,*genitive.pl=рукобитий
рукоборье|cm,sрукоборь,nя,S,*genitive.pl=рукоборий
руководство|cm,sруководств,nа,p
рукодельница|A
рукокрылые|cm,A,*genitive.sg=рукокрылых,*dative.sg=рукокрылым,*accusative.sg=рукокрылых,*instrumental.sg=рукокрылыми,*prepositional.sg=рукокрылых
руконожка|A
рукопашная|cm,*nominative.pl=рукопашные,*genitive.sg=рукопашной,*genitive.pl=рукопашных,*dative.sg=рукопашной,*dative.pl=рукопашным,*accusative.sg=рукопашную,*accusative.pl=рукопашные,*instrumental.sg=рукопашной,*instrumental.pl=рукопашными,*prepositional.sg=рукопашной,*prepositional.pl=рукопашных
рукоплескания|cm,*genitive.sg=рукоплесканий,*dative.sg=рукоплесканиям,*instrumental.sg=рукоплесканиями,*prepositional.sg=рукоплесканиях
рукоприкладство|cm,sрукоприкладств,nа,p
рулевой|A,*genitive.sg=рулевого,*dative.sg=рулевому,*accusative.sg=рулевого,*instrumental.sg=рулевым,*prepositional.sg=рулевом
руль|cm,iём
румба|p
румпель|cm
румын|A
румынка|A
румынский|*genitive.sg=румынского,*dative.sg=румынскому,*instrumental.sg=румынским,*prepositional.sg=румынском
румяна|cm,*genitive.sg=румян,*dative.sg=румянам,*instrumental.sg=румянами,*prepositional.sg=румянах
рунетчик|A
рус|A
русак|A
русалка|A
русин|A
русист|A
русич|A
русло|cm,sрусл,nа,*genitive.pl=русел
русофил|A
русская|cm,*nominative.pl=русские,*genitive.sg=русской,*genitive.pl=русских,*dative.sg=русской,*dative.pl=русским,*accusative.sg=русскую,*instrumental.sg=русской,*instrumental.pl=русскими,*prepositional.sg=русской,*prepositional.pl=русских
русскоговорящий|A,*genitive.sg=русскоговорящего,*dative.sg=русскоговорящему,*accusative.sg=русскоговорящего,*instrumental.sg=русскоговорящим,*prepositional.sg=русскоговорящем
ручательство|cm,sручательств,nа,p
ручеёк|sручейк
ручнист|A
ручница|A
рушанин|sрушан,nе,p,A,*genitive.sg=рушанина,*dative.sg=рушанину,*accusative.sg=рушанина,*instrumental.sg=рушанином,*prepositional.sg=рушанине
рыба-ангел|sрыбам-ангел,A,*nominative.pl=рыбы-ангелы,*genitive.sg=рыбы-ангела,*genitive.pl=рыб-ангелов,*dative.sg=рыбе-ангелу,*accusative.sg=рыбу-ангела,*accusative.pl=рыб-ангелов,*instrumental.sg=рыбой-ангелом,*instrumental.pl=рыбами-ангелами,*prepositional.sg=рыбе-ангеле,*prepositional.pl=рыбах-ангелах
рыба-кит|sрыбам-кит,A,*nominative.pl=рыбы-киты,*genitive.sg=рыбы-кита,*genitive.pl=рыб-китов,*dative.sg=рыбе-киту,*accusative.sg=рыбу-кита,*accusative.pl=рыб-китов,*instrumental.sg=рыбой-китом,*instrumental.pl=рыбами-китами,*prepositional.sg=рыбе-ките,*prepositional.pl=рыбах-китах
рыба-удильщик|sрыбам-удильщик,A,*nominative.pl=рыбы-удильщики,*genitive.sg=рыбы-удильщика,*genitive.pl=рыб-удильщиков,*dative.sg=рыбе-удильщику,*accusative.sg=рыбу-удильщика,*accusative.pl=рыб-удильщиков,*instrumental.sg=рыбой-удильщиком,*instrumental.pl=рыбами-удильщиками,*prepositional.sg=рыбе-удильщике,*prepositional.pl=рыбах-удильщиках
рыбак|A
рыбарь|cm,iём,A
рыболов|A
рыболовка|p,A
рыболовство|cm,sрыболовств,nа,p
рыбопромышленник|A
рывок|sрывк
рынок|sрынк
рыцарь|cm,A
рюрик|A
рядовой|A,*genitive.sg=рядового,*dative.sg=рядовому,*accusative.sg=рядового,*instrumental.sg=рядовым,*prepositional.sg=рядовом
сабинянин|sсабинян,nе,p,A,*genitive.sg=сабинянина,*dative.sg=сабинянину,*accusative.sg=сабинянина,*instrumental.sg=сабинянином,*prepositional.sg=сабинянине
сабля|*genitive.pl=сабель
саванна|p
садист|A
садовник|A
садовод|A
садоводство|cm,sсадоводств,nа,p
сажа|gа,dи,lе,*genitive.pl=сажи,*dative.pl=саж
сазандарь|cm,A
сакля|pей
сакс|A
саксофонист|A
салага|A
салака|A
саламандра|p,A
самаритянин|sсамаритян,nе,p,A,*genitive.sg=самаритянина,*dative.sg=самаритянину,*accusative.sg=самаритянина,*instrumental.sg=самаритянином,*prepositional.sg=самаритянине
самба|p
самец|A,*genitive.pl=самцов,*accusative.pl=самцов,*instrumental.sg=самцом
самка|A
самоваришко|nы
самоварище|cm,sсамоварищ,nа,p
самодержец|A
самодовольство|cm,sсамодовольств,nа,p
самоедство|cm,sсамоедств,nа,p
самозванец|A
самолёт-заправщик|sсамолётам-заправщик,*nominative.pl=самолёты-заправщики,*genitive.sg=самолёта-заправщика,*genitive.pl=самолётов-заправщиков,*dative.sg=самолёту-заправщику,*accusative.pl=самолёты-заправщики,*instrumental.sg=самолётом-заправщиком,*instrumental.pl=самолётами-заправщиками,*prepositional.sg=самолёте-заправщике,*prepositional.pl=самолётах-заправщиках
самолёт-снаряд|sсамолётам-снаряд,*nominative.pl=самолёты-снаряды,*genitive.sg=самолёта-снаряда,*genitive.pl=самолётов-снарядов,*dative.sg=самолёту-снаряду,*accusative.pl=самолёты-снаряды,*instrumental.sg=самолётом-снарядом,*instrumental.pl=самолётами-снарядами,*prepositional.sg=самолёте-снаряде,*prepositional.pl=самолётах-снарядах
самородок|sсамородк
самоубийство|cm,sсамоубийств,nа,p
самоубийца|p,A
самоучка|A
самурай|A
сангвиник|A
сани|*genitive.sg=саней,*dative.sg=саням,*instrumental.sg=санями,*prepositional.sg=санях
санитар|A
санитарка|A
санктпетербуржец|A
сантехник|A
сантименты|*genitive.sg=сантиментов,*dative.sg=сантиментам,*instrumental.sg=сантиментами,*prepositional.sg=сантиментах
санфранцисец|A
сапёр|A
сапог|p
сапожник|A
сапсан|A
саранча|pей,*instrumental.sg=саранчой
саранчук|A
сарацин|A
сатана|A
сатанист|A
сатирик|A
сатрап|A
сатурналии|*genitive.sg=сатурналий,*dative.sg=сатурналиям,*instrumental.sg=сатурналиями,*prepositional.sg=сатурналиях
сахар|nа
сачок|sсачк
сборище|cm,sсборищ,nа,p
сборная|cm,*nominative.pl=сборные,*genitive.sg=сборной,*genitive.pl=сборных,*dative.sg=сборной,*dative.pl=сборным,*accusative.sg=сборную,*accusative.pl=сборные,*instrumental.sg=сборной,*instrumental.pl=сборными,*prepositional.sg=сборной,*prepositional.pl=сборных
сбруя|pй
свадьба|*genitive.pl=свадеб
сварщик|A
сват|A
свая|pй
свёкла|p
свёкор|sсвёкр,A
свекровь|A
свердловчанин|sсвердловчан,nе,p,A,*genitive.sg=свердловчанина,*dative.sg=свердловчанину,*accusative.sg=свердловчанина,*instrumental.sg=свердловчанином,*prepositional.sg=свердловчанине
сверло|cm,sсвёрл,nа,p,*genitive.sg=сверла,*dative.sg=сверлу,*instrumental.sg=сверлом,*prepositional.sg=сверле
сверстник|A
сверстница|A
свёрток|sсвёртк
сверчок|sсверчк,A
светильня|*genitive.pl=светилен
светляк|A
светлячок|sсветлячк,A
свеча|pей,*instrumental.sg=свечой
свиданье|cm,sсвидань,nя,S,*genitive.pl=свиданий
свидетель|cm,A
свидетельство|cm,sсвидетельств,nа,p
свинец|*genitive.pl=свинцов,*instrumental.sg=свинцом
свинство|cm,sсвинств,nа,p
свинья|iёй,*genitive.pl=свиней
свисток|sсвистк
свистулька|*genitive.pl=свистулек
свиток|sсвитк
сводник|A
сводня|pей,A
свояк|A
свояченица|A
связист|A
связной|A,*genitive.sg=связного,*dative.sg=связному,*accusative.sg=связного,*instrumental.sg=связным,*prepositional.sg=связном
святейшество|cm,sсвятейшеств,nа,p
святилище|cm,sсвятилищ,nа,p
святитель|cm,A
святыня|*genitive.pl=святынь
священник|A
священнослужитель|cm,A
сгусток|sсгустк
северянин|sсеверян,nе,p,A,*genitive.sg=северянина,*dative.sg=северянину,*accusative.sg=северянина,*instrumental.sg=северянином,*prepositional.sg=северянине
севрюга|A
седло|cm,sсёдл,nа,*genitive.sg=седла,*genitive.pl=сёдел,*dative.sg=седлу,*instrumental.sg=седлом,*prepositional.sg=седле
седьмая|cm,*nominative.pl=седьмые,*genitive.sg=седьмой,*genitive.pl=седьмых,*dative.sg=седьмой,*dative.pl=седьмым,*accusative.sg=седьмую,*accusative.pl=седьмые,*instrumental.sg=седьмой,*instrumental.pl=седьмыми,*prepositional.sg=седьмой,*prepositional.pl=седьмых
секира|gа,*genitive.pl=секиры,*dative.sg=секиры,*dative.pl=секир
секретарша|p
секретарь|cm,iём,A
секс-бомба|p,A
сексапилочка|A
сексист|A
сексолог|A
секта|p
сектор|nа
секунда|p
секундант|A
селезень|cm,sселезн,A
сель|cm
сельдь|A
сельцо|cm,sсельц,nа,*genitive.pl=селец,*instrumental.sg=сельцом
сельчанин|sсельчан,nе,p,A,*genitive.sg=сельчанина,*dative.sg=сельчанину,*accusative.sg=сельчанина,*instrumental.sg=сельчанином,*prepositional.sg=сельчанине
селянин|sселян,nе,p,A,*genitive.sg=селянина,*dative.sg=селянину,*accusative.sg=селянина,*instrumental.sg=селянином,*prepositional.sg=селянине
сёмга|p
семейство|cm,sсемейств,nа,p
семенодоля|pей
семечко|nы
семьянин|sсемьян,nе,p,A,*genitive.sg=семьянина,*dative.sg=семьянину,*accusative.sg=семьянина,*instrumental.sg=семьянином,*prepositional.sg=семьянине
семядоля|pей
сенатор|A
сенбернар|A
сенешаль|cm,A
сенокосец|A
сентябрь|cm,iём
сеньёр|A
сепаратист|A
серб|A
сербиянин|sсербиян,nе,p,A,*genitive.sg=сербиянина,*dative.sg=сербиянину,*accusative.sg=сербиянина,*instrumental.sg=сербиянином,*prepositional.sg=сербиянине
сербка|A
сербскохорватский|*genitive.sg=сербскохорватского,*dative.sg=сербскохорватскому,*instrumental.sg=сербскохорватским,*prepositional.sg=сербскохорватском
сердечко|nы
середа|*genitive.pl=серёд
сержант|A
серна|p,A
серпуховчанин|sсерпуховчан,nе,p,A,*genitive.sg=серпуховчанина,*dative.sg=серпуховчанину,*accusative.sg=серпуховчанина,*instrumental.sg=серпуховчанином,*prepositional.sg=серпуховчанине
серьга|*genitive.pl=серёг
сестра|*nominative.pl=сёстры,*genitive.pl=сестёр,*dative.pl=сёстрам,*instrumental.pl=сёстрами,*prepositional.pl=сёстрах
сестрёнка|A
сестринство|cm,sсестринств,nа,p
сестрица|A
сестричка|A
сеттер|A
сибиряк|A
сиверко|nы
сиг|A
сиги|A,*genitive.sg=сигов,*dative.sg=сигам,*accusative.sg=сигов,*instrumental.sg=сигами,*prepositional.sg=сигах
сиговые|cm,A,*genitive.sg=сиговых,*dative.sg=сиговым,*accusative.sg=сиговых,*instrumental.sg=сиговыми,*prepositional.sg=сиговых
сиделка|A
сиденье|cm,sсидень,nя,S,*genitive.pl=сидений
силач|A,*instrumental.sg=силачом
силезский|*genitive.sg=силезского,*dative.sg=силезскому,*instrumental.sg=силезским,*prepositional.sg=силезском
сило|cm,sсиль,nя,S,*genitive.sg=сила,*dative.sg=силу,*instrumental.sg=силом,*prepositional.sg=силе
силовик|A
сингальский|*genitive.sg=сингальского,*dative.sg=сингальскому,*instrumental.sg=сингальским,*prepositional.sg=сингальском
синтагма|p
синька|*genitive.pl=синек
сионист|A
сир|A
сисадмин|A
сиська|*genitive.pl=сисек
сито|cf,iом,*genitive.sg=сито,*genitive.pl=сита,*dative.sg=сита,*dative.pl=сит
сифилитик|A
сиятельство|cm,sсиятельств,nа,p
сказуемое|cm,*nominative.pl=сказуемые,*genitive.sg=сказуемого,*genitive.pl=сказуемых,*dative.sg=сказуемому,*dative.pl=сказуемым,*accusative.pl=сказуемые,*instrumental.sg=сказуемым,*instrumental.pl=сказуемыми,*prepositional.sg=сказуемом,*prepositional.pl=сказуемых
скальпель|cm
скалярия|A
скамейка|*genitive.pl=скамеек
скамья|iёй,*genitive.pl=скамей
скаут|A
скачок|sскачк
скворец|A,*genitive.pl=скворцов,*instrumental.sg=скворцом
сквоттер|A
скептик|A
скинхед|A
скирда|p
скиф|A
скобель|cm
скоморох|A
скопец|*genitive.sg=скопец,*genitive.pl=скопцы,*dative.sg=скопца,*dative.pl=скопцов,*instrumental.sg=скопцом
скорпион|A
скотина|A
скотобойня|*genitive.pl=скотобойнь
скотт|A
скрипач|A,*instrumental.sg=скрипачом
скромник|A
скряга|A
скульптор|A
скумбрия|A
скунс|A
скупец|sскупец,A,*genitive.pl=скупецов,*accusative.pl=скупецов,*instrumental.sg=скупецом
скуфья|iёй,*genitive.pl=скуфей
славист|A
славянин|sславян,nе,p,A,*genitive.sg=славянина,*dative.sg=славянину,*accusative.sg=славянина,*instrumental.sg=славянином,*prepositional.sg=славянине
славянка|A
славянофил|A
слагаемое|cm,*nominative.pl=слагаемые,*genitive.sg=слагаемого,*genitive.pl=слагаемых,*dative.sg=слагаемому,*dative.pl=слагаемым,*accusative.pl=слагаемые,*instrumental.sg=слагаемым,*instrumental.pl=слагаемыми,*prepositional.sg=слагаемом,*prepositional.pl=слагаемых
сладкоежка|A
сластёна|A
сласти|*genitive.sg=сластей,*dative.sg=сластям,*instrumental.sg=сластями,*prepositional.sg=сластях
следователь|cm,A
следующее|cm,*nominative.pl=следующие,*genitive.sg=следующего,*genitive.pl=следующих,*dative.sg=следующему,*dative.pl=следующим,*accusative.pl=следующие,*instrumental.sg=следующим,*instrumental.pl=следующими,*prepositional.sg=следующем,*prepositional.pl=следующих
слеза|*nominative.pl=слёзы,*genitive.pl=слёз
слепец|A,*genitive.pl=слепцов,*accusative.pl=слепцов,*instrumental.sg=слепцом
слесарь|cm,A
сливки|*genitive.sg=сливок,*dative.sg=сливкам,*instrumental.sg=сливками,*prepositional.sg=сливках
слизень|cm,sслизн,A
слизняк|A
слиток|sслитк
словак|A
словарь|cm,iём
словачка|A
словенец|A
словенка|A
словечко|nы
словоформа|p
словцо|cm,sсловц,nа,*genitive.pl=словец,*instrumental.sg=словцом
слонёнок|sслонят,nа,p,A,*genitive.sg=слонёнка,*dative.sg=слонёнку,*accusative.sg=слонёнка,*instrumental.sg=слонёнком,*prepositional.sg=слонёнке
слонопотам|A
слуга|A
служанка|A
служба|p
служитель|cm,A
слухи|*genitive.sg=слухов,*dative.sg=слухам,*instrumental.sg=слухами,*prepositional.sg=слухах
случившееся|cm,*nominative.pl=случившиеся,*genitive.sg=случившегося,*genitive.pl=случившихся,*dative.sg=случившемуся,*dative.pl=случившимся,*accusative.pl=случившиеся,*instrumental.sg=случившимся,*instrumental.pl=случившимися,*prepositional.sg=случившемся,*prepositional.pl=случившихся
смальта|p
смельчак|A
смертник|A
смерш|iем
смеситель|cm
смехуёчки|*genitive.sg=смехуёчков,*dative.sg=смехуёчкам,*instrumental.sg=смехуёчками,*prepositional.sg=смехуёчках
смешок|sсмешк
смоква|p
смолянин|sсмолян,nе,p,A,*genitive.sg=смолянина,*dative.sg=смолянину,*accusative.sg=смолянина,*instrumental.sg=смолянином,*prepositional.sg=смолянине
смотритель|cm,A
смуглянка|A
смычок|sсмычк
снадобье|cm,sснадобь,nя,S,*genitive.pl=снадобий
снайпер|A
снегирь|cm,iём,A
снеговик|A
снежок|sснежк
снимок|sснимк
сноб|A
снотворное|cm,*nominative.pl=снотворные,*genitive.sg=снотворного,*genitive.pl=снотворных,*dative.sg=снотворному,*dative.pl=снотворным,*accusative.pl=снотворные,*instrumental.sg=снотворным,*instrumental.pl=снотворными,*prepositional.sg=снотворном,*prepositional.pl=снотворных
сноха|A
снохач|A,*instrumental.sg=снохачом
соавтор|A
соавторство|cm,sсоавторств,nа,p
собачечка|A
собачонка|p,A
собеседник|A
собеседница|A
соблазнитель|cm,A
соборянин|sсоборян,nе,p,A,*genitive.sg=соборянина,*dative.sg=соборянину,*accusative.sg=соборянина,*instrumental.sg=соборянином,*prepositional.sg=соборянине
собранье|cm,sсобрань,nя,S,*genitive.pl=собраний
собрат|nья,A,*genitive.pl=собратьев,*dative.pl=собратьям,*accusative.pl=собратьев,*instrumental.pl=собратьями,*prepositional.pl=собратьях
собственник|A
собутыльник|A
совёнок|sсовят,nа,p,A,*genitive.sg=совёнка,*dative.sg=совёнку,*accusative.sg=совёнка,*instrumental.sg=совёнком,*prepositional.sg=совёнке
совершенство|cm,sсовершенств,nа,p
советник|A
советница|A
советчик|A
советчица|A
совместительство|cm,sсовместительств,nа,p
совок|sсовк
современник|A
согражданин|sсограждан,nе,p,A,*genitive.sg=согражданина,*dative.sg=согражданину,*accusative.sg=согражданина,*instrumental.sg=согражданином,*prepositional.sg=согражданине
содержимое|cm,*genitive.sg=содержимого,*dative.sg=содержимому,*instrumental.sg=содержимым,*prepositional.sg=содержимом
содомит|A
содружество|cm,sсодружеств,nа,p
создатель|cm,A
созидатель|cm,A
соискатель|cm,A
соискательница|A
сойка|A,*genitive.pl=соек,*accusative.pl=соек
сокол|A
соколёнок|sсоколят,nа,p,A,*genitive.sg=соколёнка,*dative.sg=соколёнку,*accusative.sg=соколёнка,*instrumental.sg=соколёнком,*prepositional.sg=соколёнке
сокровище|cm,sсокровищ,nа,p
солдат|p,A
солдатик|A
солдатня|iёй,pей
солильня|*genitive.pl=солилен
солист|A
солнце|cm,sсолнц,nа,p
соловей|sсоловь,iём,pёв,A
соловейко|cm,sсоловейк,A,*genitive.pl=соловеек,*accusative.pl=соловеек
солодильня|*genitive.pl=солодилен
сомалиец|A
сомовые|cm,A,*genitive.sg=сомовых,*dative.sg=сомовым,*accusative.sg=сомовых,*instrumental.sg=сомовыми,*prepositional.sg=сомовых
сомообразные|cm,A,*genitive.sg=сомообразных,*dative.sg=сомообразным,*accusative.sg=сомообразных,*instrumental.sg=сомообразными,*prepositional.sg=сомообразных
соня|A,*genitive.pl=сонь,*accusative.pl=сонь
соня-полчок|sсоням-полчк,A,*nominative.pl=сони-полчки,*genitive.sg=сони-полчка,*genitive.pl=сонь-полчков,*dative.sg=соне-полчку,*accusative.sg=соню-полчка,*accusative.pl=сонь-полчков,*instrumental.sg=соней-полчком,*instrumental.pl=сонями-полчками,*prepositional.sg=соне-полчке,*prepositional.pl=сонях-полчках
сообщество|cm,sсообществ,nа,p
сообщник|A
сообщница|A
соотечественник|A
соперник|A
соперница|A
соперничество|cm,sсоперничеств,nа,p
соплеменник|A
сопли|*genitive.sg=соплей,*dative.sg=соплям,*instrumental.sg=соплями,*prepositional.sg=соплях
сопло|cm,sсопл,nа,*genitive.pl=сопел
сопредседатель|cm,A
сопровождающий|A,*genitive.sg=сопровождающего,*dative.sg=сопровождающему,*accusative.sg=сопровождающего,*instrumental.sg=сопровождающим,*prepositional.sg=сопровождающем
соратник|A
сорвиголова|sсорвголов,A,*nominative.sg=сорвголова
сорт|nа
сортировка|p
сосед|gа,dу,iом,pей,S,A
соседка|A
соседство|cm,sсоседств,nа,p
сослуживец|A
сосна|*genitive.pl=сосен
составитель|cm,A
составляющая|cm,*nominative.pl=составляющие,*genitive.sg=составляющей,*genitive.pl=составляющих,*dative.sg=составляющей,*dative.pl=составляющим,*accusative.sg=составляющую,*accusative.pl=составляющие,*instrumental.sg=составляющей,*instrumental.pl=составляющими,*prepositional.sg=составляющей,*prepositional.pl=составляющих
сосулька|*genitive.pl=сосулек
сотник|A
сотовый|*genitive.sg=сотового,*dative.sg=сотовому,*instrumental.sg=сотовым,*prepositional.sg=сотовом
сотрудник|A
сотрудница|A
сотрудничество|cm,sсотрудничеств,nа,p
соты|*genitive.sg=сот,*dative.sg=сотам,*instrumental.sg=сотами,*prepositional.sg=сотах
соучастник|A
соучастница|A
сохозяин|sсохозяев,nа,p,A,*genitive.sg=сохозяина,*dative.sg=сохозяину,*accusative.sg=сохозяина,*instrumental.sg=сохозяином,*prepositional.sg=сохозяине
социал-демократ|A
социалист|A
социнианин|sсоциниан,nе,p,A,*genitive.sg=социнианина,*dative.sg=социнианину,*accusative.sg=социнианина,*instrumental.sg=социнианином,*prepositional.sg=социнианине
социолог|A
сочинитель|cm,A
союзник|A
союзница|A
соя|pй
спайка|*genitive.pl=спаек
спальня|*genitive.pl=спален
спаниель|cm,A
спаржа|p
спасатель|cm,A
спаситель|cm,A
спектакль|cm
спекулянт|A
спелеолог|A
сперма|p
спец|sспец,A,*genitive.pl=спецов,*accusative.pl=спецов,*instrumental.sg=спецом
специалист|A
спецназовец|A
спецпредставитель|cm,A
спецслужба|p
спиртное|cm,*genitive.sg=спиртного,*dative.sg=спиртному,*instrumental.sg=спиртным,*prepositional.sg=спиртном
список|sсписк
спичрайтер|A
сплетник|A
сплетница|A
спличанин|sспличан,nе,p,A,*genitive.sg=спличанина,*dative.sg=спличанину,*accusative.sg=спличанина,*instrumental.sg=спличанином,*prepositional.sg=спличанине
спличанка|A
сподвижник|A
спонсор|A
спортсмен|A
спортсменка|A
спрингер|A
спринтер|A
спутница|A
спящий|A,*genitive.sg=спящего,*dative.sg=спящему,*accusative.sg=спящего,*instrumental.sg=спящим,*prepositional.sg=спящем
сральня|*genitive.pl=срален
средневековье|cm,sсредневековь,nя,S,*genitive.pl=средневековий
среднее|cm,*nominative.pl=средние,*genitive.sg=среднего,*genitive.pl=средних,*dative.sg=среднему,*dative.pl=средним,*accusative.pl=средние,*instrumental.sg=средним,*instrumental.pl=средними,*prepositional.sg=среднем,*prepositional.pl=средних
средство|cm,sсредств,nа,p
сродство|cm,sсродств,nа,p
ставень|cm,sставн
стажёр|A
стайка|*genitive.pl=стаек
стаксель|cm
сталкер|A
станок|sстанк
станок-качалка|cm,sстанкам-качалк,*nominative.pl=станки-качалки,*genitive.sg=станка-качалки,*genitive.pl=станков-качалок,*dative.sg=станку-качалке,*accusative.sg=станок-качалку,*accusative.pl=станки-качалки,*instrumental.sg=станком-качалкой,*instrumental.pl=станками-качалками,*prepositional.sg=станке-качалке,*prepositional.pl=станках-качалках
стапель|cm,nя
старейшина|A
старичок|sстаричк,A
старое|cm,*nominative.pl=старые,*genitive.sg=старого,*genitive.pl=старых,*dative.sg=старому,*dative.pl=старым,*accusative.pl=старые,*instrumental.sg=старым,*instrumental.pl=старыми,*prepositional.sg=старом,*prepositional.pl=старых
старожил|A
старорусец|A
старорушанин|sстарорушан,nе,p,A,*genitive.sg=старорушанина,*dative.sg=старорушанину,*accusative.sg=старорушанина,*instrumental.sg=старорушанином,*prepositional.sg=старорушанине
староста|p,A
старпом|A
старшеклассник|A
старшина|A
статуя|pй
статья|iёй,*genitive.pl=статей
стая|pй
стебель|cm,sстебл
стега|gа,dи,lе,*genitive.pl=стеги,*dative.pl=стёг
стегно|sстёгн,*genitive.sg=стегна,*dative.sg=стегну,*instrumental.sg=стегном,*prepositional.sg=стегне
стегозавр|A
стезя|gя,dи,iёй,lе,*genitive.pl=стези,*dative.pl=стезей
стекольщик|A
стеллаж|*instrumental.sg=стеллажом
стенограмма|p
стерва|p,A
стервятник|A
стержень|cm,sстержн
стерлядь|A
стерх|A
стиль|cm
стиляга|A
стишок|sстишк
стойка|*genitive.pl=стоек
столбец|*genitive.pl=столбцов,*instrumental.sg=столбцом
столовая|cm,*nominative.pl=столовые,*genitive.sg=столовой,*genitive.pl=столовых,*dative.sg=столовой,*dative.pl=столовым,*accusative.sg=столовую,*instrumental.sg=столовой,*instrumental.pl=столовыми,*prepositional.sg=столовой,*prepositional.pl=столовых
столоначальник|A
столяр|A
стоматолог|A
сторож|nа,A
сторонник|A
сторонница|A
страдалец|A
стражник|A
страна-участница|cm,sстранам-участниц,*nominative.pl=страны-участницы,*genitive.sg=страны-участницы,*genitive.pl=стран-участниц,*dative.sg=стране-участнице,*accusative.sg=страну-участницу,*accusative.pl=страны-участницы,*instrumental.sg=страной-участницей,*instrumental.pl=странами-участницами,*prepositional.sg=стране-участнице,*prepositional.pl=странах-участницах
странник|A
стратег|A
страус|A
страхователь|cm,A
страховщик|A
стрелец|A,*genitive.pl=стрельцов,*accusative.pl=стрельцов,*instrumental.sg=стрельцом
стрельбище|cm,sстрельбищ,nа,p
стремя|cm,sстремен,gи,dи,iем,lи,nа,*genitive.pl=стремян
стригольник|A
стриж|A,*instrumental.sg=стрижом
стриптизёр|A
стриптизёрша|p,A
строитель|cm,A
строительница|A
строительство|cm,sстроительств,nа,p
стройка|*genitive.pl=строек
стругач|*instrumental.sg=стругачом
струйка|*genitive.pl=струек
струп|nья,*genitive.pl=струпьев,*dative.pl=струпьям,*instrumental.pl=струпьями,*prepositional.pl=струпьях
струя|gя,dи,iёй,lе,*genitive.pl=струи,*dative.pl=струй
стрый|A
стряпня|iёй,pей
студенец|*genitive.pl=студенцов,*instrumental.sg=студенцом
студент|A
студень|cm,sстудн
стукач|A,*instrumental.sg=стукачом
ступенька|*genitive.pl=ступенек
ступня|iёй,pей
стюард|A
стюардесса|p
суверен|A
судак|A
сударыня|A,*genitive.pl=сударынь,*accusative.pl=сударынь
сударь|cm,A
судия|A
судмедэксперт|A
судомойня|*genitive.pl=судомоен
судопроизводство|cm,sсудопроизводств,nа,p
судьба|*genitive.pl=судеб
судья|iёй,*genitive.pl=судей
суккуб|A
сукновальня|*genitive.pl=сукновален
сумма|p
сундучок|sсундучк
сурок|sсурк,A
суслик|A
сутенёр|A
сутра|p
суфлёр|A
сухарь|cm,iём
сухоручка|A
сушильня|*genitive.pl=сушилен
сушь|cm,gи,dи,iью,lи,S0
существительное|cm,*nominative.pl=существительные,*genitive.sg=существительного,*genitive.pl=существительных,*dative.sg=существительному,*dative.pl=существительным,*instrumental.sg=существительным,*instrumental.pl=существительными,*prepositional.sg=существительном,*prepositional.pl=существительных
существо|cm,sсуществ,nа,p
сфинкс|A
сходня|pей
сходство|cm,sсходств,nа,p
сценарист|A
счастливец|A
счастливчик|A
счастье|cm,sсчасть,nя,S,*genitive.pl=счастий
счетовод|A
счёты|*genitive.sg=счётов,*dative.sg=счётам,*instrumental.sg=счётами,*prepositional.sg=счётах
сшиватель|cm
сынишка|A
сынок|sсынк,A
сыночек|sсыночк,A
сыч|A,*instrumental.sg=сычом
сыщик|A
сэр|A
сяжок|sсяжк
табельщик|A
тавро|cm,sтавр,nа,p
таджик|A
таджикский|*genitive.sg=таджикского,*dative.sg=таджикскому,*instrumental.sg=таджикским,*prepositional.sg=таджикском
таджичка|A
таец|A
таинство|cm,sтаинств,nа,p
таитянин|sтаитян,nе,p,A,*genitive.sg=таитянина,*dative.sg=таитянину,*accusative.sg=таитянина,*instrumental.sg=таитянином,*prepositional.sg=таитянине
тайка|A,*genitive.pl=таек,*accusative.pl=таек
тайконавт|A
тайцзицюань|cm
таксидермист|A
таксист|A
талыш|A,*instrumental.sg=талышом
тамильский|*genitive.sg=тамильского,*dative.sg=тамильскому,*instrumental.sg=тамильским,*prepositional.sg=тамильском
таможенник|A
тамплиер|A
танкист|A
танцовщик|A
танцовщица|A
танцор|A
тапир|A
тапочки|*genitive.sg=тапочек,*dative.sg=тапочкам,*instrumental.sg=тапочками,*prepositional.sg=тапочках
таракан|A
татарин|sтатар,p,A,*genitive.sg=татарина,*dative.sg=татарину,*accusative.sg=татарина,*instrumental.sg=татарином,*prepositional.sg=татарине
татарка|A
татарский|*genitive.sg=татарского,*dative.sg=татарскому,*instrumental.sg=татарским,*prepositional.sg=татарском
тать|cm,*genitive.sg=тать,*genitive.pl=тати,*dative.sg=татя,*dative.pl=татей
тахта|p
твердыня|*genitive.pl=твердынь
тверитянин|sтверитян,nе,p,A,*genitive.sg=тверитянина,*dative.sg=тверитянину,*accusative.sg=тверитянина,*instrumental.sg=тверитянином,*prepositional.sg=тверитянине
творец|A,*genitive.pl=творцов,*accusative.pl=творцов,*instrumental.sg=творцом
творчество|cm,sтворчеств,nа,p
тёзка|A
теист|A
телеведущая|cm,A,*nominative.pl=телеведущие,*genitive.sg=телеведущей,*genitive.pl=телеведущих,*dative.sg=телеведущей,*dative.pl=телеведущим,*accusative.sg=телеведущую,*accusative.pl=телеведущих,*instrumental.sg=телеведущей,*instrumental.pl=телеведущими,*prepositional.sg=телеведущей,*prepositional.pl=телеведущих
телеведущий|nе,A,*genitive.sg=телеведущего,*genitive.pl=телеведущих,*dative.sg=телеведущему,*dative.pl=телеведущим,*accusative.sg=телеведущего,*accusative.pl=телеведущих,*instrumental.sg=телеведущим,*instrumental.pl=телеведущими,*prepositional.sg=телеведущем,*prepositional.pl=телеведущих
телеграмма|p
телеграфист|A
телезритель|cm,A
телёнок|sтелят,nа,p,A,*genitive.sg=телёнка,*dative.sg=телёнку,*accusative.sg=телёнка,*instrumental.sg=телёнком,*prepositional.sg=телёнке
телепрограмма|p
телеса|cm,*genitive.sg=телес,*dative.sg=телесам,*instrumental.sg=телесами,*prepositional.sg=телесах
телефонист|A
тёлка|A
телогрейка|*genitive.pl=телогреек
телохранитель|cm,A
тёлочка|A
темя|cm,sтемен,gи,dи,iем,lи,nа,*genitive.pl=темён
теннисист|A
теолог|A
теоретик|A
террорист|A
тесло|cm,sтёсл,nа,*genitive.sg=тесла,*genitive.pl=тёсел,*dative.sg=теслу,*instrumental.sg=теслом,*prepositional.sg=тесле
тесто|cm,sтест,nа,p
тесть|cm,A
тесьма|p
тет-а-тет|*nominative.sg=тет-а-тет-,*nominative.pl=тет-а-теты-,*genitive.sg=тет-а-тета-,*genitive.pl=тет-а-тетов-,*dative.sg=тет-а-тету-,*dative.pl=тет-а-тетам-,*accusative.sg=тет-а-тет-,*accusative.pl=тет-а-теты-,*instrumental.sg=тет-а-тетом-,*instrumental.pl=тет-а-тетами-,*prepositional.sg=тет-а-тете-,*prepositional.pl=тет-а-тетах-
тётенька|A,*genitive.pl=тётенек,*accusative.pl=тётенек
тетерев|nа,A
тётка|A
тетрарх|A
тётушка|A
тётя|*genitive.pl=тёть
тефтели|*genitive.sg=тефтелей,*dative.sg=тефтелям,*instrumental.sg=тефтелями,*prepositional.sg=тефтелях
техасец|A
технолог|A
технорук|A
тигель|cm,sтигл
тигр|A
тигрёнок|sтигрят,nа,p,A,*genitive.sg=тигрёнка,*dative.sg=тигрёнку,*accusative.sg=тигрёнка,*instrumental.sg=тигрёнком,*prepositional.sg=тигрёнке
тильда|p
тинейджер|A
тираж|*instrumental.sg=тиражом
тиранн|A
тиранозавр|A
тиски|*genitive.sg=тисков,*dative.sg=тискам,*instrumental.sg=тисками,*prepositional.sg=тисках
титька|*genitive.pl=титек
тихарь|cm,iём,A
тихоня|pей,A
тихоходка|A
ткач|A,*instrumental.sg=ткачом
тло|cm,sтл,nа,*genitive.pl=тёл
тля|iёй,pей,A
товарищ|A
товарищество|cm,sтовариществ,nа,p
товарка|A
тождество|cm,sтождеств,nа,p
тойтерьер|A
токарь|cm,A
токиец|A
токийка|A,*genitive.pl=токиек,*accusative.pl=токиек
толмач|A,*instrumental.sg=толмачом
толпа|p
толстосум|A
толстяк|A
толчея|iёй
толчок|sтолчк
толща|p
том|nа
тонна|p
тоннель|cm
тоня|pей
топка|p
тополь|cm,nя
топсель|cm
торба|p
торговец|A
торговля|*genitive.pl=торговель
торец|*genitive.pl=торцов,*instrumental.sg=торцом
торжество|cm,sторжеств,nа,p
тормоз|nа
торока|cm,*genitive.sg=тороков,*dative.sg=торокам,*instrumental.sg=тороками,*prepositional.sg=тороках
торопчанин|sторопчан,nе,p,A,*genitive.sg=торопчанина,*dative.sg=торопчанину,*accusative.sg=торопчанина,*instrumental.sg=торопчанином,*prepositional.sg=торопчанине
торопыга|A
тортилья|*genitive.pl=тортилий
точильня|*genitive.pl=точилен
травля|*genitive.pl=травель
травма|p
традиционалист|A
тракторист|A
трансвестит|A
трансгендер|A
транспортировщик|A
транссексуал|A
траншея|pй
трасса|p
трахея|pй
тренер|A
трензель|cm,nя
тресковые|cm,A,*genitive.sg=тресковых,*dative.sg=тресковым,*accusative.sg=тресковых,*instrumental.sg=тресковыми,*prepositional.sg=тресковых
трескообразные|cm,A,*genitive.sg=трескообразных,*dative.sg=трескообразным,*accusative.sg=трескообразных,*instrumental.sg=трескообразными,*prepositional.sg=трескообразных
трескотня|iёй,pей
третья|*genitive.sg=третьей,*genitive.pl=третьих,*dative.sg=третьей,*dative.pl=третьим,*instrumental.pl=третьими,*prepositional.sg=третьей,*prepositional.pl=третьих
трибун|A
тризна|p
трисель|cm
троглодит|A
тройка|*genitive.pl=троек
тройня|*genitive.pl=троен
тролль|cm,A
тропарь|cm,iём
троцкист|A
трубадур|A
трубач|A,*instrumental.sg=трубачом
трубкозуб|A
трубочист|A
трудоголик|A
трудоустройство|cm,sтрудоустройств,nа,p
труженик|A
труппа|p
трус|A
трусики|*genitive.sg=трусиков,*dative.sg=трусикам,*instrumental.sg=трусиками,*prepositional.sg=трусиках
трусца|*instrumental.sg=трусцой
трутень|cm,sтрутн,A
трюмсель|cm
трюфель|cm,nя
тряпьё|iём
трясогузка|A
туземец|A
тукан|A
туловище|cm,sтуловищ,nа,p
тумба|p
тундра|p
тунеядец|A
туннель|cm
тупизна|p
тупица|A
турецкий|*genitive.sg=турецкого,*dative.sg=турецкому,*instrumental.sg=турецким,*prepositional.sg=турецком
турист|A
туристка|A
туркмен|A
туркменка|A
турчанка|A
турчонок|sтурчат,nа,p,A,*genitive.sg=турчонка,*dative.sg=турчонку,*accusative.sg=турчонка,*instrumental.sg=турчонком,*prepositional.sg=турчонке
тусовщик|A
тусовщица|A
туфелька|*genitive.pl=туфелек
туфля|*genitive.pl=туфель
тушканчик|A
тушь|cm,gи,dи,iью,lи,S0
тыква|p
тыловик|A
тюбетейка|*genitive.pl=тюбетеек
тюленёнок|sтюленят,nа,p,A,*genitive.sg=тюленёнка,*dative.sg=тюленёнку,*accusative.sg=тюленёнка,*instrumental.sg=тюленёнком,*prepositional.sg=тюленёнке
тюлень|cm,A
тюринг|A
тюрок|cf,sтюрк,gа,dу,iом,lе,A,*accusative.sg=тюрка
тюрьма|*genitive.pl=тюрем
тютя|pей,A
тяга|gа,dи,lе,*genitive.pl=тяги,*dative.pl=тяг
тягач|*instrumental.sg=тягачом
тяжба|p
тятя|gя,dи,lе,*genitive.pl=тяти,*dative.pl=тятей
убежище|cm,sубежищ,nа,p
убийство|cm,sубийств,nа,p
убийца|p
ублюдок|sублюдк,A
уборная|cm,*nominative.pl=уборные,*genitive.sg=уборной,*genitive.pl=уборных,*dative.sg=уборной,*dative.pl=уборным,*accusative.sg=уборную,*accusative.pl=уборные,*instrumental.sg=уборной,*instrumental.pl=уборными,*prepositional.sg=уборной,*prepositional.pl=уборных
уборщица|A
убыток|sубытк
увалень|cm,sувальн,A
увечье|cm,sувечь,nя,S,*genitive.pl=увечий
увлажнитель|cm
угандиец|A
угличанин|sугличан,nе,p,A,*genitive.sg=угличанина,*dative.sg=угличанину,*accusative.sg=угличанина,*instrumental.sg=угличанином,*prepositional.sg=угличанине
угодье|cm,sугодь,nя,S,*genitive.pl=угодий
уголовник|A
уголок|sуголк
уголье|cm,sуголь,nя,S
удав|A
удильщик|A
удлинитель|cm
удмурт|A
удобство|cm,sудобств,nа,p
удод|A
удушье|cm,sудушь,nя,S,*genitive.pl=удуший
уёбок|sуёбк,A
уединенье|cm,sуединень,nя,S,*genitive.pl=уединений
узбек|A
узбечка|A
узда|p
уздцы|*genitive.sg=уздцов,*dative.sg=уздцам,*instrumental.sg=уздцами,*prepositional.sg=уздцах
узел|sузл
узелок|sузелк
узник|A
узурпатор|A
узы|*genitive.sg=уз,*dative.sg=узам,*instrumental.sg=узами,*prepositional.sg=узах
уй|A
уйма|p
указатель|cm
укладчик|A
уклейка|A,*genitive.pl=уклеек,*accusative.pl=уклеек
укоризна|p
укр|A
украинец|A
украинка|A
улей|sуль
умелец|A
уменьшаемое|cm,*nominative.pl=уменьшаемые,*genitive.sg=уменьшаемого,*genitive.pl=уменьшаемых,*dative.sg=уменьшаемому,*dative.pl=уменьшаемым,*accusative.pl=уменьшаемые,*instrumental.sg=уменьшаемым,*instrumental.pl=уменьшаемыми,*prepositional.sg=уменьшаемом,*prepositional.pl=уменьшаемых
умерший|*genitive.sg=умершего,*dative.sg=умершему,*instrumental.sg=умершим,*prepositional.sg=умершем
умиленье|cm,sумилень,nя,S,*genitive.pl=умилений
умник|A
умница|A
умра|p
умывальня|*genitive.pl=умывален
умысел|sумысл
униформа|p
унтер|A
унтер-офицер|A
упадок|sупадк
управдом|A
управленец|A
управляющий|A,*genitive.sg=управляющего,*dative.sg=управляющему,*accusative.sg=управляющего,*instrumental.sg=управляющим,*prepositional.sg=управляющем
упряжь|cm,gи,dи,iью,lи,S0
упрямство|cm,sупрямств,nа,p
упырь|cm,iём,*genitive.sg=упырь,*genitive.pl=упыри,*dative.sg=упыря,*dative.pl=упырей
уранист|A
уретра|p
урка|A
урна|p
уровень|cm,sуровн
урод|A
уродина|A
уродство|cm,sуродств,nа,p
уроженец|A
ус|*genitive.sg=ус,*genitive.pl=усы,*dative.sg=уса,*dative.pl=усов
усадьба|*genitive.pl=усадеб
усилитель|cm
ускоритель|cm
усопший|A,*genitive.sg=усопшего,*dative.sg=усопшему,*accusative.sg=усопшего,*instrumental.sg=усопшим,*prepositional.sg=усопшем
уста|cm,*genitive.sg=уст,*dative.sg=устам,*instrumental.sg=устами,*prepositional.sg=устах
устроитель|cm,A
устройство|cm,sустройств,nа,p
устье|cm,sусть,nя,S,*genitive.pl=устий
устюжанин|sустюжан,nе,p,A,*genitive.sg=устюжанина,*dative.sg=устюжанину,*accusative.sg=устюжанина,*instrumental.sg=устюжанином,*prepositional.sg=устюжанине
утайка|*genitive.pl=утаек
утёнок|sутят,nа,p,A,*genitive.sg=утёнка,*dative.sg=утёнку,*accusative.sg=утёнка,*instrumental.sg=утёнком,*prepositional.sg=утёнке
утконос|A
уточка|A
утреня|*genitive.pl=утрень
утро|cm,sутр,nа,*genitive.pl=утер
ухажёр|A
ухо|cm,sуш,*genitive.sg=уха,*dative.sg=уху,*instrumental.sg=ухом,*prepositional.sg=ухе
ухогорлонос|A
уцелевший|A,*genitive.sg=уцелевшего,*dative.sg=уцелевшему,*accusative.sg=уцелевшего,*instrumental.sg=уцелевшим,*prepositional.sg=уцелевшем
участковый|A,*genitive.sg=участкового,*dative.sg=участковому,*accusative.sg=участкового,*instrumental.sg=участковым,*prepositional.sg=участковом
участник|A
участница|A
участок|sучастк
учащийся|cm,A,*genitive.sg=учащегося,*dative.sg=учащемуся,*accusative.sg=учащегося,*instrumental.sg=учащимся,*prepositional.sg=учащемся
ученик|A
ученица|A
училище|cm,sучилищ,nа,p
училка|A
учитель|cm,nя,A
учительская|cm,*nominative.pl=учительские,*genitive.sg=учительской,*genitive.pl=учительских,*dative.sg=учительской,*dative.pl=учительским,*accusative.sg=учительскую,*accusative.pl=учительские,*instrumental.sg=учительской,*instrumental.pl=учительскими,*prepositional.sg=учительской,*prepositional.pl=учительских
учредитель|cm,A
ущелье|cm,sущель,nя,S,*genitive.pl=ущелий
фабрикант|A
фаворит|A
фазан|A
фазенда|p
факелок|sфакелк
факельщик|A
факир|A
фальшь|cm,gи,dи,iью,lи,S0
фанат|A
фанатик|A
фараон|A
фарерский|*genitive.sg=фарерского,*dative.sg=фарерскому,*instrumental.sg=фарерским,*prepositional.sg=фарерском
фарёрский|*genitive.sg=фарёрского,*dative.sg=фарёрскому,*instrumental.sg=фарёрским,*prepositional.sg=фарёрском
фарисей|A
фарисейство|cm,sфарисейств,nа,p
фармаколог|A
фармацевт|A
фарцовщик|A
фаталист|A
фашист|A
фашистка|A
февраль|cm,iём
федералист|A
фекалии|*genitive.sg=фекалий,*dative.sg=фекалиям,*instrumental.sg=фекалиями,*prepositional.sg=фекалиях
фельдшер|nа,A
феминистка|A
фенек|A
феникс|A
феня|*genitive.pl=фень
феодал|A
ферма|p
фермер|A
фермерство|cm,sфермерств,nа,p
фестиваль|cm
фея|pй,A
фигляр|A
фигня|iёй,pей
фигурист|A
физиолог|A
физрук|A
филантроп|A
филин|A
филистимлянин|sфилистимлян,nе,p,A,*genitive.sg=филистимлянина,*dative.sg=филистимлянину,*accusative.sg=филистимлянина,*instrumental.sg=филистимлянином,*prepositional.sg=филистимлянине
филолог|A
философ|A
философастер|A
филуменист|A
финалист|A
финансист|A
финикиянин|sфиникиян,nе,p,A,*genitive.sg=финикиянина,*dative.sg=финикиянину,*accusative.sg=финикиянина,*instrumental.sg=финикиянином,*prepositional.sg=финикиянине
финн|A
финский|*nominative.sg=финского,*genitive.sg=финскому,*instrumental.sg=финским,*prepositional.sg=финском
фирма|p
фитиль|cm,iём
флажок|sфлажк
фламандский|*genitive.sg=фламандского,*dative.sg=фламандскому,*instrumental.sg=фламандским,*prepositional.sg=фламандском
фланёр|A
флегма|p
флейта|p
флибустьер|A
флигель|cm,nя
флотский|A,*genitive.sg=флотского,*dative.sg=флотскому,*accusative.sg=флотского,*instrumental.sg=флотским,*prepositional.sg=флотском
фокстерьер|A
фокусник|A
фонарище|cm,sфонарищ,nа,p
фонарщик|A
фонарщица|A
фонарь|cm,iём
фонограмма|p
фонолог|A
формалист|A
фотограф|A
фоторобот|A
фраер|nа,A
француженка|A
француз|A
французы|A,*genitive.sg=французов,*dative.sg=французам,*accusative.sg=французов,*instrumental.sg=французами,*prepositional.sg=французах
фриц|A
фронтовик|A
функционер|A
фураж|*instrumental.sg=фуражом
фурия|A
футболист|A
фухтель|cm
фюзеляж|*instrumental.sg=фюзеляжом
фюрер|A
хазарин|sхазар,p,A,*genitive.sg=хазарина,*dative.sg=хазарину,*accusative.sg=хазарина,*instrumental.sg=хазарином,*prepositional.sg=хазарине
хакер|A
халва|p
халиф|A
халтурщик|A
хам|A
хамелеон|A
хамство|cm,sхамств,nа,p
хан|A
хангыль|cm
ханжа|pей,A,*instrumental.sg=ханжой
ханство|cm,sханств,nа,p
харза|p,A
хариус|A
харьковчанин|sхарьковчан,nе,p,A,*genitive.sg=харьковчанина,*dative.sg=харьковчанину,*accusative.sg=харьковчанина,*instrumental.sg=харьковчанином,*prepositional.sg=харьковчанине
харя|*genitive.pl=харь
хач|A,*instrumental.sg=хачом
хачик|A
хвощ|*instrumental.sg=хвощом
хвоя|pй
хедхантер|A
хек|A
херня|iёй,pей
херувим|A
химера|A
химерообразные|cm,A,*genitive.sg=химерообразных,*dative.sg=химерообразным,*accusative.sg=химерообразных,*instrumental.sg=химерообразными,*prepositional.sg=химерообразных
химик|A
химикалии|*genitive.sg=химикалий,*dative.sg=химикалиям,*instrumental.sg=химикалиями,*prepositional.sg=химикалиях
хирург|A
хитрец|sхитрец,A,*genitive.pl=хитрецов,*accusative.pl=хитрецов,*instrumental.sg=хитрецом
хищник|A
хладобойня|*genitive.pl=хладобоен
хлебопекарня|sхлбопекарн,*nominative.sg=хлбопекарня
хлопец|A
хлопоты|*genitive.sg=хлопот,*dative.sg=хлопотам,*instrumental.sg=хлопотами,*prepositional.sg=хлопотах
хоббит|A
хоботок|sхоботк
ходатайство|cm,sходатайств,nа,p
ходжа|pей,A,*instrumental.sg=ходжой
ходуля|pей
хозяин|A,*nominative.pl=хозяева,*genitive.pl=хозяев,*dative.pl=хозяевам,*instrumental.pl=хозяевами,*prepositional.pl=хозяевах
хозяйка|A,*genitive.pl=хозяек,*accusative.pl=хозяек
хозяйство|cm,sхозяйств,nа,p
хоккеист|A
холодец|*genitive.pl=холодцов,*instrumental.sg=холодцом
холодная|cm,*nominative.pl=холодные,*genitive.sg=холодной,*genitive.pl=холодных,*dative.sg=холодной,*dative.pl=холодным,*accusative.sg=холодную,*accusative.pl=холодные,*instrumental.sg=холодной,*instrumental.pl=холодными,*prepositional.sg=холодной,*prepositional.pl=холодных
холоп|A
холостяк|A
холуй|iём,pёв,A
хорват|A
хорватка|A
хорватский|*nominative.sg=хорватского,*genitive.sg=хорватскому,*instrumental.sg=хорватским,*prepositional.sg=хорватском
хорда|p
хорёк|sхорьк,A
хореограф|A
хоромы|*genitive.sg=хором,*dative.sg=хоромам,*instrumental.sg=хоромами,*prepositional.sg=хоромах
хорь|cm,iём,A
хохма|p
хохол|sхохл
хохолок|sхохолк
храбрец|sхрабрец,A,*genitive.pl=храбрецов,*accusative.pl=храбрецов,*instrumental.sg=храбрецом
хранилище|cm,sхранилищ,nа,p
хранитель|cm,A
хребет|sхребт
христадельфианин|sхристадельфиан,nе,p,A,*genitive.sg=христадельфианина,*dative.sg=христадельфианину,*accusative.sg=христадельфианина,*instrumental.sg=христадельфианином,*prepositional.sg=христадельфианине
христианин|sхристиан,nе,p,A,*genitive.sg=христианина,*dative.sg=христианину,*accusative.sg=христианина,*instrumental.sg=христианином,*prepositional.sg=христианине
христианка|A
христианство|cm,sхристианств,nа,p
хрусталь|cm,iём
хрущ|A,*instrumental.sg=хрущом
хряк|A
хрящ|*instrumental.sg=хрящом
художество|cm,sхудожеств,nа,p
художник|A
художник-мультипликатор|sхудожникам-мультипликатор,A,*nominative.pl=художники-мультипликаторы,*genitive.sg=художника-мультипликатора,*genitive.pl=художников-мультипликаторов,*dative.sg=художнику-мультипликатору,*accusative.sg=художника-мультипликатора,*accusative.pl=художников-мультипликаторов,*instrumental.sg=художником-мультипликатором,*instrumental.pl=художниками-мультипликаторами,*prepositional.sg=художнике-мультипликаторе,*prepositional.pl=художниках-мультипликаторах
художница|A
худрук|A
хуесос|A
хуесосик|A
хуище|cm,sхуищ,p
хуйло|cm,sхуйл,nа,*genitive.pl=хуил
хуйня|iёй
хулиган|A
хулиганство|cm,sхулиганств,nа,p
хунвэйбин|A
хунта|p
хутор|nа
хуторянин|sхуторян,nе,p,A,*genitive.sg=хуторянина,*dative.sg=хуторянину,*accusative.sg=хуторянина,*instrumental.sg=хуторянином,*prepositional.sg=хуторянине
цапля|A,*genitive.pl=цапель,*accusative.pl=цапель
царевич|A
царевна|A,*genitive.pl=царевен,*accusative.pl=царевен
цареубийство|cm,sцареубийств,nа,p
цареубийца|p,A
царь|cm,iём,A
цветочек|sцветочк
целакант|A
целое|cm,*nominative.pl=целые,*genitive.sg=целого,*genitive.pl=целых,*dative.sg=целому,*dative.pl=целым,*accusative.pl=целые,*instrumental.sg=целым,*instrumental.pl=целыми,*prepositional.sg=целом,*prepositional.pl=целых
цензор|A
ценитель|cm,A
центавр|A
центрист|A
центурион|A
церка|p
церковь|cm,sцеркв,gи,dи,lи,*instrumental.sg=церковью
цесаревич|A
цикля|pей
цимбалы|*genitive.sg=цимбал,*dative.sg=цимбалам,*instrumental.sg=цимбалами,*prepositional.sg=цимбалах
циник|A
циноглоссовые|cm,A,*genitive.sg=циноглоссовых,*dative.sg=циноглоссовым,*accusative.sg=циноглоссовых,*instrumental.sg=циноглоссовыми,*prepositional.sg=циноглоссовых
циркуль|cm
цирюльник|A
цирюльня|*genitive.pl=цирюлен
цистерна|p
цитоплазма|p
цитра|p
цифра|p
цуцик|A
цыган|nе,p,A
цыганёнок|sцыганят,nа,p,A,*genitive.sg=цыганёнка,*dative.sg=цыганёнку,*accusative.sg=цыганёнка,*instrumental.sg=цыганёнком,*prepositional.sg=цыганёнке
цыганка|A
цыплёнок|sцыплят,nа,p,A,*genitive.sg=цыплёнка,*dative.sg=цыплёнку,*accusative.sg=цыплёнка,*instrumental.sg=цыплёнком,*prepositional.sg=цыплёнке
цыплёночек|cf,sцыплятк,A,*genitive.sg=цыплёночка,*dative.sg=цыплёночку,*accusative.sg=цыплёночка,*instrumental.sg=цыплёночком,*prepositional.sg=цыплёночке
цыпочка|A
чабан|A
чабрец|sчабрец,*genitive.pl=чабрецов,*instrumental.sg=чабрецом
чадра|p
чаевые|cm,*genitive.sg=чаевых,*dative.sg=чаевым,*instrumental.sg=чаевыми,*prepositional.sg=чаевых
чайная|cm,*nominative.pl=чайные,*genitive.sg=чайной,*genitive.pl=чайных,*dative.sg=чайной,*dative.pl=чайным,*accusative.sg=чайную,*accusative.pl=чайные,*instrumental.sg=чайной,*instrumental.pl=чайными,*prepositional.sg=чайной,*prepositional.pl=чайных
чакра|p
чалма|p
чародейка|A,*genitive.pl=чародеек,*accusative.pl=чародеек
часовой|A,*genitive.sg=часового,*dative.sg=часовому,*accusative.sg=часового,*instrumental.sg=часовым,*prepositional.sg=часовом
частник|A
частное|cm,*nominative.pl=частные,*genitive.sg=частного,*genitive.pl=частных,*dative.sg=частному,*dative.pl=частным,*accusative.pl=частные,*instrumental.sg=частным,*instrumental.pl=частными,*prepositional.sg=частном,*prepositional.pl=частных
чеболь|cm
чекист|A
чёлн|sчелн
человеконенавистник|A
человеконенавистничество|cm,sчеловеконенавистничеств,nа,p
человечек|sчеловечк,A
челядин|A
чемпионка|A
черва|p
червь|cm,iём
червяк|A
черевичек|sчеревичк
черемша|pей,*instrumental.sg=черемшой
черепашка|A
черепок|sчерепк
чернобыль|cm
черногорец|A
черногорка|A
черножопый|*nominative.sg=черножопого,*genitive.sg=черножопому,*instrumental.sg=черножопым,*prepositional.sg=черножопом
чернокнижник|A
чёрт|A,*nominative.pl=черти,*genitive.pl=чертей,*dative.pl=чертям,*instrumental.pl=чертями,*prepositional.pl=чертях
чертёж|sчертеж,*instrumental.sg=чертежом
чертёнок|sчертенят,nа,p,A,*genitive.sg=чертёнка,*dative.sg=чертёнку,*accusative.sg=чертёнка,*instrumental.sg=чертёнком,*prepositional.sg=чертёнке
чертяга|A
чертяка|A
чёсанок|cn,sчёсанк,nы
четвереньки|*genitive.sg=четверенек,*dative.sg=четверенькам,*instrumental.sg=четвереньками,*prepositional.sg=четвереньках
четвёртая|cm,*nominative.pl=четвёртые,*genitive.sg=четвёртой,*genitive.pl=четвёртых,*dative.sg=четвёртой,*dative.pl=четвёртым,*accusative.sg=четвёртую,*accusative.pl=четвёртые,*instrumental.sg=четвёртой,*instrumental.pl=четвёртыми,*prepositional.sg=четвёртой,*prepositional.pl=четвёртых
чехол|sчехл
чеченец|A
чеченка|A
чешский|*nominative.sg=чешского,*genitive.sg=чешскому,*instrumental.sg=чешским,*prepositional.sg=чешском
чешуеног|A
чешуя|iёй,pй
чжуинь|cm
чибис|A
чиж|A,*instrumental.sg=чижом
чизель|cm
чилиец|A
чиновница|A
чиновничество|cm,sчиновничеств,nа,p
чинодрал|A
чинуша|A
чир|A
чирва|p
числитель|cm
числительное|cm,*nominative.pl=числительные,*genitive.sg=числительного,*genitive.pl=числительных,*dative.sg=числительному,*dative.pl=числительным,*accusative.pl=числительные,*instrumental.sg=числительным,*instrumental.pl=числительными,*prepositional.sg=числительном,*prepositional.pl=числительных
чистилище|cm,sчистилищ,nа,p
читальня|*genitive.pl=читален
член-корреспондент|sчленам-корреспондент,A,*nominative.pl=члены-корреспонденты,*genitive.sg=члена-корреспондента,*genitive.pl=членов-корреспондентов,*dative.sg=члену-корреспонденту,*accusative.sg=члена-корреспондента,*accusative.pl=членов-корреспондентов,*instrumental.sg=членом-корреспондентом,*instrumental.pl=членами-корреспондентами,*prepositional.sg=члене-корреспонденте,*prepositional.pl=членах-корреспондентах
членистоногое|A,*nominative.pl=членистоногие,*genitive.sg=членистоногого,*genitive.pl=членистоногих,*dative.sg=членистоногому,*dative.pl=членистоногим,*accusative.pl=членистоногих,*instrumental.sg=членистоногим,*instrumental.pl=членистоногими,*prepositional.sg=членистоногом,*prepositional.pl=членистоногих
членодевка|A
членство|cm,sчленств,nа,p
чорт|sчерт,pей,S,A,*genitive.sg=чорта,*dative.sg=чорту,*accusative.sg=чорта,*instrumental.sg=чортом,*prepositional.sg=чорте
чревовещатель|cm,A
чревоугодник|A
чтец|sчтец,A,*genitive.pl=чтецов,*accusative.pl=чтецов,*instrumental.sg=чтецом
чувак|A
чуваш|A,*instrumental.sg=чувашом
чувиха|A
чувствилище|cm,sчувствилищ,nа,p
чувство|cm,sчувств,nа,p
чудак|A
чудище|cm,sчудищ,nа,p,A,*accusative.sg=чудище
чудо-юдо|cm,sчудам-юд,*nominative.pl=чуда-юда,*genitive.sg=чуда-юда,*genitive.pl=чуд-юд,*dative.sg=чуду-юду,*accusative.pl=чуда-юда,*instrumental.sg=чудом-юдом,*instrumental.pl=чудами-юдами,*prepositional.sg=чуде-юде,*prepositional.pl=чудах-юдах
чудотворец|A
чужак|A
чужанин|sчужан,nе,p,A,*genitive.sg=чужанина,*dative.sg=чужанину,*accusative.sg=чужанина,*instrumental.sg=чужанином,*prepositional.sg=чужанине
чужеземец|A
чукча|pей,A
чуня|pей
чутьё|iём
чухна|A
чухонец|A
шабёр|sшабер,A
шавка|A
шажок|sшажк
шайба|p
шайка|*genitive.pl=шаек
шайтан|A
шакал|A
шалава|A
шалаш|*instrumental.sg=шалашом
шалун|A
шаман|A
шампанское|cm,*nominative.pl=шампанские,*genitive.sg=шампанского,*genitive.pl=шампанских,*dative.sg=шампанскому,*dative.pl=шампанским,*instrumental.sg=шампанским,*instrumental.pl=шампанскими,*prepositional.sg=шампанском,*prepositional.pl=шампанских
шампунь|cm
шантаж|*instrumental.sg=шантажом
шантрапа|A
шапка-невидимка|cm,sшапкам-невидимк,*nominative.pl=шапки-невидимки,*genitive.sg=шапки-невидимки,*genitive.pl=шапок-невидимок,*dative.sg=шапке-невидимке,*accusative.sg=шапку-невидимку,*accusative.pl=шапки-невидимки,*instrumental.sg=шапкой-невидимкой,*instrumental.pl=шапками-невидимками,*prepositional.sg=шапке-невидимке,*prepositional.pl=шапках-невидимках
шапка-ушанка|cm,sшапкам-ушанк,*nominative.pl=шапки-ушанки,*genitive.sg=шапки-ушанки,*genitive.pl=шапок-ушанок,*dative.sg=шапке-ушанке,*accusative.sg=шапку-ушанку,*accusative.pl=шапки-ушанки,*instrumental.sg=шапкой-ушанкой,*instrumental.pl=шапками-ушанками,*prepositional.sg=шапке-ушанке,*prepositional.pl=шапках-ушанках
шарлатан|A
шаровары|*genitive.sg=шаровар,*dative.sg=шароварам,*instrumental.sg=шароварами,*prepositional.sg=шароварах
шатёр|sшатр
шафер|nа,A
шахматист|A
шахта|p
шахтёр|A
шваб|A
швабра|p
швед|A
шведка|A
шведский|*genitive.sg=шведского,*dative.sg=шведскому,*instrumental.sg=шведским,*prepositional.sg=шведском
швейка|A,*genitive.pl=швеек,*accusative.pl=швеек
швейцар|A
швейцарец|A
швейцарка|A
швея|iёй,pй,A
шейка|*genitive.pl=шеек
шейх|A
шекель|cm
шёлк|sшелк,nа,*genitive.sg=шёлка,*dative.sg=шёлку,*instrumental.sg=шёлком,*prepositional.sg=шёлке
шелкопряд|A
шёлкопрядильня|*genitive.pl=шёлкопрядилен
шенкель|cm,nя
шеншель|cm,nя
шепотня|iёй,pей
шеренга|p
шериф|A
шерстобойня|*genitive.pl=шерстобоен
шеф|A
шеф-повар|nа,A
шея|pй
шибздик|A
шизик|A
шизофреник|A
шилоклювка|A
шиншилла|p,A
ширма|p
шитьё|iём
шихта|p
шиш|*instrumental.sg=шишом
шкет|A
шкипер|A
школьник|A
школьница|A
школяр|A
шлёпанцы|*genitive.sg=шлёпанцев,*dative.sg=шлёпанцам,*instrumental.sg=шлёпанцами,*prepositional.sg=шлёпанцах
шлепок|sшлепк
шляхта|p
шмель|cm,iём,A
шмотки|*genitive.sg=шмоток,*dative.sg=шмоткам,*instrumental.sg=шмотками,*prepositional.sg=шмотках
шнауцер|A
шницель|cm
шнобель|cm
шнурок|sшнурк
шобла|p
шов|sшв
шоры|*genitive.sg=шор,*dative.sg=шорам,*instrumental.sg=шорами,*prepositional.sg=шорах
шотландец|A
шофёр|A
шпатель|cm
шпахтель|cm
шпиль|cm
шпилька|*genitive.pl=шпилек
шпиндель|cm
шпион|A
штабель|cm,nя
штабной|A,*genitive.sg=штабного,*dative.sg=штабному,*accusative.sg=штабного,*instrumental.sg=штабным,*prepositional.sg=штабном
штабс-капитан|A
штанга|p
штангенциркуль|cm
штангист|A
штанишки|*genitive.sg=штанишек,*dative.sg=штанишкам,*instrumental.sg=штанишками,*prepositional.sg=штанишках
штатский|A,*genitive.sg=штатского,*dative.sg=штатскому,*accusative.sg=штатского,*instrumental.sg=штатским,*prepositional.sg=штатском
штатское|cm,*nominative.pl=штатские,*genitive.sg=штатского,*genitive.pl=штатских,*dative.sg=штатскому,*dative.pl=штатским,*accusative.pl=штатские,*instrumental.sg=штатским,*instrumental.pl=штатскими,*prepositional.sg=штатском,*prepositional.pl=штатских
штемпель|cm,nя
штепсель|cm,nя
штихель|cm
штольня|*genitive.pl=штолен
штрейкбрехер|A
штурман|A
штуцер|nа
штырь|cm,iём
шулер|nа,A
шурин|sшурь,nя,pёв,S,A,*genitive.sg=шурина,*dative.sg=шурину,*accusative.sg=шурина,*instrumental.sg=шурином,*prepositional.sg=шурине
шутник|A
шуянин|sшуян,nе,p,A,*genitive.sg=шуянина,*dative.sg=шуянину,*accusative.sg=шуянина,*instrumental.sg=шуянином,*prepositional.sg=шуянине
щеглёнок|sщеглят,nа,p,A,*genitive.sg=щеглёнка,*dative.sg=щеглёнку,*accusative.sg=щеглёнка,*instrumental.sg=щеглёнком,*prepositional.sg=щеглёнке
щегол|A
щёголь|cm
щека|cm,sщек,gи,dе,iой,*nominative.pl=щёки,*genitive.pl=щёк,*accusative.sg=щёку
щелкунчик|A
щёлочь|cm,gи,dи,iью,lи,*genitive.pl=щелочей,*dative.pl=щелочам,*instrumental.pl=щелочами,*prepositional.pl=щелочах
щелчок|sщелчк
щеночек|sщеночк,A
щепа|gа,*genitive.pl=щепы,*dative.sg=щепы,*dative.pl=щеп
щипач|A,*instrumental.sg=щипачом
щипчики|*genitive.sg=щипчиков,*dative.sg=щипчикам,*instrumental.sg=щипчиками,*prepositional.sg=щипчиках
щит|*genitive.sg=щит,*genitive.pl=щиты,*dative.sg=щита,*dative.pl=щитов
щитовая|cm,*nominative.pl=щитовые,*genitive.sg=щитовой,*genitive.pl=щитовых,*dative.sg=щитовой,*dative.pl=щитовым,*accusative.sg=щитовую,*accusative.pl=щитовые,*instrumental.sg=щитовой,*instrumental.pl=щитовыми,*prepositional.sg=щитовой,*prepositional.pl=щитовых
щиток|sщитк
щупальце|cm,sщупальц,nа,*genitive.pl=щупалец
эгоист|A
эдил|A
эколог|A
экономист|A
экскурсовод|A
экспедитор|A
экспериментатор|A
эксперт|A
экспортёр|A
экстрасенс|A
экстремист|A
электрик|A
электромобиль|cm
электропоезд|nа
эль|cm
эльф|A
эмигрант|A
эмир|A
эмитент|A
эндемик|A
эндрюсарх|A
эндшпиль|cm
энергоноситель|cm
энтузиаст|A
эпиграмма|p
эпопея|pй
эрдельтерьер|A
эрзянин|sэрзян,nе,p,A,*genitive.sg=эрзянина,*dative.sg=эрзянину,*accusative.sg=эрзянина,*instrumental.sg=эрзянином,*prepositional.sg=эрзянине
эрцгерцог|A
эрцгерцогиня|A,*genitive.pl=эрцгерцогинь,*accusative.pl=эрцгерцогинь
эсер|A
эскадрилья|*genitive.pl=эскадрилий
эстонец|A
эстонка|A
эстонский|*genitive.sg=эстонского,*dative.sg=эстонскому,*instrumental.sg=эстонским,*prepositional.sg=эстонском
эсэсовец|A
этаж|*instrumental.sg=этажом
этнолог|A
этруск|A
юань|cm
юбиляр|A
ювелир|A
юг|nа
югослав|A
юдофоб|A
южанин|sюжан,nе,p,A,*genitive.sg=южанина,*dative.sg=южанину,*accusative.sg=южанина,*instrumental.sg=южанином,*prepositional.sg=южанине
южнокореец|A
южносуданец|A
юзверь|cm,A
юзер|A
юморист|A
юнга|p,A
юнец|A,*genitive.pl=юнцов,*accusative.pl=юнцов,*instrumental.sg=юнцом
юнкер|nа
юноша|pей
юрист|A
юрта|p
яблоко|cm,sяблок,p
яблоня|*genitive.pl=яблонь
яблочко|nы
ягнёнок|sягнят,nа,p,A,*genitive.sg=ягнёнка,*dative.sg=ягнёнку,*accusative.sg=ягнёнка,*instrumental.sg=ягнёнком,*prepositional.sg=ягнёнке
ягуар|A
ядро|cm,sядр,nа,*genitive.pl=ядер
язва|p
языковед|A
язычество|cm,sязычеств,nа,p
язычник|A
язычок|sязычк
язь|cm,iём,A
яичко|nы
як|A
якорь|cm,nя
ямча|*instrumental.sg=ямчой
ямщик|A
январь|cm,iём
янтарь|cm,iём
янычар|p,A
японец|A
японка|A
японцы|A,*genitive.sg=японцев,*dative.sg=японцам,*accusative.sg=японцев,*instrumental.sg=японцами,*prepositional.sg=японцах
япошка|A
ярл|A
ярмо|cf,iом,*genitive.sg=ярмо,*genitive.pl=ярма,*dative.sg=ярма,*dative.pl=ярм
ясень|cm
яства|cm,*genitive.sg=яств,*dative.sg=яствам,*instrumental.sg=яствами,*prepositional.sg=яствах
ястреб|nа
яхта|p
яхтсмен|A
ячейка|*genitive.pl=ячеек
ячмень|cm,iём
яшма|p
ящер|A
ящерка|p,A
ящичек|sящичк
`;

const CLASSES: Record<string, RuClass> = {
  m: "masculine",
  f: "feminine-a",
  n: "neuter",
  k: "feminine-soft",
};

function parse(spec: string): RuStemFlags {
  const flags: RuStemFlags = {};
  const forms: Record<string, string> = {};
  for (const part of spec.split(",")) {
    if (part.startsWith("*")) {
      const [cell, form] = part.slice(1).split("=") as [string, string];
      forms[cell] = form;
      continue;
    }
    const code = part[0] as string;
    const value = part.slice(1);
    if (code === "A") flags.animate = true;
    else if (code === "S") flags.soft = value !== "0";
    else if (code === "c") {
      const plClass = CLASSES[value];
      if (plClass !== undefined) flags.class = plClass;
    }
    else if (code === "s") flags.stem = value;
    else if (code === "g") flags.genSg = value;
    else if (code === "d") flags.datSg = value;
    else if (code === "i") flags.insSg = value;
    else if (code === "l") flags.prepSg = value;
    else if (code === "n") flags.nomPl = value;
    else if (code === "p") flags.genPl = value;
  }
  if (Object.keys(forms).length > 0) flags.forms = forms;
  return flags;
}

/** What each noun's paradigm does that the rules do not predict. */
export const STEM_FLAGS: ReadonlyMap<string, RuStemFlags> = new Map(
  STEM_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => {
      const [lemma, spec] = line.split("|") as [string, string];
      return [lemma, parse(spec)] as const;
    }),
);
